(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InViewObserver = function () {
	function InViewObserver() {
		_classCallCheck(this, InViewObserver);
	}

	_createClass(InViewObserver, null, [{
		key: "ElementIsInView",
		value: function ElementIsInView(element, inViewCallback, outOfViewCallback) {
			new IntersectionObserver(function (entries, observer) {
				entries.forEach(function (entry) {
					if (entry.intersectionRatio > 0) {
						if (inViewCallback) {
							inViewCallback();
						}
					} else {
						if (outOfViewCallback) {
							outOfViewCallback();
						}
					}
				});
			}).observe(element);
		}
	}]);

	return InViewObserver;
}();

exports.default = InViewObserver;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });
var TrapFocus = /** @class */function () {
	function TrapFocus() {}

	TrapFocus.startTrapFocus = function (parent) {
		TrapFocus.parent = parent;
		TrapFocus.focusedElBeforeOpen = document.activeElement;
		TrapFocus.focusElements = TrapFocus.parent.querySelectorAll(TrapFocus.focusElementsSelector);
		TrapFocus.firstFocusableEl = TrapFocus.focusElements[0];
		TrapFocus.lastFocusableEl = TrapFocus.focusElements[TrapFocus.focusElements.length - 1];
		document.addEventListener('keydown', TrapFocus.handleKeyDown);
		document.addEventListener('keyup', TrapFocus.handleKeyUp);
		// Timeout to set the focus after the click is done. 1ms isn't enough apparently
		setTimeout(function () {
			TrapFocus.firstFocusableEl.focus();
		}, 30);
	};
	TrapFocus.setFocus = function (element) {
		setTimeout(function () {
			element.focus();
		}, 31);
	};
	TrapFocus.endTrapFocus = function () {
		document.removeEventListener('keydown', TrapFocus.handleKeyDown);
		document.removeEventListener('keyup', TrapFocus.handleKeyUp);
		if (TrapFocus.focusedElBeforeOpen instanceof HTMLElement) {
			TrapFocus.focusedElBeforeOpen.focus();
		}
	};
	TrapFocus.handleKeyDown = function (e) {
		if (e.key === 'Tab') {
			if (TrapFocus.focusElements.length === 1) {
				e.preventDefault();
				return;
			}
			if (e.shiftKey) {
				if (document.activeElement === TrapFocus.firstFocusableEl) {
					e.preventDefault();
					TrapFocus.lastFocusableEl.focus();
				}
			} else if (document.activeElement === TrapFocus.lastFocusableEl) {
				e.preventDefault();
				TrapFocus.firstFocusableEl.focus();
			}
		}
	};
	TrapFocus.handleKeyUp = function () {
		if (!TrapFocus.parent.contains(document.activeElement)) {
			TrapFocus.firstFocusableEl.focus();
		}
	};
	TrapFocus.focusElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';
	TrapFocus.isFocusTrapped = false;
	TrapFocus.radioGroupName = '';
	return TrapFocus;
}();
exports.default = TrapFocus;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = fix;
function fix() {
	Array.from(document.querySelectorAll('[data-ie-background]')).forEach(function (elem) {
		var image = elem.querySelector('img');
		elem.style.backgroundImage = 'url(\'' + image.src + '\')';
	});
}

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Indicator = function () {
	function Indicator(sections, indicator) {
		var _this = this;

		_classCallCheck(this, Indicator);

		this.indicator = indicator;
		this.sections = Array.from(sections, function (elem) {
			return {
				elem: elem,
				name: elem.dataset.section
			};
		});

		this.indicator.innerHTML = this.sections.map(function (_ref, ix) {
			var name = _ref.name;
			return '<div class="lrv-indicator__item" data-indicator="section-' + ix + '">' + name + '</div>';
		}).reduce(function (acc, curr) {
			return acc + curr;
		}, '<div class="lrv-indicator__dot"></div>');
		this.sections = this.sections.map(function (_ref2, ix) {
			var name = _ref2.name,
			    elem = _ref2.elem;
			return {
				name: name,
				elem: elem,
				indicatorElem: indicator.querySelector('[data-indicator="section-' + ix + '"]')
			};
		});
		this.redDot = this.indicator.querySelector('.lrv-indicator__dot');
		window.addEventListener('scroll', function (ev) {
			return _this.onScroll(ev);
		}, {
			passive: true
		});
	}

	_createClass(Indicator, [{
		key: 'onScroll',
		value: function onScroll() {
			var _this2 = this;

			// These two lines force an element repaint, which solves clipping issues in Edge and Safari.
			// Surprisingly, it works fine in IE without this fix...
			this.indicator.style.width = '100%';
			setTimeout(function () {
				return _this2.indicator.style.width = '';
			}, 0);

			var activeSection = this.sections.find(function (_ref3) {
				var elem = _ref3.elem;
				return elem.offsetTop + elem.getBoundingClientRect().height / 2 > (window.scrollY || window.pageYOffset);
			});
			if (activeSection) {
				this.sections.forEach(function (_ref4) {
					var indicatorElem = _ref4.indicatorElem;
					return indicatorElem.classList.toggle('active', false);
				});
				activeSection.indicatorElem.classList.toggle('active', true);
				this.redDot.style.transform = 'translateY(' + activeSection.indicatorElem.offsetTop + 'px)';
			}
		}
	}]);

	return Indicator;
}();

exports.default = Indicator;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = init;

var _popup = require('../Modules/_popup');

var _popup2 = _interopRequireDefault(_popup);

var _tabsNavigation = require('../Modules/_tabs-navigation');

var _tabsNavigation2 = _interopRequireDefault(_tabsNavigation);

var _testFeature = require('../Partials/_test-feature.js');

var _testFeature2 = _interopRequireDefault(_testFeature);

var _testIe = require('../Partials/_test-ie');

var _testIe2 = _interopRequireDefault(_testIe);

var _ieImageFix = require('./_ie-image-fix');

var _ieImageFix2 = _interopRequireDefault(_ieImageFix);

var _indicator = require('./_indicator');

var _indicator2 = _interopRequireDefault(_indicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function init() {
	var ieVersion = (0, _testIe2.default)();
	_testFeature2.default.setClass(!!ieVersion, 'ie');
	if (ieVersion) {
		(0, _ieImageFix2.default)();
	}
	var popupTriggers = Array.from(document.querySelectorAll('[data-trigger-popup]')).reduce(function (acc, elem) {
		var accIndex = acc.findIndex(function (list) {
			return list.some(function (trigger) {
				return trigger.elem.dataset.triggerPopup === elem.dataset.triggerPopup;
			});
		});
		if (accIndex === -1) return [].concat(_toConsumableArray(acc), [[{ showPopup: elem.hasAttribute('data-popup-open'), elem: elem }]]);else {
			acc[accIndex].push({
				showPopup: elem.hasAttribute('data-popup-open'),
				elem: elem
			});
			return acc;
		}
	}, []);

	popupTriggers.forEach(function (triggers) {
		return new _popup2.default(document.querySelector('[' + triggers[0].elem.dataset.triggerPopup + ']'), triggers);
	});

	new _tabsNavigation2.default(document.querySelector('[data-tabs="steps"]'), document.querySelector('[data-tabs-content="steps"]'));
	var sections = document.querySelectorAll('[data-section]');
	Array.from(document.querySelectorAll('[data-lrv-indicator]'), function (elem) {
		return new _indicator2.default(sections, elem);
	});
}

},{"../Modules/_popup":26,"../Modules/_tabs-navigation":32,"../Partials/_test-feature.js":54,"../Partials/_test-ie":55,"./_ie-image-fix":3,"./_indicator":4}],6:[function(require,module,exports){
'use strict';

var _stickyfill = require('../Vendor/_stickyfill.js');

var _stickyfill2 = _interopRequireDefault(_stickyfill);

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _collapsible = require('../Partials/_collapsible.js');

var _collapsible2 = _interopRequireDefault(_collapsible);

var _testFeature = require('../Partials/_test-feature.js');

var _testFeature2 = _interopRequireDefault(_testFeature);

var _viewportstateWatcher = require('../Partials/_viewportstate-watcher.js');

var _viewportstateWatcher2 = _interopRequireDefault(_viewportstateWatcher);

var _printButton = require('../Partials/_print-button.js');

var _printButton2 = _interopRequireDefault(_printButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
	var supportsSticky = _testFeature2.default.test('position', 'sticky');
	_testFeature2.default.setClass(supportsSticky, 'csssticky');

	// Run through article blocks
	var articles = Array.from(document.querySelectorAll('.main__article'));
	articles.forEach(function (article) {
		// Run through law sections
		var lawSections = Array.from(document.querySelectorAll('.law-section'));
		lawSections.forEach(function (section) {
			// Run through cards
			var cards = Array.from(section.querySelectorAll('.ordered-card-list__card'));
			cards.forEach(function (card) {
				// Collapsibles (up till xlarge)
				var collapsibles = Array.from(card.querySelectorAll('.js-collapsible'));
				collapsibles.forEach(function (collapsible) {
					// Until xlarge, collapsibles
					new _collapsible2.default(collapsible, ['all'], false);

					// After xlarge, single selection 'tabs'
					var id = collapsible.querySelector('.js-collapsible__body').id;
					var trigger = card.querySelector('.ordered-card-list__triggers [href="#' + id + '"]');
					new _collapsible2.default(collapsible, ['all'], trigger, ['xlarge']);

					// TODO: don't use collapsibles for this tab behaviour and make sure that the collapsibles initialization only applies to small, smallPlus, medium and large

					// Contextual print buttons
					var button = collapsible.querySelector('.js-print-button');
					if (button) new _printButton2.default(button, [collapsible, card, section, article]);
				});

				// Sticky polyfill for card counter
				//const counter = card.querySelector('.ordered-card-list__counter');
				//if (counter) Stickyfill.add(counter);

				// Sticky polyfill for 'tabs'
				var tabs = card.querySelector('.js-collapsible__triggers');
				if (tabs) {
					_viewportstateWatcher2.default.watch(['xlarge'], function () {
						return _stickyfill2.default.add(tabs);
					}, function () {
						return _stickyfill2.default.remove(tabs);
					});
				}
			});
		});
	});
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_collapsible.js":37,"../Partials/_print-button.js":48,"../Partials/_test-feature.js":54,"../Partials/_viewportstate-watcher.js":58,"../Vendor/_stickyfill.js":59,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],7:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**

 * A singleton communication to iframe child

 *

 * @class ChatHeader

 */

var ChatHeader = function () {
	function ChatHeader() {
		var _this = this;

		_classCallCheck(this, ChatHeader);

		this._chatHeaderContainer = document.querySelector('[data-attribute="chat-header-container"]');
		this._iframeWindow = document.querySelector('[data-attribute="iframe-window"]');
		this._closeButton = document.querySelector('[data-attribute="chat-header-close-button"]');

		this._isCollapsed = null;
		this._viewportH = document.documentElement.clientHeight;
		this._pageHeader = document.getElementById('page-header');
		this._pageHeaderH = this._pageHeader.offsetHeight;
		this._chatHeaderH = this._viewportH - this._pageHeaderH + 'px';

		this._focusHandler = function () {
			_this._hide();
		};

		this._iframeMessageHandler = function (e) {
			if (e.data === '' || typeof e.data !== 'string') return;
			var data = JSON.parse(e.data);
			if (data.expand !== true && _this._isCollapsed !== true) return;

			if (data.closeEvent === true) {
				_this._handleClick();
				return;
			}

			_this._isCollapsed = data.expand;
			if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0) {
				_this._scrollHandler(0);
			} else {
				_this._show();
			}
		};

		this._handleClick = function () {
			if (_this._isCollapsed === true) {
				_this._hide();
			}
		};

		// Deal with escape key
		this._closeOnEscape = function (e) {
			if (e.key === 'Escape' || e.key === 'Esc') {
				if (_this._isCollapsed === true) {
					_this._handleClick();
				}
			}
		};

		var timer = void 0;
		this._resizeHandler = function () {
			clearTimeout(timer);
			timer = setTimeout(function () {
				return _this._resize();
			}, 50);
		};

		this._init();
	}

	// Set attributes and event handlers


	_createClass(ChatHeader, [{
		key: '_init',
		value: function _init() {
			window.addEventListener('message', this._iframeMessageHandler);
			this._closeButton.addEventListener('click', this._handleClick);
			window.addEventListener('resize', this._resizeHandler);
			window.addEventListener('orientationchange', this._resizeHandler);

			document.body.addEventListener('keyup', this._closeOnEscape);
		}

		// Show the panel

	}, {
		key: '_show',
		value: function _show() {
			document.body.classList.add('has-chat-overlay');
			this._chatHeaderContainer.style.height = this._chatHeaderH;
			this._closeButton.setAttribute('aria-hidden', 'false');
			var message = JSON.stringify({
				animationFinished: true
			});
			this._iframeWindow.contentWindow.postMessage(message, '*');

			document.body.addEventListener('focus', this._focusHandler, true);
		}
		// Hide the panel

	}, {
		key: '_hide',
		value: function _hide() {
			this._chatHeaderContainer.style.height = null;
			this._closeButton.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('has-chat-overlay');
			this._isCollapsed = null;
			this._chatHeaderContainer.focus();
			var message = JSON.stringify({
				reset: true
			});
			this._iframeWindow.contentWindow.postMessage(message, '*');

			document.body.removeEventListener('focus', this._focusHandler, true);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			this._viewportH = document.documentElement.clientHeight;
			this._pageHeaderH = this._pageHeader.offsetHeight;
			this._chatHeaderH = this._viewportH - this._pageHeaderH + 'px';

			if (this._isCollapsed === true) {
				this._chatHeaderContainer.style.height = this._chatHeaderH;
			}
		}
	}, {
		key: '_scrollHandler',
		value: function _scrollHandler(offset) {
			var _this2 = this;

			var fixedOffset = offset.toFixed(),
			    onScroll = function onScroll() {
				if (window.pageYOffset.toFixed() === fixedOffset) {
					window.removeEventListener('scroll', onScroll);
					_this2._show();
				}
			};
			window.addEventListener('scroll', onScroll);
			window.scrollTo({
				top: offset,
				behavior: 'smooth'
			});
		}
	}]);

	return ChatHeader;
}();

var init = function init(e) {
	// Create an instance on DOM ready
	if (document.querySelector('[data-attribute="chat-header-container"]') !== null) {
		var chatHeader = new ChatHeader();
	}
};

document.addEventListener('DOMContentLoaded', init, {
	once: true
});

},{}],8:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A singleton showing/hiding the chatbot
 *
 * @class Chat
 */
var Chat = function () {
	function Chat() {
		var _this = this;

		_classCallCheck(this, Chat);

		this._chatContainer = document.querySelector('#rdw-chat');
		this._chatWindow = document.querySelector('#chat__window');
		this._chatBar = document.querySelector('#chat-bar');
		this._chatBarHint = document.querySelector('#chat-bar__sr-hint');
		this._openHintText = this._chatBar.getAttribute('data-open-hint');
		this._closeHintText = this._chatBar.getAttribute('data-close-hint');
		this._chatButton = document.getElementById('chat-button');
		this._iframe = document.getElementById('chat__iframe');
		this._startTime = new Date(); // start time of this script

		// Lottie animations
		this._barAvatarIntroAnimation = null;
		this._barAvatarLoopAnimation = null;
		this._btnAvatarIntroAnimation = null;
		this._btnAvatarLoopAnimation = null;

		// elements for avatar animations
		this._barAvatarIntroElm = document.getElementById('chat-bar__avatar-intro');
		this._barAvatarLoopElm = document.getElementById('chat-bar__avatar-loop');
		this._btnAvatarIntroElm = document.getElementById('chat-button__avatar-intro');
		this._btnAvatarLoopElm = document.getElementById('chat-button__avatar-loop');

		// Deal with escape key
		this._closeOnEscape = function (e) {
			if (e.key === 'Escape' || e.key === 'Esc') {
				_this._hideChat();
			}
		};
		this._init();
	}

	// Set attributes and event handlers


	_createClass(Chat, [{
		key: '_init',
		value: function _init() {
			var _this2 = this;

			this._chatBar.addEventListener('click', function () {
				_this2._toggle();
			});
			this._chatButton.addEventListener('click', function () {
				_this2._toggle();
			});
			document.body.addEventListener('keyup', this._closeOnEscape);

			this._iframe.addEventListener('load', function () {
				// do we need to do something here?
			});

			if (document.querySelector('.feedback__link') !== null) {
				document.body.classList.add('chat-has-feedback-button');
			}

			this._initAnimations();
		}

		// Toggle item

	}, {
		key: '_toggle',
		value: function _toggle() {
			if (this._chatWindow.classList.contains('is-expanded')) {
				this._hideChat();
			} else {
				this._showChat();
			}
		}

		// Show chat

	}, {
		key: '_showChat',
		value: function _showChat() {
			document.body.classList.add('has-chat-overlay');
			this._chatContainer.classList.add('js-window-is-initialized', 'js-window-is-initialized-mobile'); // prevent initializing animations from continuing/starting
			this._chatBar.setAttribute('aria-expanded', 'true');
			this._chatBar.setAttribute('title', this._closeHintText);
			this._chatBarHint.textContent = this._closeHintText;
			this._chatWindow.setAttribute('aria-hidden', 'false');
			this._chatWindow.classList.add('is-expanded');
			this._iframe.setAttribute('tabindex', 0); // make accessible with tabs
			document.addEventListener('keyup', this._restrictTabToChat);

			if (typeof dataLayer !== 'undefined') {
				dataLayer.push({
					event: 'Chatbot Activiteit',
					eventAction: 'Chatsessie Gestart',
					eventLabel: window.location.pathname
				});
			}
		}

		// Hide the panel

	}, {
		key: '_hideChat',
		value: function _hideChat() {
			document.body.classList.remove('has-chat-overlay');
			this._chatBar.setAttribute('aria-expanded', 'false');
			this._chatBar.setAttribute('title', this._openHintText);
			this._chatBarHint.textContent = this._openHintText;
			this._chatWindow.setAttribute('aria-hidden', 'true');
			this._chatWindow.classList.remove('is-expanded');
			this._iframe.setAttribute('tabindex', -1); // prevent tabbing into iframe when chat is closed
			document.removeEventListener('keyup', this._restrictTabToChat);

			if (typeof dataLayer !== 'undefined') {
				dataLayer.push({
					event: 'Chatbot Activiteit',
					eventAction: 'Chatsessie Gestopt',
					eventLabel: window.location.pathname
				});
			}
		}

		// start monitoring tab events to prevent tab from leaving chat

	}, {
		key: '_restrictTabToChat',
		value: function _restrictTabToChat(e) {
			if (e.which === 9) {
				// tab was pressed
				var activeElm = document.activeElement;
				if (!activeElm.closest('#rdw-chat')) {
					// active element is outside of chat; put focus back on toggle
					document.getElementById('chat-bar').focus();
				}
			}
		}

		// create promise for loading lottie-data

	}, {
		key: '_createAnimationDataPromise',
		value: function _createAnimationDataPromise(dataUrl, elm) {
			var promise = new Promise(function (resolve, reject) {
				var animation = bodymovin.loadAnimation({
					container: elm,
					path: dataUrl,
					renderer: 'svg',
					autoplay: false
				});
				animation.setSpeed(1.8);
				animation.addEventListener('data_ready', function () {
					resolve(animation);
				});
			});

			return promise;
		}

		// load lottie animation library and animations

	}, {
		key: '_initAnimations',
		value: function _initAnimations() {
			var _this3 = this;

			var lottieUrl = this._chatContainer.getAttribute('data-chat-lottie-url');
			if (lottieUrl) {
				var script = document.createElement('script');
				script.src = lottieUrl;
				script.addEventListener('load', function () {
					_this3._loadAnimations();
				});
				document.head.appendChild(script);
			}
		}

		// load all separate animation files

	}, {
		key: '_loadAnimations',
		value: function _loadAnimations() {
			var _this4 = this;

			if (typeof window.bodymovin !== 'undefined') {
				// lottie is present
				var avatarBarIntroJSON = this._chatContainer.getAttribute('data-chat-bar-intro-animation-json-url');
				var avatarBarLoopJSON = this._chatContainer.getAttribute('data-chat-bar-loop-animation-json-url');
				var avatarBtnIntroJSON = this._chatContainer.getAttribute('data-chat-btn-intro-animation-json-url');
				var avatarBtnLoopJSON = this._chatContainer.getAttribute('data-chat-btn-loop-animation-json-url');

				// load all animations' json files
				var introPromise = this._createAnimationDataPromise(avatarBarIntroJSON, this._barAvatarIntroElm).then(function (animation) {
					_this4._barAvatarIntroAnimation = animation;
				});
				var loopPromise = this._createAnimationDataPromise(avatarBarLoopJSON, this._barAvatarLoopElm).then(function (animation) {
					_this4._barAvatarLoopAnimation = animation;
				});
				var btnIntroPromise = this._createAnimationDataPromise(avatarBtnIntroJSON, this._btnAvatarIntroElm).then(function (animation) {
					_this4._btnAvatarIntroAnimation = animation;
				});
				var btnLoopPromise = this._createAnimationDataPromise(avatarBtnLoopJSON, this._btnAvatarLoopElm).then(function (animation) {
					_this4._btnAvatarLoopAnimation = animation;
				});

				// start introduction when all animations are loaded
				Promise.all([introPromise, loopPromise, btnIntroPromise, btnLoopPromise]).then(function () {
					_this4._introduceChat();
				});
			}
		}

		//set up the animation sequence

	}, {
		key: '_startAnimations',
		value: function _startAnimations() {
			var _this5 = this;

			this._barAvatarIntroAnimation.addEventListener('complete', function () {
				_this5._barAvatarIntroElm.classList.add('js-is-hidden');
				_this5._barAvatarLoopElm.classList.remove('js-is-hidden');
				_this5._barAvatarLoopAnimation.addEventListener('complete', function () {
					_this5._startAvatarLoopAnimation(_this5._barAvatarLoopAnimation);
				});
				_this5._startAvatarLoopAnimation(_this5._barAvatarLoopAnimation);
			});
			this._barAvatarIntroAnimation.play();
		}

		// start the loop after random delay of 5-15 secs

	}, {
		key: '_startAvatarLoopAnimation',
		value: function _startAvatarLoopAnimation(animation) {
			var delay = Math.round(10000 * Math.random()) + 5000;
			setTimeout(function () {
				animation.goToAndPlay(1, true);
			}, delay);
		}

		// handle end of bar's slide in animation

	}, {
		key: '_barAnimateInEndHandler',
		value: function _barAnimateInEndHandler() {
			var _this6 = this;

			this._chatWindow.classList.remove('js-bar-is-animating-in');
			this._chatContainer.classList.add('js-window-is-initialized');

			// set up animation for sliding out toggle on mobile
			this._chatWindow.classList.add('js-bar-is-animating-out');
			this._chatWindow.addEventListener('animationend', function () {
				_this6._barAnimateOutEndHandler();
			}, { once: true });
		}

		// handle end of bar's slide out animation

	}, {
		key: '_barAnimateOutEndHandler',
		value: function _barAnimateOutEndHandler() {
			var _this7 = this;

			this._chatWindow.classList.remove('js-bar-is-animating-out');
			this._chatContainer.classList.add('js-window-is-initialized-mobile');
			// the end-state of the properties we're animating is the same as they get when the ...-initialized classes are added. However, Safari on iOs sees those as a change from the original state without the animation, and then applies the transition on that change (looking like a hickup-effect). Therefore we add the transition with a dedicated class, 1ms after setting the js-window-is-initialized-mobile class
			setTimeout(function () {
				_this7._chatContainer.classList.add('js-window-is-initialized-with-transition');
			}, 1);
			this._startBtnIntroAnimation();
		}
	}, {
		key: '_startBtnIntroAnimation',
		value: function _startBtnIntroAnimation() {
			var _this8 = this;

			this._btnAvatarIntroAnimation.addEventListener('complete', function () {
				_this8._btnIntroEndHandler();
			});
			this._btnAvatarIntroAnimation.play();
		}

		// handle end of button's pop-in animation

	}, {
		key: '_btnIntroEndHandler',
		value: function _btnIntroEndHandler() {
			var _this9 = this;

			this._chatButton.classList.add('js-button-is-initialized');
			this._btnAvatarLoopAnimation.addEventListener('complete', function () {
				_this9._startAvatarLoopAnimation(_this9._btnAvatarLoopAnimation);
			});
			this._startAvatarLoopAnimation(this._btnAvatarLoopAnimation);
		}

		// present the chat to the user when the introduction delay has passed

	}, {
		key: '_introduceChat',
		value: function _introduceChat() {
			var _this10 = this;

			var introductionDelay = 1000 * parseInt(this._chatContainer.getAttribute('data-chat-introduction-delay') || 0, 10); // delay in msecs
			var timeUntilIntroduction = new Date().getTime() + introductionDelay - this._startTime.getTime();
			if (timeUntilIntroduction < 0) {
				timeUntilIntroduction = 0;
			}
			setTimeout(function () {
				_this10._startAnimations();
				_this10._chatWindow.classList.add('js-bar-is-animating-in');
				_this10._chatWindow.classList.remove('js-is-hidden');
				_this10._chatWindow.addEventListener('animationend', function () {
					_this10._barAnimateInEndHandler();
				}, { once: true });
			}, timeUntilIntroduction);
		}
	}]);

	return Chat;
}();

var isIE = function isIE() {
	return navigator.userAgent.match(/Trident\/7\./);
};

var init = function init(e) {
	// Create an instance on DOM ready
	if (document.querySelector('#rdw-chat') !== null) {
		var chat = new Chat();

		if (isIE()) {
			// if IE
			document.body.addEventListener('mousewheel', function (e) {
				e.preventDefault();
				//scroll without smoothing
				var wheelDelta = e.wheelDelta;
				var currentScrollPosition = window.pageYOffset;
				window.scrollTo(0, currentScrollPosition - wheelDelta);
			});
		}
	}
};

document.addEventListener('DOMContentLoaded', init, {
	once: true
});

},{"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],9:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _collapsible = require('../Partials/_collapsible.js');

var _collapsible2 = _interopRequireDefault(_collapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * initialize everything for the faq
 * @returns {undefined}
 */
var init = function init() {
	// vars
	var collapsibles = Array.from(document.querySelectorAll('.clustered-blocks > .js-collapsible'));
	collapsibles.forEach(function (el) {
		new _collapsible2.default(el);
	});
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_collapsible.js":37,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],10:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**

 * A singleton communication to iframe child

 *

 * @class DealerLocator

 */

var DealerLocator = function () {
	function DealerLocator() {
		var _this = this;

		_classCallCheck(this, DealerLocator);

		this._dealerLocatorContainer = document.querySelector('[data-attribute="dealer-locator-container"]');
		this._iframeWindow = document.querySelector('[data-attribute="iframe-window"]');
		this._dealerLocatorContainerH = 0;
		this._viewportH = document.documentElement.clientHeight;
		this._pageHeader = document.getElementById('page-header');
		this._pageHeaderH = 0;
		this._pageUtils = document.getElementById('page-utils');
		this._pageUtilsH = 0;
		this._pageAlerts = document.querySelector('.page-alerts');
		this._pageAlertsH = 0;

		var timer = void 0;
		this._resizeHandler = function () {
			clearTimeout(timer);
			timer = setTimeout(function () {
				return _this._resize();
			}, 50);
		};

		this._init();
	}

	// Set attributes and event handlers


	_createClass(DealerLocator, [{
		key: '_init',
		value: function _init() {
			window.addEventListener('resize', this._resizeHandler);
			window.addEventListener('orientationchange', this._resizeHandler);
			this._setHeight();
		}
	}, {
		key: '_setHeight',
		value: function _setHeight() {
			if (this._pageHeader) {
				this._pageHeaderH = this._pageHeader.offsetHeight;
			}

			if (this._pageUtils) {
				this._pageUtilsH = this._pageUtils.offsetHeight;
			}

			if (this._pageAlerts) {
				this._pageAlertsH = this._pageAlerts.offsetHeight;
			}

			this._dealerLocatorContainerH = this._viewportH - this._pageHeaderH - this._pageUtilsH - this._pageAlertsH + 'px';
			this._dealerLocatorContainer.style.height = this._dealerLocatorContainerH;
		}
	}, {
		key: '_resize',
		value: function _resize() {
			this._viewportH = document.documentElement.clientHeight;
			this._setHeight();
		}
	}]);

	return DealerLocator;
}();

var init = function init(e) {
	// Create an instance on DOM ready
	if (document.querySelector('[data-attribute="dealer-locator-container"]') !== null) {
		var dealerLocator = new DealerLocator();
	}
};

document.addEventListener('DOMContentLoaded', init, {
	once: true
});

},{}],11:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _tooltips = require('../Partials/_tooltips.js');

var _tooltips2 = _interopRequireDefault(_tooltips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
	var definitionEls = Array.from(document.querySelectorAll('dfn.js-tooltip'));
	definitionEls.forEach(function (el) {
		if (el.getAttribute('id') === null) {
			new _tooltips2.default(el);
		}
	});
};

document.addEventListener('DOMContentLoaded', init, { once: true });
window.addEventListener('renderTooltips', init);

},{"../Partials/_tooltips.js":57,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],12:[function(require,module,exports){
'use strict';

var _collapsibleExpandList = require('../Partials/_collapsible-expand-list.js');

var _collapsibleExpandList2 = _interopRequireDefault(_collapsibleExpandList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
	// Collapsibles in service-listing for medium to xlarge vp
	var listingCollapsibleExpandList = Array.from(document.querySelectorAll('.expand-list .js-collapsible-expand-list'));
	listingCollapsibleExpandList.forEach(function (el) {
		new _collapsibleExpandList2.default(el, ['medium', 'mediumPlus', 'large', 'xlarge']);
	});
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_collapsible-expand-list.js":36}],13:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _collapsible = require('../Partials/_collapsible.js');

var _collapsible2 = _interopRequireDefault(_collapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * initialize collapsible behaviour
 * @param {Array} arr - Array with DOM elements on which the collapsible behavior must be initiated
 * @returns {undefined}
 */
var initCollapsibles = function initCollapsibles(arr) {
	arr.forEach(function (el) {
		new _collapsible2.default(el);
	});
};

/**
 * initialize everything for the faq
 * @returns {undefined}
 */
var init = function init() {
	// vars
	var faqCollapsibles = Array.from(document.querySelectorAll('.faq__questions > .js-collapsible'));
	// functions
	initCollapsibles(faqCollapsibles);
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_collapsible.js":37,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.GenesysLiveChat = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _inView = require('../Helpers/in-view');

var _inView2 = _interopRequireDefault(_inView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GenesysLiveChat = exports.GenesysLiveChat = function () {
	function GenesysLiveChat(buttons) {
		_classCallCheck(this, GenesysLiveChat);

		this.buttons = buttons;
		this.toggle = document.querySelector('.genesys-live-chat__button--desktop');
		this.footer = document.querySelector('#page-footer__meta');

		if (window['Genesys']) {
			this.init();
			this.events();
		}
	}

	_createClass(GenesysLiveChat, [{
		key: 'init',
		value: function init() {
			var _this = this;

			this.deploymentId = window['Genesys'].c.deploymentId;

			if (this.footer) {
				_inView2.default.ElementIsInView(this.footer, function () {
					return _this.toggle.classList.add('genesys-live-chat__button--pull-up');
				}, function () {
					return _this.toggle.classList.remove('genesys-live-chat__button--pull-up');
				});
			}
		}
	}, {
		key: 'events',
		value: function events() {
			var _this2 = this;

			this.buttons.forEach(function (button) {
				return _this2.openClickEvent(button);
			});

			window['Genesys']('subscribe', 'Messenger.Ready', this.openChatWindow.bind(this));
		}
	}, {
		key: 'openClickEvent',
		value: function openClickEvent(button) {
			button.addEventListener('click', this.openChat);
		}
	}, {
		key: 'openChat',
		value: function openChat() {
			var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (e) {
				e.preventDefault();
			}

			window['Genesys']('command', 'Messenger.open', {});
		}
	}, {
		key: 'openChatWindow',
		value: function openChatWindow(e) {
			var urlParams = new URLSearchParams(window.location.search);
			var open = urlParams.get('open-chat') === '1';

			if (open) {
				var chatStatusCookie = window.localStorage.getItem('_' + this.deploymentId + ':gcmcopn');

				if (chatStatusCookie) {
					var chatStatusCookieParsed = JSON.parse(chatStatusCookie);

					if (chatStatusCookieParsed.value === 'false') {
						this.openChat();
					}
				} else {
					this.openChat();
				}
			}
		}
	}]);

	return GenesysLiveChat;
}();

new GenesysLiveChat(document.querySelectorAll('[data-open-chat]'));

},{"../Helpers/in-view":1}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GtmCsatCes = exports.GtmCsatCes = function () {
	function GtmCsatCes() {
		_classCallCheck(this, GtmCsatCes);

		this._itemList = document.querySelectorAll('.csat-form__radio');
		this._radioList = document.querySelectorAll('.csat-form__input');
		this._labelList = document.querySelectorAll('.csat-form__label');

		this._form = document.querySelector('.csat-form__form');
		this._feedback = document.querySelector('.csat-form__feedback');
		this._questionnaire = document.querySelector('.csat-form__questionnaire');
		this._result = document.querySelector('.csat-form__result');

		this._buttonsSubmit = document.querySelectorAll('.csat-form__btn--send');
		this._buttonsQuestionnaire = document.querySelectorAll('.csat-form__btn--questionnaire');
		this._buttonsCancel = document.querySelectorAll('.csat-form__btn--not-send');

		this._initialFeedbackGiven = false;

		this.init();
	}

	_createClass(GtmCsatCes, [{
		key: 'init',
		value: function init() {
			var _this = this;
			this._itemList.forEach(function (item, i) {
				_this._labelList[i].addEventListener('mouseover', function () {
					_this._scoreReset();
					_this._setScore(i);
				});

				_this._labelList[i].addEventListener('mouseleave', function () {
					_this._scoreReset();
					_this._radioList.forEach(function (radio, i) {
						if (radio.checked) {
							_this._setScore(i);
						}
					});
				});

				_this._radioList[i].addEventListener('keypress', function (event) {
					event.preventDefault();
					if (event.key === 'Enter') {
						_this._submitScore();
					}
				});
			});
			this._radioList.forEach(function (_input, i) {
				_input.addEventListener('change', function () {
					_this._setScore(i);
					_this._updateForm(i);
				});
			});

			this._labelList.forEach(function (_label) {
				_label.addEventListener('click', function () {
					setTimeout(function () {
						return _this._submitScore();
					}, 100);
				});
			});

			this._buttonsSubmit.forEach(function (button) {
				button.addEventListener('click', function (e) {
					e.preventDefault();
					_this._submitForm(e);
				});
			});

			this._buttonsQuestionnaire.forEach(function (button) {
				button.addEventListener('click', function (e) {
					_this._gotoNotSendFeedback();
				});
			});

			this._buttonsCancel.forEach(function (button) {
				button.addEventListener('click', function (e) {
					e.preventDefault();
					_this._gotoNotSendFeedback();
				});
			});
		}
	}, {
		key: '_scoreReset',
		value: function _scoreReset() {
			this._itemList.forEach(function (item) {
				item.classList.remove('csat-form__radio--level-1', 'csat-form__radio--level-2', 'csat-form__radio--level-3', 'csat-form__radio--level-4', 'csat-form__radio--level-5');
			});
		}
	}, {
		key: '_setScore',
		value: function _setScore(level) {
			this._itemList.forEach(function (item, i) {
				item.classList.remove('csat-form__radio--level-1', 'csat-form__radio--level-2', 'csat-form__radio--level-3', 'csat-form__radio--level-4', 'csat-form__radio--level-5');
				if (i <= level) {
					item.classList.add('csat-form__radio--level-' + (level + 1));
				}
			});
		}
	}, {
		key: '_updateForm',
		value: function _updateForm(level) {
			this._feedback.setAttribute('aria-hidden', 'false');
			this._feedback.setAttribute('aria-expanded', 'true');
		}
	}, {
		key: '_submitScore',
		value: function _submitScore() {
			if (!this._initialFeedbackGiven) {
				this._pushLayer('CSAT-RATING', false);
				this._initialFeedbackGiven = true;
			}
		}
	}, {
		key: '_submitForm',
		value: function _submitForm() {
			this._pushLayer('CSAT-FEEDBACK', true);
		}
	}, {
		key: '_gotoNotSendFeedback',
		value: function _gotoNotSendFeedback() {
			if (this._result) {
				this._result.setAttribute('aria-hidden', 'false');
				this._result.setAttribute('aria-expanded', 'true');
			}

			if (this._questionnaire) {
				this._questionnaire.setAttribute('aria-hidden', 'true');
				this._questionnaire.setAttribute('aria-expanded', 'false');
			}

			this._buttonsSubmit.forEach(function (button) {
				button.setAttribute('disabled', 'true');
			});
		}
	}, {
		key: '_pushLayer',
		value: function _pushLayer(type, showResult) {
			var _score = document.querySelector('[name="csat-score"]:checked');

			var _feedback = document.querySelector('#csat-feedback-textarea');

			if (_score) {
				if (typeof dataLayer !== 'undefined') {
					dataLayer.push({
						event: type,
						value: _score.value,
						feedback: _feedback.value.replace(/(\r\n|\n|\r)/gm, ' ')
					});
				} else {
					console.log('trying to push to GTM', {
						event: type,
						value: _score.value,
						feedback: _feedback.value.replace(/(\r\n|\n|\r)/gm, ' ')
					});
				}

				if (showResult) {
					if (this._form) {
						this._form.setAttribute('aria-hidden', 'true');
						this._form.setAttribute('aria-expanded', 'false');
					}

					if (this._questionnaire) {
						this._questionnaire.setAttribute('aria-hidden', 'false');
						this._questionnaire.setAttribute('aria-expanded', 'true');
					}

					if (this._feedback) {
						this._feedback.setAttribute('aria-hidden', 'true');
						this._feedback.setAttribute('aria-expanded', 'false');
					}

					this._buttonsSubmit.forEach(function (button) {
						button.setAttribute('disabled', 'true');
					});
				}
			}
		}
	}]);

	return GtmCsatCes;
}();

/**
 * initialize the kennisbank
 * @returns {undefined}
 */


var init = function init() {
	new GtmCsatCes();
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{}],16:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _createId = require('../Partials/_create-id.js');

var _createId2 = _interopRequireDefault(_createId);

var _onswipe = require('../Partials/_onswipe.js');

var _onswipe2 = _interopRequireDefault(_onswipe);

var _tooltips = require('../Partials/_tooltips.js');

var _tooltips2 = _interopRequireDefault(_tooltips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// define vars we need in multiple functions
// we can't assign values yet, because js isn't included at the end of the body, so need to use let
var views = void 0;
var nav = void 0;
var navLinks = void 0;
var select = void 0;
var options = void 0;
//local storage key to read/write value
var lsKey = 'hotspot-navigation';

/**
 * initialize toggles to show left or right side of wide views
 * @returns {undefined}
 */
var initWideViewsToggles = function initWideViewsToggles() {
	var wideItems = Array.from(document.querySelectorAll('.hotspot-view--wide'));

	wideItems.forEach(function (el) {
		var toggle = el.querySelector('.hotspot-view__thumbnail-nav');
		if (toggle) {
			toggle.addEventListener('click', function () {
				return el.classList.toggle('js-hotspot-view--right');
			});

			var swipeLeft = new _onswipe2.default();
			swipeLeft.on('left', el, function () {
				return el.classList.add('js-hotspot-view--right');
			});

			var swipeRight = new _onswipe2.default();
			swipeRight.on('right', el, function () {
				return el.classList.remove('js-hotspot-view--right');
			});
		} else {
			// A 'wide' view must have a toggle navigation via the CMS or else it cannot be used...
			// ...and therefore we remove its wide status and let it scale normally
			el.classList.remove('hotspot-view--wide');
		}
	});
};

/**
 * initialize tooltips on hotspots
 * @returns {undefined}
 */
var initHotspots = function initHotspots() {
	views.forEach(function (view) {
		var image = view.querySelector('.hotspot-view__img');
		var list = view.querySelector('.hotspot-view__hotspots');
		var hotspots = Array.from(view.querySelectorAll('.hotspot__link'));

		if (list) {
			var timer = void 0;
			var placeList = function placeList() {
				image.classList.add('tickle'); // Temporarily altering max-height of the image to force a redraw
				clearTimeout(timer);
				timer = setTimeout(function () {
					image.classList.remove('tickle');
					list.style.width = image.offsetWidth + 'px';
					list.style.height = image.offsetHeight + 'px';
					list.style.top = image.offsetTop + 'px';
				}, 200);
			};

			image.addEventListener(
			// When image is loaded
			'load', placeList);
			window.addEventListener(
			// When vp is resized or orientation changed
			'resize', placeList);
			window.addEventListener('orientationchange', placeList);

			window.addEventListener('hotspot-resize', placeList);

			placeList();
		}

		hotspots.forEach(function (el) {
			new _tooltips2.default(el, {
				triggers: ['click'],
				globalUntriggers: ['click'],
				additionalClassNames: ['tooltip__hotspot'],
				allowFocusInside: false,
				offsetTop: 15,
				offsetBottom: 64
			});

			el.addEventListener('click', function (e) {
				e.preventDefault();
			});
		});
	});
};

/**
 * handle change of view - either by clicking on nav-links, or using select
 * @returns {undefined}
 */
var changeView = function changeView(activeViewId) {
	var clss = 'is-active';

	navLinks.forEach(function (navLink) {
		if (navLink.getAttribute('aria-controls') === activeViewId) {
			navLink.classList.add(clss);
			navLink.setAttribute('aria-selected', 'true');
		} else {
			navLink.classList.remove(clss);
			navLink.setAttribute('aria-selected', 'false');
		}
	});

	views.forEach(function (view) {
		if (view.id === activeViewId) {
			view.classList.add(clss);
			view.setAttribute('aria-hidden', 'false');
		} else {
			view.classList.remove(clss);
			view.setAttribute('aria-hidden', 'true');
		}
	});

	options.forEach(function (option) {
		if (option.value === activeViewId) {
			option.setAttribute('selected', 'selected');
		} else {
			option.removeAttribute('selected');
		}
	});
};

var setFocusInView = function setFocusInView(viewId) {
	var view = document.getElementById(viewId);
	if (view) {
		setTimeout(function () {
			return view.focus();
		}, 100);
	}
};

/**
 * initialize nav for switching views; add aria-attributes
 * @returns {undefined}
 */
var initViewNav = function initViewNav() {
	select.setAttribute('aria-controls', 'hotspot-views');

	var navLists = nav.querySelectorAll('.vehicle-views-nav__list');
	navLists.forEach(function (navList) {
		navList.setAttribute('role', 'tablist');
		var navListItems = navList.querySelectorAll('button');
		navListItems.forEach(function (navLinkItem) {
			navLinkItem.setAttribute('role', 'tab');
		});
	});

	navLinks.forEach(function (navLink, i) {
		var view = views[i];
		var option = options[i];
		var labelId = 'hotspot-label-' + (0, _createId2.default)();

		// Set initial ARIA attributes
		var bodyId = 'hotspot-panel-' + (0, _createId2.default)();

		view.setAttribute('id', bodyId);
		view.setAttribute('role', 'tabpanel');
		view.setAttribute('aria-labelledby', labelId);

		if (option) {
			option.setAttribute('value', bodyId);
			option.setAttribute('id', labelId);
			option.setAttribute('aria-controls', bodyId);
		}

		navLink.setAttribute('id', labelId);
		navLink.setAttribute('aria-controls', bodyId);

		option.addEventListener('click', function (e) {
			options.forEach(function (o) {
				return o.classList.remove('active');
			});
			e.preventDefault();
			changeView(bodyId);
			setFocusInView(bodyId);
			option.classList.add('active');
		});

		navLink.addEventListener('click', function (e) {
			e.preventDefault();
			changeView(bodyId);
			setFocusInView(bodyId);
		});
	});

	options[0].classList.add('active');

	select.addEventListener('change', function (e) {
		return changeView(e.target.value);
	});
};

var VisualListSelector = function VisualListSelector() {
	var views = document.querySelector('.vehicle-views');
	var hotspots = document.getElementById('vehicle-view-hotspots');
	var list = document.getElementById('vehicle-view-list');
	var radioButtons = document.querySelectorAll('[name="vehicleViewType"]');
	var speed = 300;

	var listHeight = list.offsetHeight;
	var hotspotsHeight = hotspots.offsetHeight;
	var timeout = null;

	var resetHeight = function resetHeight() {
		clearTimeout(timeout);

		timeout = setTimeout(function () {
			var checkedValue = document.querySelector('[name="vehicleViewType"]:checked').value;

			var listHeight = list.offsetHeight;
			var hotspotsHeight = hotspots.offsetHeight;

			if (checkedValue === 'list') {
				views.setAttribute('style', 'height: ' + listHeight + 'px');
			} else {
				views.setAttribute('style', 'height: ' + hotspotsHeight + 'px');
			}
		}, speed);
	};

	var init = function init() {
		var lsValue = window.localStorage.getItem(lsKey);
		if (lsValue) {
			var radioButton = [].concat(_toConsumableArray(radioButtons)).find(function (radioButton) {
				return radioButton.value === lsValue;
			});

			if (radioButton) {
				radioButton.setAttribute('checked', true);
			} else {
				radioButtons[0].setAttribute('checked', true);
			}
		} else {
			radioButtons[0].setAttribute('checked', true);
		}

		if (lsValue === 'visual') {
			views.setAttribute('style', 'height: ' + hotspotsHeight + 'px');
		} else {
			views.setAttribute('style', 'height: ' + listHeight + 'px');
		}
	};

	init();

	window.addEventListener('resize', resetHeight);
	window.addEventListener('orientationchange', resetHeight);

	radioButtons.forEach(function (radioButton) {
		radioButton.addEventListener('click', function (e) {
			window.localStorage.setItem(lsKey, e.target.value);
			if (e.target.value === 'visual') {
				list.classList.add('hidden');
				views.setAttribute('style', 'height: ' + hotspotsHeight + 'px');
				setTimeout(function () {
					list.setAttribute('aria-hidden', 'true');
					hotspots.removeAttribute('aria-hidden');
					setTimeout(function () {
						hotspots.classList.remove('hidden');
					}, speed);
					var event = new Event('hotspot-resize');
					window.dispatchEvent(event);
				}, speed);
			} else {
				hotspots.classList.add('hidden');
				views.setAttribute('style', 'height: ' + listHeight + 'px');
				setTimeout(function () {
					hotspots.setAttribute('aria-hidden', 'true');
					list.removeAttribute('aria-hidden');
					setTimeout(function () {
						list.classList.remove('hidden');
					}, speed);
				}, speed);
			}
		});
		var panel = document.getElementById(radioButton.parentElement.getAttribute('aria-controls'));
		if (!radioButton.getAttribute('checked')) {
			panel.classList.add('hidden');
			panel.setAttribute('aria-hidden', 'true');
		}
	});
};

/**
 * initialize apk navigation
 * @returns {undefined}
 */
var init = function init() {
	if (document.querySelector('.hotspot-nav-section') !== null) {
		// define vars that rely on dom being present
		views = Array.from(document.querySelectorAll('.hotspot-view'));
		nav = document.getElementById('vehicle-views-nav');
		select = document.getElementById('vehicle-views-selector');

		if (nav) {
			navLinks = Array.from(nav.querySelectorAll('button'));
		}

		initWideViewsToggles();
		initHotspots();

		if (navLinks && select) {
			options = Array.from(select.querySelectorAll('button'));
			initViewNav();
			changeView(Array.from(views)[0].id); // Select first view
		}
		VisualListSelector();
	}
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_create-id.js":38,"../Partials/_onswipe.js":46,"../Partials/_tooltips.js":57,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LightBoxRDW = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // custom/script


require('../Vendor/fslightbox');

var _trapFocus = require('../Helpers/trap-focus');

var _trapFocus2 = _interopRequireDefault(_trapFocus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LightBoxRDW = exports.LightBoxRDW = function () {
	function LightBoxRDW() {
		_classCallCheck(this, LightBoxRDW);

		var isSitecore = false;
		try {
			if (!!(Sitecore && Sitecore.PageModes && Sitecore.PageModes.PageEditor)) {
				isSitecore = true;
			}
		} catch (e) {}

		if (!isSitecore) {
			this.images = document.querySelectorAll('.lightbox:not(.slideshow)');
			this.init();
		}
	}

	_createClass(LightBoxRDW, [{
		key: 'isMobileSafari',
		value: function isMobileSafari() {
			return navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/);
		}
	}, {
		key: 'setTranslation',
		value: function setTranslation(elm, text) {
			if (elm && text) {
				elm.removeAttribute('title');
				elm.setAttribute('aria-label', text);
			}
		}
	}, {
		key: 'init',
		value: function init() {
			var _this = this;

			var list = [];
			this.images.forEach(function (picture) {
				var containsLink = !!picture.closest('a');

				if (!containsLink) {
					if (!picture.parentNode.classList.contains('figure-rte') && !picture.parentNode.classList.contains('lightbox-trigger-button')) {
						// The EE can leave empty figures behind in the html, we need to filter these out if they don't have an img tag
						list.push(picture.closest('picture'));
					} else if (picture.classList.contains('figure-rte')) {
						list.push(picture.closest('.figure-rte'));
					}
				}
			});

			if (list.length > 0) {
				var lightbox = new FsLightbox();
				var images = [];

				list.forEach(function (item, index) {
					if (!item.parentNode.classList.contains('lightbox-trigger-button')) {
						images.push('/assets/Rdw/images/spinnerRDW.png');

						var link = document.createElement('button');
						link.classList.add('lightbox-trigger-button');
						link.appendChild(item.cloneNode(true));
						link.addEventListener('click', function () {
							lightbox.open(index);
							link.classList.add('return-focus-to-me');
						});

						// check if we have scaling data set on the image itself from the EE
						var img = item.querySelector('img');
						var styleData = img.getAttribute('style');

						if (styleData) {
							// move this styling to the wrapper button
							img.removeAttribute('style');
							link.setAttribute('style', styleData);
						}
						item.replaceWith(link);
					}
				});

				lightbox.props.sources = images;
				lightbox.props.loadOnlyCurrentSource = true;
				lightbox.props.exitFullscreenOnClose = true;
				lightbox.props.accessable = false;
				lightbox.props.onOpen = function () {
					// on mobile safari there is no fullscreen mode, remove the button
					// there is no id or class so we need to match the title
					var fullscreen = document.querySelector('.fslightbox-toolbar-button[title="Enter fullscreen"]');

					if (fullscreen && _this.isMobileSafari()) {
						fullscreen.remove();
					}
					if (!lightbox.props.accessable) {
						var slideButtons = document.querySelectorAll('.fslightbox-container .fslightbox-slide-btn-container div');

						slideButtons.forEach(function (btn) {
							var slideBtn = document.createElement('button');
							var button = btn.cloneNode(true);
							slideBtn.appendChild(button);
							slideBtn.addEventListener('click', function () {
								_this.loadImage(list);
							});
							btn.replaceWith(slideBtn);
						});

						var toolbarButtons = document.querySelectorAll('.fslightbox-toolbar .fslightbox-toolbar-button svg');

						toolbarButtons.forEach(function (svg) {
							var toolbarBtn = document.createElement('button');
							var newBtn = svg.cloneNode(true);
							toolbarBtn.appendChild(newBtn);
							svg.replaceWith(toolbarBtn);
						});
						lightbox.props.accessable = true;
					}
					_trapFocus2.default.startTrapFocus(document.querySelector('.fslightbox-container'));
					setTimeout(function () {
						_this.loadImage(list);

						lightbox.props.observer = new MutationObserver(function () {
							_this.loadImage(list);
						});
						lightbox.props.observer.observe(document.querySelector('.fslightbox-container'), {
							childList: false,
							attributes: true,
							subtree: false
						});
					}, 500);
				};
				lightbox.props.onClose = function () {
					_this.lastFocused(true);
					lightbox.props.observer.disconnect();
				};
				lightbox.props.onInit = function () {
					document.addEventListener('keydown', function (e) {
						if (e.code === 'ArrowLeft' || e.code === 'ArrowRight') {
							_this.loadImage(list);
						}
					});
					setTimeout(function () {
						_this.loadImage(list);
					}, 500);
				};
			}
		}
	}, {
		key: 'loadImage',
		value: function loadImage(list) {
			var _this2 = this;

			var lightboxImageContainers = document.querySelectorAll('.fslightbox-absoluted.fslightbox-flex-centered');

			setTimeout(function () {
				var indexSpan = document.querySelector('.fslightbox-slide-number-container .fslightbox-flex-centered span');
				var index = 0;
				if (indexSpan) {
					index = parseInt(indexSpan.innerText) - 1;
				}
				var container = lightboxImageContainers[index];

				if (container && !container.classList.contains('figure-loaded')) {
					var img = container.querySelector('img');

					if (img) {
						var item = list[index].cloneNode(true);

						if (item) {
							var loadedImage = item.querySelector('img');
							var source = item.querySelector('source');
							if (source) {
								source.remove();
							}

							// we have scaling data for the lightbox
							var scalingLightboxSrcSet = loadedImage.getAttribute('data-lightbox-srcset');

							var scalingLightboxSizes = loadedImage.getAttribute('data-lightbox-sizes');

							var scalingLightboxSrc = loadedImage.getAttribute('data-lightbox-src');

							_this2.setTranslation(document.querySelector('.fslightbox-toolbar-button[title="Enter fullscreen"]'), loadedImage.getAttribute('data-lightbox-fullscreen'));

							_this2.setTranslation(document.querySelector('.fslightbox-toolbar-button[title="Close"]'), loadedImage.getAttribute('data-lightbox-close'));

							_this2.setTranslation(document.querySelector('.fslightbox-slide-btn-container-previous'), loadedImage.getAttribute('data-lightbox-previous'));

							_this2.setTranslation(document.querySelector('.fslightbox-slide-btn-container-next'), loadedImage.getAttribute('data-lightbox-next'));

							if (scalingLightboxSrcSet) {
								loadedImage.setAttribute('srcset', scalingLightboxSrcSet);
							}
							if (scalingLightboxSizes) {
								loadedImage.setAttribute('sizes', scalingLightboxSizes);
							}
							if (scalingLightboxSrc) {
								loadedImage.setAttribute('src', scalingLightboxSrc);
							}

							img.replaceWith(item);
							container.classList.add('figure-loaded');
						}
					}
				}
			}, 100);
		}
	}, {
		key: 'lastFocused',
		value: function lastFocused() {
			var removeClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			var lastFocused = document.querySelector('.return-focus-to-me');

			lastFocused.focus();
			if (removeClass) {
				lastFocused.classList.remove('return-focus-to-me');
			}
		}
	}]);

	return LightBoxRDW;
}();

/**
 * initialize the lightbox
 * @returns {undefined}
 */


var init = function init() {
	new LightBoxRDW();
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Helpers/trap-focus":2,"../Vendor/fslightbox":60}],18:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _collapsible = require('../Partials/_collapsible.js');

var _collapsible2 = _interopRequireDefault(_collapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// define selectors for all listings that need to be collapsible
var smallViewCollapsibleSelectors = ['.forward-list-section > .js-collapsible', '.recent-changes > .js-collapsible'].toString();

/**
 * initialize collapsible behaviour for lists that should be collapsible in small view
 * @returns {undefined}
 */
// general script for listings
// until now, only handles listings's collapsible behavior

var initSmallViewCollapsibles = function initSmallViewCollapsibles() {
	var listingCollapsibles = Array.from(document.querySelectorAll(smallViewCollapsibleSelectors));

	listingCollapsibles.forEach(function (el) {
		// Collapsible for mobile
		new _collapsible2.default(el, ['small']);
	});
};

// for every viewport (or set of viewports), define which selectors need to be made into collapsible
var collapsiblesPerViewport = [{
	viewportStates: ['small'],
	selectors: ['.forward-list-section > .js-collapsible', '.recent-changes > .js-collapsible', '.related-documents > .js-collapsible'].toString()
}, {
	viewportStates: 'all',
	selectors: ['.more-related-documents.js-collapsible', '.subjects > .js-collapsible']
}];

/**
 * initialize collapsible behaviour for lists that should be collapsible in small view
 * @returns {undefined}
 */
var initCollapsibles = function initCollapsibles() {
	collapsiblesPerViewport.forEach(function (viewportSet) {
		var collapsibles = Array.from(document.querySelectorAll(viewportSet.selectors));

		collapsibles.forEach(function (el) {
			new _collapsible2.default(el, viewportSet.viewportStates);
		});
	});
};

/**
 * initialize everything for the forward-list
 * @returns {undefined}
 */
var init = function init() {
	initCollapsibles();
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_collapsible.js":37,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],19:[function(require,module,exports){
'use strict';

(function () {
	/**
  *
  * @returns {undefined}
  */
	var setTextHeights = function setTextHeights() {
		var bBody = document.querySelector('[data-js="login-box__body--business"]');
		var pBody = document.querySelector('[data-js="login-box__body--private"]');

		if (bBody && pBody) {
			bBody.style.minHeight = 0;
			pBody.style.minHeight = 0;
			var minHeight = Math.max(bBody.offsetHeight, pBody.offsetHeight);
			bBody.style.minHeight = minHeight + 'px';
			pBody.style.minHeight = minHeight + 'px';
		}
	};

	/**
  * debounced variant of setTextHeights
  * @returns {undefined}
  */
	var debouncedSetTextHeights = debounce(setTextHeights, 100);

	// https://davidwalsh.name/javascript-debounce-function
	function debounce(func, wait, immediate) {
		var timeout;

		return function () {
			var context = this,
			    args = arguments;
			var later = function later() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(context, args);
			}
		};
	}

	/**
  * initialize
  * @returns {undefined}
  */
	var init = function init() {
		window.addEventListener('resize', debouncedSetTextHeights);
		setTextHeights();
	};

	document.addEventListener('DOMContentLoaded', init, { once: true });
})();

},{}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

require('core-js/fn/object/keys');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A singleton that manages all LUK components on a page by requesting the codes for all in a single request.
 * Add new LUK DOM elements to the instance, then fire off the request() method to retrieve and parse codes for all components
 * at once, depending on vehicle type. Vehicle type per LUK component is set on the data-luk-vehicle attribute.
 *
 * @param {string} uri URI of the service API; can also be set after instantiating via setURI() method.
 * @class LUK
 */
var LUK = function () {
	function LUK() {
		var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

		_classCallCheck(this, LUK);

		this._vehicles = {}; // {auto: [item, item], motor: [item], ...}
		this._req = new XMLHttpRequest();
		this._serviceURI = uri;
	}

	/**
  * Set the URI of the API service for this instance
  *
  * @param {string} uri
  * @memberof LUK
  */


	_createClass(LUK, [{
		key: 'setURI',
		value: function setURI() {
			var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			this._serviceURI = uri;
		}

		/**
   * Add a LUK component that will be processed when requesting codes
   *
   * @param {Object} item A LUK DOM component
   * @type {HTMLElement}
   * @param {Object} codeContainer The DOM element inside the item where the code should be placed
   * @type {HTMLElement}
   * @memberof LUK
   */

	}, {
		key: 'add',
		value: function add(item, codeContainer) {
			var v = item.getAttribute('data-luk-vehicle') || 'auto';

			if (!this._vehicles[v]) {
				this._vehicles[v] = { code: '', items: [] };
			}
			this._vehicles[v].items.push({
				root: item,
				codeContainer: codeContainer
			});
		}

		/**
   * Request codes for all added LUK components
   *
   * @memberof LUK
   */

	}, {
		key: 'request',
		value: function request() {
			var _this = this;

			if (Object.keys(this._vehicles).length > 0) {
				this._query(function (result) {
					return _this._parseResult(result);
				});
			}
		}
	}, {
		key: '_query',
		value: function _query(successFn) {
			var _this2 = this;

			if (this._serviceURI.length > 0) {
				this._req.abort();

				var arr = [];
				Object.keys(this._vehicles).forEach(function (key) {
					return arr.push(encodeURIComponent(key));
				});

				var p = arr.join('&vehicle=');
				var uri = this._serviceURI + '?vehicle=' + p; // baseURI?vehicle=auto&vehicle=motor&...

				// Set callback function
				this._req.onreadystatechange = function (e) {
					if (_this2._req.readyState === XMLHttpRequest.DONE && _this2._req.status === 200) {
						var result = JSON.parse(_this2._req.responseText);
						successFn(result);
					}
				};

				this._req.open('GET', uri, true);
				this._req.send();
			}
		}
	}, {
		key: '_parseResult',
		value: function _parseResult() {
			var _this3 = this;

			var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			// [{ "vehicle": "auto", "code": "xx-xx-xx" }, {...}]
			result.forEach(function (set) {
				var v = set.vehicle;
				var c = set.code;

				if (_this3._vehicles[v]) {
					_this3._vehicles[v].code = c;
					_this3._vehicles[v].items.forEach(function (item) {
						return _this3._parseItem(item.codeContainer, c);
					});
				}
			});
		}
	}, {
		key: '_parseItem',
		value: function _parseItem(codeContainer, code) {
			codeContainer.innerText = code;
		}
	}]);

	return LUK;
}();

var luk = new LUK();

var init = function init() {
	// Service URI via data attr on LUK component for now, maybe META in HEAD later
	var el = document.querySelector('[data-luk-service-uri]');
	var uri = el ? el.getAttribute('data-luk-service-uri') : '';
	luk.setURI(uri);

	var items = Array.from(document.querySelectorAll('.kenteken-luk'));
	if (items.length > 0) {
		items.forEach(function (item) {
			return luk.add(item, item.querySelector('.kenteken__code'));
		});
		luk.request();
	}
};

init();

exports.default = luk;

},{"core-js/fn/array/for-each":63,"core-js/fn/array/from":64,"core-js/fn/object/keys":67}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _viewportstateWatcher = require('../Partials/_viewportstate-watcher.js');

var _viewportstateWatcher2 = _interopRequireDefault(_viewportstateWatcher);

var _testTouchevents = require('../Partials/_test-touchevents.js');

var _testTouchevents2 = _interopRequireDefault(_testTouchevents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* 
    TODO: 
    - upon viewport resize, set scroll position to list (top, bottom or whatever) or content
*/

/**
 * A singleton that is in charge of the exotic scrolling/flicking behaviour of the page masthead (on small and medium view)
 *
 * @class MastheadScrollhandler
 */
var MastheadScrollhandler = function () {
	function MastheadScrollhandler() {
		var _this = this;

		_classCallCheck(this, MastheadScrollhandler);

		this._wrap = document.querySelector('.masthead__wrap');
		this._services = this._wrap.querySelector('.masthead__services');
		this._textitem = this._wrap.querySelector('.masthead__text');

		this._scrollBuffer = 75;
		this._scrollStep = 6;
		this._dir = 'down';

		this._hasInitialised = false;

		var timer = void 0;

		// Called on various interaction events
		this._scrollHandler = function (event) {
			var fn = void 0;

			if (_this._dir === 'down') {
				// Services list is shown, user wants to scroll down
				fn = function fn() {
					var y = _this._wrap.scrollTop;
					_this._updateProps();

					if (_this._bodyY > 0) {
						return;
					}

					if (y + _this._wrapH > _this._textitemY + _this._scrollBuffer) {
						// Content peeks from the bottom of root and is pastbuffer zone: scroll to content
						_this._scrollTo(_this._textitemY, function () {
							_this._dir = 'up';
						});
					} else if (_this._servicesH <= _this._wrapH) {
						// List height is smaller than root height: scroll to list top; long list allows user scrolling
						_this._scrollTo(0);
					} else if (y + _this._wrapH > _this._textitemY) {
						// Content peeks from the bottom of root but is below buffer zone: scroll to bottom of list
						_this._scrollTo(_this._servicesH - _this._wrapH);
					}
				};
			} else {
				// Text item is shown, user wants to scroll up
				fn = function fn() {
					var y = _this._wrap.scrollTop;
					_this._updateProps();

					if (_this._bodyY > 0) {
						return;
					}

					if (y < _this._textitemY - _this._scrollBuffer) {
						// List peeks from the top of root and is past buffer zone

						if (y > _this._servicesH - _this._wrapH) {
							// Bottom of list is still visible: scroll to bottom of list
							_this._scrollTo(_this._servicesH - _this._wrapH, function () {
								_this._dir = 'down';
							});
						}
					} else if (_this._textitemH <= _this._wrapH) {
						// Content height is smaller than root height: scroll to top of content
						_this._scrollTo(_this._textitemY + _this._scrollBuffer);
					}
				};
			}

			clearTimeout(timer);

			if (event.type === 'touchend' || event.type === 'mouseup') {
				fn();
			} else {
				timer = setTimeout(fn, 50);
			}
		};

		// Remove scroll event handler (triggered on mousedown and touchstart events)
		this._removeScrollListener = function () {
			return _this._wrap.removeEventListener('scroll', _this._scrollHandler, {
				passive: true
			});
		};

		// Add scroll event handler (triggered on mouseup and touchend events)
		this._addScrollListener = function () {
			return _this._wrap.addEventListener('scroll', _this._scrollHandler, {
				passive: true
			});
		};

		// Handle page scrolling
		this._scrollHandlerPage = function (event) {
			clearTimeout(timer);
			timer = setTimeout(function () {
				if (document.body.scrollTop > 0) {
					// Enable masthead scrolling when not scrolled to top
					// (Might not be agnostic enough; it implies masthead sits at top)
					_this._wrap.classList.add('stop-scrolling');
				} else {
					// Disable masthead scrolling when not scrolled to top
					_this._wrap.classList.remove('stop-scrolling');
				}
			}, 50);
		};

		this._touchEvents = _testTouchevents2.default.test();
		_testTouchevents2.default.setClass(this._touchEvents, 'touchevents');

		// Stream init/uninit through viewportStateWatcher
		_viewportstateWatcher2.default.watch(['small', 'medium', 'mediumPlus'], function () {
			return _this._init();
		}, function () {
			return _this._uninit();
		});
	}

	_createClass(MastheadScrollhandler, [{
		key: '_init',
		value: function _init() {
			if (this._hasInitialised) return; // Don't initialise unless uninitialised
			this._hasInitialised = true;

			this._addEventHandlers();

			document.addEventListener('scroll', this._scrollHandlerPage, {
				passive: true
			});
		}
	}, {
		key: '_uninit',
		value: function _uninit() {
			this._hasInitialised = false;

			this._removeEventHandlers();

			document.removeEventListener('scroll', this._scrollHandlerPage, {
				passive: true
			});
		}

		// Update some variables from the DOM

	}, {
		key: '_updateProps',
		value: function _updateProps() {
			this._bodyY = document.body.scrollTop;
			this._wrapH = this._wrap.offsetHeight;
			this._servicesH = this._services.offsetHeight;
			this._textitemH = this._textitem.offsetHeight;
			this._textitemY = this._textitem.offsetTop;
		}

		// Add all relevant interaction event handlers

	}, {
		key: '_addEventHandlers',
		value: function _addEventHandlers() {
			this._wrap.addEventListener('touchend', this._scrollHandler, {
				passive: true
			});
			this._wrap.addEventListener('mouseup', this._scrollHandler);
			this._wrap.addEventListener('scroll', this._scrollHandler, {
				passive: true
			});
			this._wrap.addEventListener('touchstart', this._removeScrollListener, {
				passive: true
			});
			this._wrap.addEventListener('mousedown', this._removeScrollListener);
			this._wrap.addEventListener('touchend', this._addScrollListener, {
				passive: true
			});
			this._wrap.addEventListener('mouseup', this._addScrollListener);
		}

		// Remove all relevant interaction event handlers

	}, {
		key: '_removeEventHandlers',
		value: function _removeEventHandlers() {
			this._wrap.removeEventListener('touchend', this._scrollHandler, {
				passive: true
			});
			this._wrap.removeEventListener('mouseup', this._scrollHandler);
			this._wrap.removeEventListener('scroll', this._scrollHandler, {
				passive: true
			});
			this._wrap.removeEventListener('touchstart', this._removeScrollListener, { passive: true });
			this._wrap.removeEventListener('mousedown', this._removeScrollListener);
			this._wrap.removeEventListener('touchend', this._addScrollListener, {
				passive: true
			});
			this._wrap.removeEventListener('mouseup', this._addScrollListener);
		}

		/**
   * Scroll the wrapper to a designated position
   *
   * @param {integer} targetY - The target position
   * @param {function} [callbackFn=() => {}] - Optional callback function, called upon reaching the target position
   *
   * @memberOf MastheadScrollhandler
   */

	}, {
		key: '_scrollTo',
		value: function _scrollTo(targetY) {
			var _this2 = this;

			var callbackFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

			this._removeEventHandlers();
			if (this._touchevents) {
				this._wrap.classList.add('stop-scrolling');
			}

			var scrollY = this._wrap.scrollTop;
			var step = targetY > scrollY ? this._scrollStep : -this._scrollStep;

			// Loop run with each interval call
			var loop = function loop() {
				scrollY += step;
				if (scrollY >= targetY && step > 0 || scrollY <= targetY && step < 0) {
					_this2._wrap.scrollTop = targetY;
					clearInterval(timer);
					setTimeout(function () {
						if (_this2._touchevents) {
							_this2._wrap.classList.remove('stop-scrolling');
						}
						_this2._addEventHandlers();
						callbackFn();
					}, 100);
				} else {
					_this2._wrap.scrollTop = scrollY;
				}
			};

			var timer = void 0;

			clearInterval(timer);
			timer = setInterval(loop, 0);
		}
	}]);

	return MastheadScrollhandler;
}();

exports.default = MastheadScrollhandler;

},{"../Partials/_test-touchevents.js":56,"../Partials/_viewportstate-watcher.js":58}],22:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _viewportstateWatcher = require('../Partials/_viewportstate-watcher.js');

var _viewportstateWatcher2 = _interopRequireDefault(_viewportstateWatcher);

var _collapsible = require('../Partials/_collapsible.js');

var _collapsible2 = _interopRequireDefault(_collapsible);

var _mastheadScrollhandler = require('../Modules/_masthead-scrollhandler.js');

var _mastheadScrollhandler2 = _interopRequireDefault(_mastheadScrollhandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
	// Collapsibles in masthead
	var mastheadCollapsibles = Array.from(document.querySelectorAll('.masthead .js-collapsible'));
	mastheadCollapsibles.forEach(function (el) {
		new _collapsible2.default(el, ['small']);
	});

	// Scrollhandler
	// let mastheadServices = document.querySelectorAll('.masthead .masthead__services');
	// if (mastheadServices.length > 0) {
	//     let mastheadScrollHandler = new MastheadScrollHandler();
	// }

	// Fallback for safari because it doesn't support calc(25% - 24px), see file: _masthead-services.scss
	if (document.querySelector('html').classList.contains('is-ios-safari')) {
		var items = Array.from(document.querySelectorAll('.masthead__services__item'));

		if (items.length < 1) {
			return;
		}

		_viewportstateWatcher2.default.watch(['large', 'xlarge'], function () {
			var parentHeight = items[0].parentElement.offsetHeight;
			var newItemHeight = String(parentHeight / 4 - 16);

			items.forEach(function (item) {
				return item.style.height = newItemHeight + 'px';
			});
		}, function () {
			return null;
		});
	}
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Modules/_masthead-scrollhandler.js":21,"../Partials/_collapsible.js":37,"../Partials/_viewportstate-watcher.js":58,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],23:[function(require,module,exports){
'use strict';

var init = function init() {
	var messages = document.querySelectorAll('.message');
	messages.forEach(function (message) {
		var button = message.querySelector('button');
		var storage = message.dataset.persistent !== undefined ? localStorage : sessionStorage;

		var close = function close(instant) {
			if (instant) {
				message.remove();
			} else {
				message.setAttribute('style', 'opacity: 0');
				setTimeout(function () {
					message.remove();
				}, 500);
			}
			if (message.id) {
				storage.setItem(message.id, 'hidden-from-user');
			} else {
				console.info('no message id given for closing state, message will reapear to the user');
			}
		};

		var show = function show() {
			message.setAttribute('aria-hidden', 'false');
		};

		if (message) {
			// if the message has been closed before, hide it again
			if (storage.getItem(message.id)) {
				close(true);

				return;
			}

			show();
		}

		var clickEventListener = function clickEventListener() {
			close();
		};

		var keyEventListener = function keyEventListener(event) {
			if (event.code === 'Enter') {
				close();
			}
		};

		var focusEventListener = function focusEventListener() {
			document.addEventListener('keydown', keyEventListener);
		};

		var blurEventListener = function blurEventListener() {
			document.removeEventListener('keydown', keyEventListener);
		};

		var addListeners = function addListeners() {
			if (message) {
				message.addEventListener('focus', focusEventListener);
				message.addEventListener('blur', blurEventListener);
			}
			if (button) {
				button.addEventListener('click', clickEventListener);
			}
		};

		addListeners();
	});
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{}],24:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _collapsible = require('../Partials/_collapsible.js');

var _collapsible2 = _interopRequireDefault(_collapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
	// Collapsibles in footer doormat
	var footerCollapsibles = Array.from(document.querySelectorAll('#page-footer__doormat .js-collapsible'));
	footerCollapsibles.forEach(function (el) {
		new _collapsible2.default(el, ['small', 'medium']);
	});
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_collapsible.js":37,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],25:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

var _printButton = require('../Partials/_print-button.js');

var _printButton2 = _interopRequireDefault(_printButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appendPrintInfo = function appendPrintInfo() {
	var infoNode = document.createElement('div');

	var metaEl = document.querySelector('meta[name="print-message"]');
	infoNode.classList.add('print-message');
	infoNode.setAttribute('role', 'presentation');
	infoNode.setAttribute('data-nosnippet', '');
	infoNode.textContent = metaEl ? metaEl.getAttribute('content') : '';

	document.body.appendChild(infoNode);
};

var init = function init() {
	// Page utilities print button
	var buttonPrintPage = document.getElementById('print-page');
	if (buttonPrintPage) {
		new _printButton2.default(buttonPrintPage);
	}

	appendPrintInfo();
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_print-button.js":48,"core-js/fn/array/from":64}],26:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Popup = function () {
	function Popup(popup, triggers) {
		var _this = this;

		_classCallCheck(this, Popup);

		this.popup = popup;
		this.bindFocusLoop();
		this.keyup = function (e) {
			return e.key === 'Escape' ? _this.togglePopUp(false)() : function () {}();
		}; //noop
		triggers.forEach(function (trigger) {
			return trigger.elem.addEventListener('click', _this.togglePopUp(trigger.showPopup));
		});
	}

	_createClass(Popup, [{
		key: 'togglePopUp',
		value: function togglePopUp(showPopup) {
			var _this2 = this;

			return function (event) {
				_this2.popup.classList.toggle('visible', showPopup);
				document.querySelector('body').classList.toggle('has-overlay', showPopup);
				if (showPopup) {
					document.addEventListener('keyup', _this2.keyup);
					_this2.usedTrigger = event.target;
					_this2.popup.focus();
				} else {
					document.removeEventListener('keyup', _this2.keyup);
					_this2.usedTrigger.focus();
				}
			};
		}
	}, {
		key: 'bindFocusLoop',
		value: function bindFocusLoop() {
			var tabableElements = this.popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
			tabableElements[tabableElements.length - 1].addEventListener('focusout', function () {
				return tabableElements[0].focus();
			});
		}
	}]);

	return Popup;
}();

exports.default = Popup;

},{}],27:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _table = require('../Partials/_table.js');

var _table2 = _interopRequireDefault(_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
	var rtes = Array.from(document.querySelectorAll('.rte'));
	rtes.forEach(function (rte) {
		var tables = Array.from(rte.querySelectorAll('.js-resizing-table'));
		tables.forEach(function (table) {
			new _table2.default(table, rte);
		});
	});
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_table.js":53,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],28:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _onswipe = require('../Partials/_onswipe.js');

var _onswipe2 = _interopRequireDefault(_onswipe);

var _searchSuggest = require('../Partials/_search-suggest.js');

var _searchSuggest2 = _interopRequireDefault(_searchSuggest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeaderSearchForm = function () {
	function HeaderSearchForm() {
		_classCallCheck(this, HeaderSearchForm);

		this._root = document.getElementById('page-header__search');
		this._form = this._root.querySelector('.site-search__form');
		this._label = document.getElementById('page-header__search__label');
		this._field = document.getElementById('page-header__search__field');
		this._button = document.getElementById('page-header__search__toggle');

		this._searchResultItems = Array.from(document.querySelectorAll('.search-results__results-list  > li > a'));

		this._isExpanded = false;

		this._init();
	}

	_createClass(HeaderSearchForm, [{
		key: '_init',
		value: function _init() {
			var _this = this;

			this._button.setAttribute('aria-expanded', false);
			this._button.textContent = this._button.getAttribute('data-label-show');

			this._form.setAttribute('aria-hidden', true);
			if (typeof dataLayer !== 'undefined') {
				this._searchResultItems.forEach(function (item) {
					item.addEventListener('click', _this._handleResultItem);
				});
			}
			var escHandler = function escHandler(e) {
				if (e.key === 'Escape' || e.key === 'Esc') {
					if (!_this._root.querySelector('.search-suggest.is-active')) {
						_this._quit();
						setTimeout(function () {
							return _this._button.focus();
						}, 100);
					}
				}
			};

			this._root.addEventListener('keyup', escHandler);
			this._label.addEventListener('click', function () {
				return _this._activate();
			});

			var toggleHandler = function toggleHandler(e) {
				e.preventDefault();

				if (_this._isExpanded) {
					_this._quit();
				} else {
					_this._activate();
				}
			};

			this._button.addEventListener('click', toggleHandler);

			var focusoutHandler = function focusoutHandler(e) {
				if (_this._isExpanded) _this._quit();
			};

			document.body.addEventListener('focusin', focusoutHandler);
			document.body.addEventListener('click', focusoutHandler);

			this._root.addEventListener('focusin', function (e) {
				return e.stopPropagation();
			});
			this._root.addEventListener('click', function (e) {
				return e.stopPropagation();
			});

			var swipeHandler = new _onswipe2.default();
			swipeHandler.on('right', this._root, function () {
				return _this._quit();
			});
		}
	}, {
		key: '_handleResultItem',
		value: function _handleResultItem(e) {
			if (typeof dataLayer !== 'undefined') {
				var item = e.currentTarget;
				var itemLink = item.getAttribute('href');
				var searchTitleElement = item.querySelector('h2');
				var searchTitleText = searchTitleElement.innerText || searchTitleElement.textContent;
				dataLayer.push({
					event: 'clickoutSearch', //values are dynamic depending on the click out
					clickName: searchTitleText,
					clickPath: itemLink
				});
			}
		}
	}, {
		key: '_activate',
		value: function _activate() {
			var _this2 = this;

			this._root.addEventListener('transitionend', function () {
				_this2._button.setAttribute('aria-expanded', true);
				_this2._form.setAttribute('aria-hidden', false);
				setTimeout(function () {
					return _this2._field.focus();
				}, 100);
			}, {
				once: true
			});

			this._root.classList.add('site-search--is-expanded');
			document.body.classList.add('site-search--is-expanded');
			document.body.classList.add('has-overlay');
			document.body.addEventListener('touchmove', this._freezeViewport, {
				passive: false
			});

			this._button.textContent = this._button.getAttribute('data-label-hide');

			this._isExpanded = true;
		}
	}, {
		key: '_freezeViewport',
		value: function _freezeViewport(e) {
			e.preventDefault();
		}
	}, {
		key: '_quit',
		value: function _quit(e) {
			if (e && typeof e.preventDefault === 'function') e.preventDefault();

			this._button.setAttribute('aria-expanded', false);
			this._form.setAttribute('aria-hidden', true);

			this._button.textContent = this._button.getAttribute('data-label-show');

			this._root.classList.remove('site-search--is-expanded');
			document.body.classList.remove('site-search--is-expanded');
			document.body.classList.remove('has-overlay');
			document.body.removeEventListener('touchmove', this._freezeViewport, {
				passive: false
			});

			this._isExpanded = false;
		}
	}]);

	return HeaderSearchForm;
}();

var initPreventEmptySubmit = function initPreventEmptySubmit(el) {
	var fn = function fn(e) {
		var field = el.querySelector('input.site-search__field');
		if (field && field.value.length < 1) {
			e.preventDefault();
		}
	};
	el.addEventListener('submit', fn);
};

/**
 * [initResetAndFocus shows and hides a reset button which resets and focus the input field]
 * @method initResetAndFocus
 */
var initResetAndFocus = function initResetAndFocus() {
	var searchForm = document.querySelector('.search-results .site-search__form');
	var searchFormClass = 'site-search__form--active';
	var field = document.querySelector('.search-results .site-search__field');
	var resetBtn = document.querySelector('.js-search-field-reset');

	if (!field) return;

	var checkField = function checkField() {
		if (field && field.value.length > 0) {
			searchForm.classList.add(searchFormClass);
			resetBtn.setAttribute('style', 'opacity: 1; visibility: visible;');
		} else {
			searchForm.classList.remove(searchFormClass);
			resetBtn.setAttribute('style', 'opacity: 0; visibility: hidden;');
		}
	};

	var hideBtn = function hideBtn() {
		resetBtn.setAttribute('style', 'opacity: 0; visibility: hidden;');
		field.value = '';
		field.focus();
	};

	field.addEventListener('keyup', checkField);
	resetBtn.addEventListener('click', hideBtn);
	checkField();
};

var init = function init() {
	var allSearchElms = Array.from(document.querySelectorAll('.site-search__form'));
	allSearchElms.forEach(function (el) {
		// Prevent empty form submission on all search forms
		initPreventEmptySubmit(el);

		// Set search suggestions on all search forms
		new _searchSuggest2.default(el, el.querySelector('.site-search__field'));
	});

	initResetAndFocus();

	var headerSearch = document.getElementById('page-header__search');
	if (headerSearch) {
		new HeaderSearchForm();
	}
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_onswipe.js":46,"../Partials/_search-suggest.js":52,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],29:[function(require,module,exports){
'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _collapsible = require('../Partials/_collapsible.js');

var _collapsible2 = _interopRequireDefault(_collapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
	// Collapsibles in service-listing for small vp
	var listingCollapsible = Array.from(document.querySelectorAll('.services .js-collapsible'));
	listingCollapsible.forEach(function (el) {
		new _collapsible2.default(el, ['small']);
	});
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"../Partials/_collapsible.js":37,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],30:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var _createId = require('../Partials/_create-id.js');

var _createId2 = _interopRequireDefault(_createId);

var _onswipe = require('../Partials/_onswipe.js');

var _onswipe2 = _interopRequireDefault(_onswipe);

var _viewportstateWatcher = require('../Partials/_viewportstate-watcher.js');

var _viewportstateWatcher2 = _interopRequireDefault(_viewportstateWatcher);

var _luk = require('./_luk');

var _luk2 = _interopRequireDefault(_luk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A singleton dealing with the APK manual's collapsing navigation.
 *
 * @class SiteNavigation
 */
var FLYOUTNavigation = function () {
	function FLYOUTNavigation() {
		var _this = this;

		_classCallCheck(this, FLYOUTNavigation);

		this._navFlyout = document.querySelector('#site-navigation__flyout');
		this._primaryOpener = document.querySelector('#site-navigation__flyoutopener');

		this._panelTriggers = Array.from(document.querySelectorAll('#site-navigation__flyout > ul > li > a'));
		this._panels = Array.from(document.querySelectorAll('.flyout__child'));
		this._backButton = document.querySelector('#site-navigation__flyout__back');
		this._secondDaryNav = document.querySelector('#site-navigation__secondary');
		this._tertiaryNav = document.querySelector('#site-navigation__tertiary');
		this._navWrap = document.querySelector('#site-navigation__wrap');
		this._hasInitialised = false;
		this._openItem = null;
		this._openPanelItem = null;

		this._panels.forEach(function (panel, i) {
			var id = 'flyoutnav-' + (0, _createId2.default)();
			_this._panelTriggers[i].setAttribute('aria-labelledby', id);
			panel.setAttribute('id', id);
		});

		// this._navFlyout.addEventListener('click', (e) => e.stopPropagation());
		this._primaryOpener.addEventListener('focusin', function (e) {
			return e.stopPropagation();
		});
		this._primaryOpener.addEventListener('click', function (e) {
			e.stopPropagation();
			e.preventDefault();
		});

		this._handleClickPrimary = function (e) {
			_this._toggleFlyout();
		};

		this._handleClickPanelTrigger = function (e) {
			e.preventDefault();
			e.stopPropagation();
			_this._toggleFlyoutPanel(e.currentTarget);
		};

		this._handleClickBack = function (e) {
			e.preventDefault();
			e.stopPropagation();
			_this._hideOpenPanelItem();
		};

		// Deal with escape key
		this._closeOnEscape = function (e) {
			if (e.key === 'Escape' || e.key === 'Esc') {
				_this._exit(e);
			}
		};

		// Exit all
		this._exit = function (e) {
			// if (e.target.id === 'site-navigation__flyout') return
			_this._hideAll();
		};

		var timer = void 0;
		this._handleResize = function (e) {
			clearTimeout(timer);
			timer = setTimeout(function () {
				return _this._exit(e);
			}, 50);
		};

		// Stream init/uninit through viewportStateWatcher
		_viewportstateWatcher2.default.watch(['small', 'medium', 'mediumPlus', 'large', 'xlarge'], function () {
			return _this._init();
		}, function () {
			return _this._uninit();
		});
	}

	// Set attributes and event handlers


	_createClass(FLYOUTNavigation, [{
		key: '_init',
		value: function _init() {
			var _this2 = this;

			if (this._hasInitialised) return; // Don't initialise unless uninitialised
			this._hasInitialised = true;

			this._panelTriggers.forEach(function (panel) {
				panel.addEventListener('click', _this2._handleClickPanelTrigger);
				panel.addEventListener('focusin', _this2._handleClickPanelTrigger);
			});
			this._primaryOpener.addEventListener('click', this._handleClickPrimary);
			document.body.addEventListener('keyup', this._closeOnEscape);
			this._backButton.addEventListener('click', this._handleClickBack);
			// this._primaryOpener.addEventListener(
			//   'focusin',
			//   this._handleClickPrimary
			// );
			// document.body.addEventListener(
			//   'focusin',
			//   this._exit
			// );
			// document.body.addEventListener(
			//   'click',
			//   this._exit
			// );
			window.addEventListener('orientationchange', this._handleResize);
			// window.addEventListener(
			//   'resize',
			//   this._handleResize
			// );
		}

		// Remove attributes and event handlers

	}, {
		key: '_uninit',
		value: function _uninit() {
			var _this3 = this;

			this._hasInitialised = false;

			this._panelTriggers.forEach(function (panel) {
				panel.addEventListener('click', _this3._handleClickPanelTrigger);
				panel.addEventListener('focusin', _this3._handleClickPanelTrigger);
			});

			this._primaryOpener.removeEventListener('click', this._handleClickPrimary);
			this._primaryOpener.removeEventListener('keyup', this._closeOnEscape);
			this._primaryOpener.removeEventListener('focusin', this._focusOnItem);
			document.body.removeEventListener('focusin', this._exit);
			document.body.removeEventListener('click', this._exit);
			window.removeEventListener('orientationchange', this._handleResize);
			window.removeEventListener('resize', this._handleResize);
		}
	}, {
		key: '_toggleFlyoutPanel',
		value: function _toggleFlyoutPanel(panelTrigger) {
			this._navWrap.scrollTop = 0;
			if (this._openPanelItem !== null) {
				document.getElementById(this._openPanelItem.getAttribute('aria-labelledby')).classList.remove('is-expanded');
				this._openPanelItem.classList.remove('is-expanded');
				this._navFlyout.classList.remove('third-is-expanded');
				this._backButton.classList.remove('is-expanded');
				this._secondDaryNav.classList.remove('is-hidden');
				this._tertiaryNav.classList.remove('is-hidden');
			}
			this._navFlyout.classList.add('third-is-expanded');
			this._backButton.classList.add('is-expanded');
			panelTrigger.classList.add('is-expanded');
			this._secondDaryNav.classList.add('is-hidden');
			this._tertiaryNav.classList.add('is-hidden');

			document.getElementById(panelTrigger.getAttribute('aria-labelledby')).classList.add('is-expanded');
			this._openPanelItem = panelTrigger;
		}
	}, {
		key: '_hideOpenPanelItem',
		value: function _hideOpenPanelItem() {
			this._navWrap.scrollTop = 0;
			if (this._openPanelItem !== null) {
				this._backButton.classList.remove('is-expanded');
				this._navFlyout.classList.remove('third-is-expanded');
				this._secondDaryNav.classList.remove('is-hidden');
				this._tertiaryNav.classList.remove('is-hidden');
				document.getElementById(this._openPanelItem.getAttribute('aria-labelledby')).classList.remove('is-expanded');
				this._openPanelItem.classList.remove('is-expanded');
				this._openPanelItem = null;
			}
		}

		// Toggle individual item

	}, {
		key: '_toggleFlyout',
		value: function _toggleFlyout() {
			if (this._navFlyout.className.indexOf('is-expanded') >= 0) {
				this._hideAll();
			} else {
				this._showFlyout(this._navFlyout);
			}
		}

		// Show the main panel

	}, {
		key: '_showFlyout',
		value: function _showFlyout(item) {
			this._navFlyout.setAttribute('aria-expanded', 'true');
			// this._panels[i].setAttribute('aria-hidden', 'false');
			document.body.classList.add('has-overlay');
			this._navFlyout.classList.add('is-expanded');
			this._openItem = item;
			this._backButton.classList.remove('is-expanded');
		}
		// Hide the main panel

	}, {
		key: '_hideFlyout',
		value: function _hideFlyout(item) {
			// const i = this._items.indexOf(item);
			this._navFlyout.setAttribute('aria-expanded', 'false');
			// this._panels[i].setAttribute('aria-hidden', 'true');
			document.body.classList.remove('has-overlay');
			this._navFlyout.classList.remove('is-expanded');
			this._openItem = null;
		}

		// Hide all panels

	}, {
		key: '_hideAll',
		value: function _hideAll() {
			var _this4 = this;

			this._hideFlyout();
			this._hideOpenPanelItem();
			this._panelTriggers.forEach(function (item, i) {
				item.classList.remove('is-expanded');
				_this4._panels[i].classList.remove('is-expanded');
			});
		}
	}]);

	return FLYOUTNavigation;
}();

var init = function init() {
	// Create an instance on DOM ready
	if (document.querySelector('#site-navigation__flyout') !== null) {
		// let flyoutNavigation = new FLYOUTNavigation();
		// window.flyoutNavigation = flyoutNavigation
	}
};

// document.addEventListener('DOMContentLoaded', init, { once: true });
// const flyoutNavigation = new FLYOUTNavigation();
exports.default = FLYOUTNavigation;

},{"../Partials/_create-id.js":38,"../Partials/_onswipe.js":46,"../Partials/_viewportstate-watcher.js":58,"./_luk":20,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],31:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _onswipe = require('../Partials/_onswipe.js');

var _onswipe2 = _interopRequireDefault(_onswipe);

var _viewportstateWatcher = require('../Partials/_viewportstate-watcher.js');

var _viewportstateWatcher2 = _interopRequireDefault(_viewportstateWatcher);

var _siteNavigationFlyout = require('./_site-navigation-flyout');

var _siteNavigationFlyout2 = _interopRequireDefault(_siteNavigationFlyout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A singleton dealing with the page´s burger navigation.
 *
 * @class SiteNavigation
 */
var SiteNavigation = function () {
	function SiteNavigation() {
		var _this = this;

		_classCallCheck(this, SiteNavigation);

		this._header = document.querySelector('#page-header');
		this._toggleButton = document.querySelector('#site-navigation__toggle');
		this._panel = document.querySelector('#site-navigation__wrap');
		this._primary = document.querySelector('#site-navigation__primary') || document.querySelector('#apk-navigation__primary');
		this._secondary = document.querySelector('#site-navigation__secondary');
		this._showState = false;
		this._bodyScrollY = 0;
		this._hasInitialised = false;

		this._swipeHandler = new _onswipe2.default();
		this._swipeHandler.on('left', this._panel, function (event) {
			return _this._hide();
		}); // TODO: this should be set on init and removed on uninit, but swipeHandler is not yet fit for this

		// Handle toggle button clicks
		this._handleClick = function (event) {
			event.preventDefault();
			_this._toggle();
		};

		// Deal with escape key
		this._closeOnEscape = function (e) {
			if (e.key === 'Escape' || e.key === 'Esc') {
				if (_this._showState) {
					_this._hide();
					_this._toggleButton.focus();
				}
			}
		};

		// Deal with focus outside open panel
		this._handleFocusout = function (e) {
			if (!_this._header.contains(document.activeElement) && !document.querySelector('#site-navigation').contains(document.activeElement)) {
				_this._toggle();
			}
			// if (this._showState) {
			//     this._hide();
			//     this._toggleButton.focus();
			// }
		};

		// this._panel.addEventListener('focusin', (e) => e.stopPropagation());

		this._setARIAActive();

		// Stream init/uninit through viewportStateWatcher
		_viewportstateWatcher2.default.watch(['small', 'medium'], function () {
			if (_this._toggleButton === null) return;
			_this._init();
			_this._initState();
		}, function () {
			return _this._uninit();
		});
	}

	// Set attributes and event handlers


	_createClass(SiteNavigation, [{
		key: '_init',
		value: function _init() {
			if (this._hasInitialised) return; // Don't initialise unless uninitialised
			if (this._toggleButton === null) return; // Don't initialize without a toggle button

			this._hasInitialised = true;

			this._toggleButton.addEventListener('click', this._handleClick);
			this._header.addEventListener('keyup', this._closeOnEscape);

			this._toggleButton.setAttribute('aria-controls', 'site-navigation__wrap');
			this._toggleButton.removeAttribute('role');
			// this._toggleButton.textContent = this._toggleButton.getAttribute('data-label-show');
		}

		// Remove attributes and event handlers

	}, {
		key: '_uninit',
		value: function _uninit() {
			this._hasInitialised = false;

			if (this._toggleButton === null) return; // Don't initialize without a toggle button

			this._toggleButton.removeEventListener('click', this._handleClick);
			this._header.removeEventListener('keyup', this._closeOnEscape);

			this._toggleButton.removeAttribute('aria-controls');
			this._toggleButton.removeAttribute('aria-expanded');
			this._toggleButton.setAttribute('role', 'heading');
			this._panel.removeAttribute('aria-hidden', 'false');
		}

		// Kick off the initial/current state of the collapsible

	}, {
		key: '_initState',
		value: function _initState() {
			if (this._showState) {
				this._show(false);
			} else {
				this._hide(false);
			}
		}
	}, {
		key: '_toggle',
		value: function _toggle() {
			if (this._showState) {
				this._hide();
				document.removeEventListener('focus', this._handleFocusout, true);
			} else {
				this._show();
				document.addEventListener('focus', this._handleFocusout, true);
			}
		}

		// Show the panel

	}, {
		key: '_show',
		value: function _show() {
			var _this2 = this;

			var animBool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this._showState = true;
			this._getBodyScrollY();
			this._toggleButton.setAttribute('aria-expanded', 'true');
			// this._toggleButton.textContent = this._toggleButton.getAttribute('data-label-hide');
			this._panel.setAttribute('aria-hidden', 'false');

			if (animBool) {
				this._panel.addEventListener('transitionend', function () {
					document.documentElement.classList.add('disable-scrolling');
					_this2._header.classList.remove('is-animating');
				}, { once: true });
				this._header.classList.add('is-animating');
			} else {
				document.documentElement.classList.add('disable-scrolling');
			}

			this._header.classList.add('is-expanded');
		}

		// Hide the panel

	}, {
		key: '_hide',
		value: function _hide() {
			var _this3 = this;

			var animBool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this._showState = false;
			this._toggleButton.setAttribute('aria-expanded', 'false');
			// this._toggleButton.textContent = this._toggleButton.getAttribute('data-label-show');
			this._panel.setAttribute('aria-hidden', 'true');
			if (window.flyoutNavigation) {
				window.flyoutNavigation._hideAll();
			}
			if (animBool) {
				this._panel.addEventListener('transitionend', function () {
					return _this3._header.classList.remove('is-animating');
				}, { once: true });
				this._header.classList.add('is-animating');
			}

			document.documentElement.classList.remove('disable-scrolling');

			this._header.classList.remove('is-expanded');
			this._setBodyScrollY();
		}
	}, {
		key: '_getBodyScrollY',
		value: function _getBodyScrollY() {
			this._bodyScrollY = window.scrollY;
		}
	}, {
		key: '_setBodyScrollY',
		value: function _setBodyScrollY() {
			window.scroll(window.scrollX, this._bodyScrollY);
		}

		/**
   * Moves the ID attr with value {str} to the 'active' list item (has a classname of 'is-active')
   * and moves the aria-current attribute to that list item as well, for the purpose of disclosing
   * the active navigation item to assistive devices
   *
   * @memberOf SiteNavigation
   */

	}, {
		key: '_setARIAActive',
		value: function _setARIAActive() {
			function parse(el, str) {
				if (el && str) {
					var a = el.querySelector('#' + str);
					if (a) {
						a.removeAttribute('id');
					}

					var b = el.querySelector('[aria-current]');
					if (b) {
						b.removeAttribute('aria-current');
					}

					var c = el.querySelector('li.is-active > a');
					if (c) {
						c.setAttribute('id', str);
						c.setAttribute('aria-current', 'true');
					}
				}
			}

			parse(this._primary, 'site-navigation__primary__active');
			parse(this._secondary, 'site-navigation__secondary__active');
		}
	}]);

	return SiteNavigation;
}();

var init = function init() {
	// Create an instance on DOM ready
	if (document.querySelector('#page-header') !== null) {
		var siteNavigation = new SiteNavigation();
	}
};

document.addEventListener('DOMContentLoaded', init, { once: true });
exports.default = SiteNavigation;

},{"../Partials/_onswipe.js":46,"../Partials/_viewportstate-watcher.js":58,"./_site-navigation-flyout":30}],32:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TabNav = function () {
	function TabNav(tabsContainer, contentContainer) {
		var _this = this;

		_classCallCheck(this, TabNav);

		if (!tabsContainer || !contentContainer) {
			return;
		}
		this.tabs = Array.from(tabsContainer.querySelectorAll('[role="tab"]'), function (tab) {
			return {
				tab: tab,
				content: contentContainer.querySelector('[aria-labelledby="' + tab.id + '"]')
			};
		});
		this.contentContainer = contentContainer;
		document.addEventListener('keyup', function (ev) {
			return _this.keyup(ev);
		});
		this.tabs.forEach(function (tab) {
			return tab.tab.addEventListener('click', function () {
				return _this.toggleTab(tab)();
			});
		});
		this.tabs.forEach(function (tab) {
			var nextTabButton = tab.content.querySelector('[data-next-tab]');
			if (nextTabButton) nextTabButton.addEventListener('click', function () {
				return _this.nextTab(tab)();
			});
		});
	}

	_createClass(TabNav, [{
		key: 'toggleTab',
		value: function toggleTab(triggeringTab) {
			var _this2 = this;

			return function () {
				_this2.tabs.forEach(function (tab) {
					tab.content.classList.toggle('visible', false);
					tab.tab.classList.toggle('active', false);
					tab.tab.setAttribute('aria-selected', 'false');
				});
				var currentIndex = _this2.tabs.findIndex(function (tab) {
					return tab === triggeringTab;
				});
				_this2.contentContainer.style.transform = 'translateX(-' + currentIndex * 100 + '%)';
				triggeringTab.content.classList.toggle('visible', true);
				triggeringTab.content.setAttribute('tabindex', '0');
				triggeringTab.tab.classList.toggle('active', true);
				triggeringTab.tab.setAttribute('aria-selected', 'true');
			};
		}
	}, {
		key: 'nextTab',
		value: function nextTab(activeTab) {
			var _this3 = this;

			return function () {
				var activeIndex = _this3.tabs.findIndex(function (tab) {
					return tab === activeTab;
				});
				_this3.toggleTab(_this3.tabs[(activeIndex + 1) % _this3.tabs.length])();
			};
		}
	}, {
		key: 'keyup',
		value: function keyup(e) {
			var activeIndex = this.tabs.findIndex(function (tab) {
				return tab.tab === document.activeElement;
			});
			//break if no tab is active
			if (activeIndex === -1) return;else if (e.key === 'ArrowLeft' || e.key === 'Left') this.tabs[(activeIndex || this.tabs.length) - 1].tab.focus();else if (e.key === 'ArrowRight' || e.key === 'Right') this.tabs[(activeIndex + 1) % this.tabs.length].tab.focus();
		}
	}]);

	return TabNav;
}();

exports.default = TabNav;

},{}],33:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Lightbox = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _trapFocus = require('../Helpers/trap-focus');

var _trapFocus2 = _interopRequireDefault(_trapFocus);

var _slideshow = require('./slideshow');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Lightbox = exports.Lightbox = function () {
	function Lightbox(container) {
		_classCallCheck(this, Lightbox);

		this.container = container;
		this.zoom = this.container.querySelector('.lightbox__zoom');

		this.events();
	}

	_createClass(Lightbox, [{
		key: 'events',
		value: function events() {
			if (this.zoom) {
				this.zoom.removeEventListener('click', this.openLightbox.bind(this));
				this.zoom.addEventListener('click', this.openLightbox.bind(this));
			}
		}
	}, {
		key: 'handleKeydown',
		value: function handleKeydown(e) {
			if (e.key === 'Escape') {
				this.closeLightbox();
			}
		}
	}, {
		key: 'removeEventListeners',
		value: function removeEventListeners() {
			this.close.removeEventListener('click', this.closeLightbox.bind(this));
			this.background.removeEventListener('click', this.closeLightbox.bind(this));
			document.removeEventListener('keydown', this.handleKeydown.bind(this));
		}
	}, {
		key: 'closeLightbox',
		value: function closeLightbox() {
			new _slideshow.SlideShow(this.container, this.lightboxHasActiveTrigger());
			_trapFocus2.default.endTrapFocus();

			this.container.classList.remove('lightbox--open');
			document.documentElement.classList.remove('hide-scrollbars', 'hide-scrollbars--lower');

			if (this.lightbox) {
				this.removeEventListeners();
				this.lightbox.remove();
			}
		}
	}, {
		key: 'openLightbox',
		value: function openLightbox() {
			if (!this.container.classList.contains('lightbox--open')) {
				this.container.classList.add('lightbox--open');

				this.background = document.createElement('div');
				this.background.classList.add('lightbox__background');
				this.background.addEventListener('click', this.closeLightbox.bind(this));

				this.lightbox = document.createElement('div');
				this.lightbox.classList.add('lightbox__wrapper');
				this.lightbox.append(this.container.cloneNode(true));

				this.lightbox.querySelectorAll('[id]').forEach(function (element) {
					element.setAttribute('id', 'lightbox-' + element.id);
				});
				this.lightbox.querySelectorAll('[aria-controls]').forEach(function (element) {
					element.setAttribute('aria-controls', 'lightbox-' + element.getAttribute('aria-controls'));
				});

				this.lightbox.append(this.background);
				document.body.append(this.lightbox);
				new _slideshow.SlideShow(this.lightbox, this.hasActiveTrigger());

				this.close = this.lightbox.querySelector('.lightbox__close');
				if (this.close) {
					this.close.addEventListener('click', this.closeLightbox.bind(this));
				}

				var zoom = this.lightbox.querySelector('.lightbox__zoom');
				if (zoom) {
					zoom.remove();
				}

				_trapFocus2.default.startTrapFocus(this.lightbox);

				this.lightbox.classList.add('lightbox__wrapper--fade-in');
				document.documentElement.classList.add('hide-scrollbars', 'hide-scrollbars--lower');

				document.addEventListener('keydown', this.handleKeydown.bind(this));
			}
		}
	}, {
		key: 'lightboxHasActiveTrigger',
		value: function lightboxHasActiveTrigger() {
			var triggers = this.lightbox.querySelectorAll('.slideshow__trigger');
			var activeTrigger = this.lightbox.querySelector('.slideshow__trigger--active');

			return Array.from(triggers).indexOf(activeTrigger) + 1;
		}
	}, {
		key: 'hasActiveTrigger',
		value: function hasActiveTrigger() {
			var triggers = this.container.querySelectorAll('.slideshow__trigger');
			var activeTrigger = this.container.querySelector('.slideshow__trigger--active');

			return Array.from(triggers).indexOf(activeTrigger) + 1;
		}
	}]);

	return Lightbox;
}();

document.querySelectorAll('.lightbox:not(.disable-scripting)').forEach(function (container) {
	new Lightbox(container);
});

},{"../Helpers/trap-focus":2,"./slideshow":34}],34:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SlideShow = exports.SlideShow = function () {
	function SlideShow(container) {
		var slideIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

		_classCallCheck(this, SlideShow);

		this.loop = container.dataset.loop === '';
		this.slideIndex = slideIndex;
		this.touchstartX = 0;
		this.touchendX = 0;

		this.container = container;
		this.slides = this.container.querySelectorAll('.slideshow__slide');
		this.slidesLength = this.slides.length;
		this.triggers = this.container.querySelectorAll('.slideshow__trigger');
		this.prev = this.container.querySelector('.slideshow__prev');
		this.next = this.container.querySelector('.slideshow__next');
		this.triggersPrev = this.container.querySelector('.slideshow__triggers-prev');
		this.triggersNext = this.container.querySelector('.slideshow__triggers-next');

		this.init();
		this.events();
	}

	_createClass(SlideShow, [{
		key: 'destroy',
		value: function destroy() {
			var _this = this;

			this.container.removeEventListener('keydown', this.navigate.bind(this));

			if (this.prev) {
				this.prev.removeEventListener('click', this.handlePrevClick.bind(this));
			}
			if (this.next) {
				this.next.removeEventListener('click', this.handleNextClick.bind(this));
			}

			if (this.triggersPrev) {
				this.triggersPrev.removeEventListener('click', this.handlePrevClick.bind(this));
			}

			if (this.triggersNext) {
				this.triggersNext.removeEventListener('click', this.handleNextClick.bind(this));
			}

			this.triggers.forEach(function (trigger, index) {
				trigger.removeEventListener('click', function () {
					return _this.showSlide(index + 1);
				});
			});

			this.container.removeEventListener('touchstart', this.moveStart.bind(this));
			this.container.removeEventListener('touchend', this.moveEnd.bind(this));
		}
	}, {
		key: 'init',
		value: function init() {
			this.showSlide(this.slideIndex, true);

			this.triggers.forEach(function (trigger, index) {
				trigger.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
			});

			if (!this.loop) {
				if (this.prev && this.slideIndex === 1) {
					this.prev.setAttribute('disabled', 'true');
				}

				if (this.triggersPrev && this.slideIndex === 1) {
					this.triggersPrev.setAttribute('disabled', 'true');
				}
			}
		}
	}, {
		key: 'events',
		value: function events() {
			var _this2 = this;

			this.destroy();

			this.container.addEventListener('keydown', this.navigate.bind(this));

			if (this.prev) {
				this.prev.addEventListener('click', this.handlePrevClick.bind(this));
			}
			if (this.next) {
				this.next.addEventListener('click', this.handleNextClick.bind(this));
			}

			if (this.triggersPrev) {
				this.triggersPrev.addEventListener('click', this.handlePrevClick.bind(this));
			}

			if (this.triggersNext) {
				this.triggersNext.addEventListener('click', this.handleNextClick.bind(this));
			}

			this.triggers.forEach(function (trigger, index) {
				trigger.addEventListener('click', function () {
					return _this2.showSlide(index + 1);
				});
			});

			this.container.addEventListener('touchstart', this.moveStart.bind(this));
			this.container.addEventListener('touchend', this.moveEnd.bind(this));
		}
	}, {
		key: 'handleNextClick',
		value: function handleNextClick(e) {
			this.nextSlide(e.target);
		}
	}, {
		key: 'handlePrevClick',
		value: function handlePrevClick(e) {
			this.prevSlide(e.target);
		}
	}, {
		key: 'moveStart',
		value: function moveStart(e) {
			this.touchstartX = e.changedTouches[0].screenX;
		}
	}, {
		key: 'moveEnd',
		value: function moveEnd(e) {
			this.touchendX = e.changedTouches[0].screenX;
			this.checkDirection();
		}
	}, {
		key: 'checkDirection',
		value: function checkDirection() {
			if (this.touchendX < this.touchstartX) {
				this.nextSlide();
			}

			if (this.touchendX > this.touchstartX) {
				this.prevSlide();
			}
		}
	}, {
		key: 'navigate',
		value: function navigate(e) {
			var keyboardEvent = e;
			if (keyboardEvent.code !== 'Tab' && keyboardEvent.code !== 'Enter') {
				keyboardEvent.preventDefault();
			}

			if (keyboardEvent.code === 'ArrowLeft' || keyboardEvent.code === 'ArrowDown') {
				this.prevSlide();
			}

			if (keyboardEvent.code === 'ArrowRight' || keyboardEvent.code === 'ArrowUp') {
				this.nextSlide();
			}

			if (keyboardEvent.code === 'Home') {
				this.showSlide(1);
			}

			if (keyboardEvent.code === 'End') {
				this.showSlide(this.slidesLength);
			}
		}
	}, {
		key: 'prevSlide',
		value: function prevSlide() {
			var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (this.slideIndex > 1) {
				this.showSlide(this.slideIndex - 1);
			} else if (this.loop) {
				this.showSlide(this.slidesLength);
			}

			if (element) {
				element.focus();
			}
		}
	}, {
		key: 'nextSlide',
		value: function nextSlide() {
			var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (this.slideIndex < this.slidesLength) {
				this.showSlide(this.slideIndex + 1);
			} else if (this.loop) {
				this.showSlide(1);
			}

			if (element) {
				element.focus();
			}
		}
	}, {
		key: 'showSlide',
		value: function showSlide(index) {
			var refocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			this.slideIndex = index;

			if (!this.loop) {
				if (this.prev && this.slideIndex > 1) {
					this.prev.removeAttribute('disabled');
				}
				if (this.next && this.slideIndex < this.slidesLength) {
					this.next.removeAttribute('disabled');
				}
				if (this.triggersPrev && this.slideIndex > 1) {
					this.triggersPrev.removeAttribute('disabled');
				}
				if (this.triggersNext && this.slideIndex < this.slidesLength) {
					this.triggersNext.removeAttribute('disabled');
				}

				if (this.slideIndex === 1) {
					if (this.prev) {
						this.prev.setAttribute('disabled', 'true');
					}
					if (this.triggersPrev) {
						this.triggersPrev.setAttribute('disabled', 'true');
					}
				}
				if (this.slideIndex === this.slidesLength) {
					if (this.next) {
						this.next.setAttribute('disabled', 'true');
					}
					if (this.triggersNext) {
						this.triggersNext.setAttribute('disabled', 'true');
					}
				}
			}

			if (this.slideIndex > this.slidesLength) {
				this.slideIndex = 1;
			}
			if (this.slideIndex < 1) {
				this.slideIndex = this.slidesLength;
			}

			for (var i = 0; i < this.slidesLength; i++) {
				this.slides[i].classList.remove('slideshow__slide--active');
				this.triggers[i].classList.remove('slideshow__trigger--active');
				this.triggers[i].setAttribute('aria-selected', 'false');
			}

			if (this.slidesLength > 0) {
				var activeTrigger = this.triggers[this.slideIndex - 1];

				this.slides[this.slideIndex - 1].classList.add('slideshow__slide--active');
				activeTrigger.classList.add('slideshow__trigger--active');
				activeTrigger.setAttribute('aria-selected', 'true');

				if (refocus) {
					activeTrigger.focus();
				}
			}
		}
	}]);

	return SlideShow;
}();

document.querySelectorAll('.slideshow:not(.disable-scripting)').forEach(function (container) {
	new SlideShow(container);
});

},{}],35:[function(require,module,exports){
'use strict';

require('core-js/fn/array/for-each');

/**
 * A small script that sets a classname on the HTML element to allow CSS to get around very specific problems that can't be fixed otherwise
 * Remember, kids. UA detection is still a sin.
 *
 */
var detect = function detect() {
	var uaMap = [{
		// iOS Safari (not Chrome)
		regexp: /^((?!chrome|android|CriOS).)*safari/i,
		className: 'is-ios-safari'
	}];
	var uaStr = navigator.userAgent;
	uaMap.forEach(function (el) {
		if (el.regexp.test(uaStr)) {
			document.documentElement.classList.add(el.className);
		}
	});
};

document.addEventListener('DOMContentLoaded', detect, { once: true });

},{"core-js/fn/array/for-each":63}],36:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/fn/array/from');

require('./_matches.js');

var _createId = require('./_create-id.js');

var _createId2 = _interopRequireDefault(_createId);

var _viewportstateWatcher = require('./_viewportstate-watcher.js');

var _viewportstateWatcher2 = _interopRequireDefault(_viewportstateWatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CollapsibleExpandList = function () {
	function CollapsibleExpandList(el) {
		var _this = this;

		var viewportStates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

		_classCallCheck(this, CollapsibleExpandList);

		this._root = el;
		this._maxItemsShown = 5;
		this._itemsList = el.querySelector('.js-collapsible-expand-list__items');
		this._items = Array.from(el.querySelectorAll('.js-collapsible-expand-list__item'));

		if (this._items.length <= this._maxItemsShown) return;

		this._btnTextShow = this._root.getAttribute('data-collapsible-expand-list-show') || 'Meer';
		this._btnTextHide = this._root.getAttribute('data-collapsible-expand-list-hide') || 'Minder';

		this._showState = false;
		this._hasInitialised = false;
		this._toggleCollapseHandler = this._toggleCollapse.bind(this);

		this._resizeTimer = null;
		this._resizeHandler = function () {
			clearTimeout(_this._resizeTimer);
			_this._resizeTimer = setTimeout(function () {
				return _this._initState();
			}, 50);
		};

		// Stream init/uninit through viewportStateWatcher
		_viewportstateWatcher2.default.watch(viewportStates, function () {
			_this._init();
			//setTimeout(() => this._initState(), 10);
			_this._initState();
		}, function () {
			return _this._uninit();
		});
	}

	_createClass(CollapsibleExpandList, [{
		key: '_init',
		value: function _init() {
			if (this._hasInitialised) return; // Don't initialise unless uninitialised
			this._hasInitialised = true;

			// Calc height of items
			//this._calcItemsHeight();

			var bodyId = this._root.id || (0, _createId2.default)();
			this._root.setAttribute('id', bodyId);

			this._btn = document.createElement('button');
			this._btn.textContent = this._btnTextShow;
			this._btn.classList.add('expand-list-listing__toggle');
			this._btn.setAttribute('aria-controls', bodyId);
			this._root.appendChild(this._btn);

			this._btn.addEventListener('click', this._toggleCollapseHandler);

			window.addEventListener('resize', this._resizeHandler);
			window.addEventListener('orientationchange', this._resizeHandler);
		}
	}, {
		key: '_uninit',
		value: function _uninit() {
			this._hasInitialised = false;
			this._showState = false;
			this._itemsList.removeAttribute('style');
			if (this._btn) this._btn.remove();

			clearTimeout(this._resizeTimer);

			window.removeEventListener('resize', this._resizeHandler);
			window.removeEventListener('orientationchange', this._resizeHandler);
		}
	}, {
		key: '_initState',
		value: function _initState() {
			if (this._showState) {
				this.show(false);
			} else {
				this.hide(false);
			}
		}
	}, {
		key: '_toggleCollapse',
		value: function _toggleCollapse() {
			if (this._showState) {
				this.hide();
			} else {
				this.show();
			}
		}
	}, {
		key: 'hide',
		value: function hide() {
			var _this2 = this;

			var animBool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this._btn.setAttribute('aria-expanded', 'false');
			this._root.classList.remove('is-expanded');
			this._btn.textContent = this._btnTextShow;
			this._showState = false;

			for (var i = this._maxItemsShown; i < this._items.length; i += 1) {
				this._items[i].setAttribute('aria-hidden', true);
				this._items[i].classList.add('is-hidden');
			}

			this._setHeight(this._getHeight(this._maxItemsShown));

			if (animBool) {
				this._root.classList.add('is-animating');
				this._root.addEventListener('transitionend', function () {
					return _this2._root.classList.remove('is-animating');
				}, { once: true });
			}
		}
	}, {
		key: 'show',
		value: function show() {
			var _this3 = this;

			var animBool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this._btn.setAttribute('aria-expanded', 'true');
			this._root.classList.add('is-expanded');
			this._btn.textContent = this._btnTextHide;
			this._showState = true;

			for (var i = this._maxItemsShown; i < this._items.length; i += 1) {
				this._items[i].setAttribute('aria-hidden', false);
				this._items[i].classList.remove('is-hidden');
			}

			this._setHeight(this._getHeight(this._items.length));

			if (animBool) {
				this._root.classList.add('is-animating');
				this._root.addEventListener('transitionend', function () {
					return _this3._root.classList.remove('is-animating');
				}, { once: true });
			}
		}
	}, {
		key: '_setHeight',
		value: function _setHeight(h) {
			this._itemsList.style.height = h + 'px';
		}
	}, {
		key: '_getHeight',
		value: function _getHeight(n) {
			var h = 0;
			for (var i = 0; i < n; i += 1) {
				var styles = window.getComputedStyle(this._items[i]);
				var margin = parseFloat(styles['margin-top']) + parseFloat(styles['margin-bottom']);

				h += this._items[i].offsetHeight + margin;
			}

			return h;
		}
	}]);

	return CollapsibleExpandList;
}();

exports.default = CollapsibleExpandList;

},{"./_create-id.js":38,"./_matches.js":45,"./_viewportstate-watcher.js":58,"core-js/fn/array/from":64}],37:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createId = require('../Partials/_create-id.js');

var _createId2 = _interopRequireDefault(_createId);

var _viewportstateWatcher = require('../Partials/_viewportstate-watcher.js');

var _viewportstateWatcher2 = _interopRequireDefault(_viewportstateWatcher);

var _pubsub = require('../Partials/_pubsub.js');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _smoothscrollPolyfill = require('smoothscroll-polyfill');

var _smoothscrollPolyfill2 = _interopRequireDefault(_smoothscrollPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

_smoothscrollPolyfill2.default.polyfill();

/**
 * Creates collapsible functionality on a DOM element. It looks for classnames to determine what is the
 * trigger element (.js-collapsible__trigger) and the body element (.js-collapsible__body). Relevant ARIA
 * attributes on this collapsible are set automatically.
 *
 * The inner working of this collapsible comes down to hiding and showing the body upon trigger interaction. In order
 * to enable the animation, the wrapping element is set to the height of trigger + body, then quickly to the height of
 * just the trigger; CSS transition will cause the animation effect. The closing animation runs this sequence in reverse.
 * Because animation only needs to happen upon user interaction and not on (re-)initialisation, during the opening/closing
 * the is-animating class name is set on the wrapping element; this can be used in a selector in CSS. After this height-
 * setting sequence, a callback function hooked to a transitionend event listener causes the wrapping element to be set
 * back to height 'auto'.
 *
 * Most presentation is set via (custom) CSS. However, setting ARIA attributes - and also removing them again - requires
 * JavaScript to detect that a browser passes a breakpoint; or rather, the attributes are set following initialization and
 * unset through uninitialisation. Via viewportStateWatcher.watch() are these processes run when matching the browser'<s></s>
 * current viewport state. With this, a collapsible can init within small viewport range and uninit beyond larger breakpoints.
 * See documentation of _viewportstate-watcher.js for details.
 *
 * @class Collapsible
 */

var Collapsible = function () {
	/**
  * Creates an instance of Collapsible.
  *
  * @param {HTMLElement} el - Wrapping DOM element, the root element
  * @param {string, array} [viewportStates='all'] - An optional string or array that makes the collapsible functionality active for given viewport states (see Partials/_viewportstate-watcher.js)
  * @param {HTMLElement} trigger - An optional DOM element that serves as the trigger for this Collapsible instance. By default, Collapsible searches for a trigger within el.
  * @param {string, array} [groupBehaviorOn='all'] - An optional string or array that makes the group behavior active for given viewport states (see Partials/_viewportstate-watcher.js).
  *
  * @memberOf Collapsible
  *
  * @example
  * let el = document.querySelector('.foo');
  * let foo = new Collapsible(el, 'small');
  */
	function Collapsible(el) {
		var viewportStates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

		var _this2 = this;

		var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		var groupBehaviorOn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'all';

		_classCallCheck(this, Collapsible);

		this._root = el;
		this._colbody = el.querySelector('.js-collapsible__body');
		this._coltrigger = trigger || el.querySelector('.js-collapsible__trigger');
		this._colGroupId = el.getAttribute('data-collapsible-group');
		this._colGroupEventName = 'close-group-' + this._colGroupId;
		this._colGroupSiblingeventName = 'sibling-group-open-' + this._colGroupId;
		this._listeningToGroupEvent = true;
		this._groupHasOpenMembers = false;
		this._groupBehaviorOn = groupBehaviorOn;
		this._isGroupBehaviorActive = false;
		this._showDelay = 500;

		this._labelTextShow = '(Dicht)';
		this._labelTextHide = '(Open)';

		this._showState = this.foundInSession();

		this._hasInitialised = false;

		this._handleAction = function (event) {
			var isAnchor = _this2._coltrigger.nodeName === 'A';
			event.preventDefault();
			if (event.type === 'keyup' && (event.keyCode === 13 || event.keyCode === 32) || event.type === 'click' && event.x > 0 && event.y > 0 // X/Y check to make sure enter key doesn't execute as a click event here
			) {
					if (_this2._colGroupId && _this2._isGroupBehaviorActive) {
						_this2._clickDelayHandler();
					} else {
						_this2._toggle();
					}
				}
		};

		this._handleKeydown = function (event) {
			var keys = [32];
			if (keys.indexOf(event.keyCode) > -1) {
				event.preventDefault();
			}
		};

		/*
   * This function is used to determine whether group members need to be
   * closed first. Also, all group members are told whether they have
   * siblings that are open.
   *
   */
		this._clickDelayHandler = function () {
			// The target is open
			if (_this2._showState) {
				_this2._toggle();
				_pubsub2.default.emit(_this2._colGroupSiblingeventName, false);
			}
			// The target is closed and has no other open group members
			else if (!_this2._showState && !_this2._groupHasOpenMembers) {
					_this2._toggle();
					_pubsub2.default.emit(_this2._colGroupSiblingeventName, true);
				}
				// The target is closed and does have other open group members
				else if (!_this2._showState && _this2._groupHasOpenMembers) {
						_pubsub2.default.emit(_this2._colGroupEventName, _this2._colGroupId);
						setTimeout(function () {
							_this2._toggle();
						}, _this2._showDelay);
					}
		};

		/* Listen to emitted event to close other links of the group.
   *
   * If the current instance of Collapsible is part of a group
   * (indicated by a data-collapsible-group="#" on the root element),
   * then set up an event listener with the group number. This event is
   * handled by _pubsub.js.
   *
   * For the callback: If the current instance is listening for group
   * events (always, unless this instance is not part of a group or when
   * the current instance emitted the event) and is currently expanded on
   * the page, hide the current Collapsible.
   *
   */
		this._onPubSubEvents = function () {
			if (_this2._colGroupId) {
				_pubsub2.default.on(_this2._colGroupEventName, function (id) {
					if (_this2._listeningToGroupEvent && _this2._showState && id === _this2._colGroupId) {
						_this2.hide();
					}
					_this2._listeningToGroupEvent = true;
				});
				_pubsub2.default.on(_this2._colGroupSiblingeventName, function (boolean) {
					_this2._groupHasOpenMembers = boolean;
				});
			}
		};

		this._onPubSubEvents();

		// Toggle group behavior on groupBehaviorOn array of sizes
		_viewportstateWatcher2.default.watch(groupBehaviorOn, function () {
			return _this2._isGroupBehaviorActive = true;
		}, function () {
			_pubsub2.default.emit(_this2._colGroupEventName, _this2._colGroupId);
			_this2._isGroupBehaviorActive = false;
		});

		this._handleRootTransition = function () {
			return _this2._resetH();
		};

		// Stream init/uninit through viewportStateWatcher
		_viewportstateWatcher2.default.watch(viewportStates, function () {
			_this2.init();
			_this2.initState();
		}, function () {
			return _this2.uninit();
		});
	}

	// Manipulate DOM element, set attributes and event handlers


	_createClass(Collapsible, [{
		key: 'init',
		value: function init() {
			if (this._hasInitialised) return; // Don't initialise unless uninitialised
			this._hasInitialised = true;

			// in case we want to expand and scroll to an item, add the class highlighted to the html
			if (this._root.classList.contains('highlighted')) {
				this.show(true);
				var _this = this;
				var kb = document.querySelector('iframe#kb');
				if (kb) {
					kb.addEventListener('load', function () {
						setTimeout(function () {
							_this._root.scrollIntoView({ behavior: 'smooth' });
						}, 100);
					});
				} else {
					setTimeout(function () {
						_this._root.scrollIntoView({ behavior: 'smooth' });
					}, 100);
				}
			}

			// Interaction event listeners
			this._coltrigger.addEventListener('click', this._handleAction);
			this._coltrigger.addEventListener('keyup', this._handleAction);
			this._coltrigger.addEventListener('keydown', this._handleKeydown);
			this._root.addEventListener('transitionend', this._handleRootTransition);

			// Set initial ARIA attributes
			var bodyId = this._colbody.id || 'collapsible-' + (0, _createId2.default)();
			this._colbody.setAttribute('id', bodyId);
			this._coltrigger.setAttribute('aria-controls', bodyId);
			this._coltrigger.setAttribute('tabindex', '0');
		}

		// Remove event handlers, styles that were set, some ARIA attributes

	}, {
		key: 'uninit',
		value: function uninit() {
			this._hasInitialised = false;

			// Interaction event listeners
			this._coltrigger.removeEventListener('click', this._handleAction);
			this._coltrigger.removeEventListener('keyup', this._handleAction);
			this._coltrigger.removeEventListener('keydown', this._handleKeydown);
			this._root.removeEventListener('transitionend', this._handleRootTransition);

			// Remove ARIA attributes
			this._coltrigger.removeAttribute('role');
			this._coltrigger.removeAttribute('tabindex');
			this._coltrigger.removeAttribute('aria-expanded');
			this._coltrigger.removeAttribute('aria-controls');
			this._colbody.removeAttribute('aria-hidden');

			// Remove styles
			this._root.removeAttribute('style');
			this._colbody.removeAttribute('style');
		}

		// Kick off the initial/current state of the collapsible

	}, {
		key: 'initState',
		value: function initState() {
			if (this._showState) {
				this.show(false);
			} else {
				this.hide(false);
			}
		}
	}, {
		key: '_toggle',
		value: function _toggle() {
			if (this._showState) {
				this.hide();
			} else {
				this.show();
			}
		}
	}, {
		key: '_getH',
		value: function _getH(el) {
			return el.offsetHeight;
		}

		// Set the height of the root element

	}, {
		key: '_setH',
		value: function _setH(h) {
			this._root.style.height = h + 'px';
		}

		// Reset the height of the root element

	}, {
		key: '_resetH',
		value: function _resetH() {
			this._root.classList.remove('is-animating');
			this._coltrigger.classList.remove('is-animating');
			this._root.style.height = 'auto';
		}

		// Set a height of h1, quickly followed by h2 (timeout is for browser to update DOM)

	}, {
		key: '_fromTo',
		value: function _fromTo(h1, h2) {
			var _this3 = this;

			this._setH(h1);
			setTimeout(function () {
				_this3._root.classList.add('is-animating');
				_this3._coltrigger.classList.add('is-animating');
			}, 50);
			setTimeout(function () {
				_this3._setH(h2);
			}, 100);
		}
	}, {
		key: '_showBody',
		value: function _showBody() {
			this._colbody.style.position = 'static';
			this._colbody.style.visibility = 'visible';
			this._colbody.style.opacity = '1';
		}
	}, {
		key: '_hideBody',
		value: function _hideBody() {
			this._colbody.style.position = 'absolute';
			this._colbody.style.visibility = 'hidden';
			this._colbody.style.opacity = '0';
		}

		/**
   * Sets the show state on the collapsible, along with ARIA attributes
   *
   * @param {boolean} [animBool=true] - Adds an animation class name (is-animating) on the root element that can be used in CSS to hook a transition
   *
   * @memberOf Collapsible
   */

	}, {
		key: 'show',
		value: function show() {
			var _this4 = this;

			var animBool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this.addToSession();
			setTimeout(function () {
				_this4._root.classList.add('is-expanded');
				_this4._coltrigger.classList.add('is-expanded');
			}, 50);
			this._showState = true;

			var fn = function fn() {
				_this4._coltrigger.setAttribute('aria-expanded', 'true');
				_this4._colbody.setAttribute('aria-hidden', 'false');
			};

			if (animBool) {
				this._root.addEventListener('transitionend', fn, { once: true });
				this._fromTo(this._getH(this._coltrigger), // Height of the trigger
				this._getH(this._coltrigger) + this._getH(this._colbody) // Height of trigger + body
				);
				this.scrollIntoView();
			} else {
				fn();
				this._resetH();
			}

			this._showBody();
		}

		/**
   * Unsets the show state on the collapsible, along with ARIA attributes
   *
   * @param {boolean} [animBool=true] - Adds an animation class name (is-animating) on the root element that can be used in CSS to hook a transition
   *
   * @memberOf Collapsible
   */

	}, {
		key: 'hide',
		value: function hide() {
			var _this5 = this;

			var animBool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			// assumption, hiding is initiated with a user action when animBool is true
			if (animBool) {
				this.removeFromSession();
			}

			setTimeout(function () {
				_this5._root.classList.remove('is-expanded');
				_this5._coltrigger.classList.remove('is-expanded');
			}, 50);
			this._showState = false;

			this._coltrigger.setAttribute('aria-expanded', 'false');
			this._colbody.setAttribute('aria-hidden', 'true');

			if (animBool) {
				this._fromTo(this._getH(this._coltrigger) + this._getH(this._colbody), // Height of trigger + body
				this._getH(this._coltrigger) // Height of the trigger
				);
				this._root.addEventListener('transitionend', function () {
					return _this5._hideBody();
				}, { once: true });
				this.scrollIntoView();
			} else {
				this._resetH();
				this._hideBody();
			}
		}
	}, {
		key: 'getCollapsiblesSession',
		value: function getCollapsiblesSession() {
			return window.sessionStorage.getItem('openCollapsibles') ? JSON.parse(window.sessionStorage.getItem('openCollapsibles')) : [];
		}
	}, {
		key: 'foundInSession',
		value: function foundInSession() {
			var openCollapsibles = this.getCollapsiblesSession();
			var _id = this._coltrigger.getAttribute('aria-controls');

			return openCollapsibles.filter(function (id) {
				return id === _id;
			}).length > 0;
		}
	}, {
		key: 'addToSession',
		value: function addToSession() {
			var id = this._coltrigger.getAttribute('aria-controls');
			var openCollapsibles = this.getCollapsiblesSession();

			if (id) {
				var inArray = openCollapsibles.find(function (el) {
					return el === id;
				});

				if (!inArray) {
					openCollapsibles.push(id);
					window.sessionStorage.setItem('openCollapsibles', JSON.stringify(openCollapsibles));
				}
			}
		}
	}, {
		key: 'removeFromSession',
		value: function removeFromSession() {
			var id = this._coltrigger.getAttribute('aria-controls');
			var openCollapsibles = this.getCollapsiblesSession();

			if (id) {
				var filtered = openCollapsibles.filter(function (el) {
					return el !== id;
				});
				window.sessionStorage.setItem('openCollapsibles', JSON.stringify(filtered));
			}
		}
	}, {
		key: 'scrollIntoView',
		value: function scrollIntoView() {
			var offset = 44;
			var rootY = this._root.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
			var scrollY = window.scrollY;

			// If collapsible root is passed window scroll position, scroll root into view

			if (rootY - scrollY < 0) {
				window.scroll({
					top: rootY - offset,
					behavior: 'smooth'
				});
			}
		}
	}]);

	return Collapsible;
}();

exports.default = Collapsible;

/*
    TODO:
    - Something to manage multiple collapsibles and make all close when one opens
    - Move relevant CSS to a dedicated partial
*/

},{"../Partials/_create-id.js":38,"../Partials/_pubsub.js":49,"../Partials/_viewportstate-watcher.js":58,"smoothscroll-polyfill":153}],38:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * A helper function that creates and returns an alphanumeric string that can be used in ID attributes
 *
 * @param {number} [length=12] - Optional length of returned string
 * @returns {string} - Generated alphanumeric string
 */
var createId = function createId() {
	var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;

	var S4 = function S4() {
		return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
	};
	var id = 'id-' + (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4()).substring(0, length - 1);
	return id;
};

exports.default = createId;

},{}],39:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Creates an instance of the FileUpload class.
 * This will be used in the CMS only.
 * @class FileUpload
 */
var FileUpload = function () {
	/**
  * Creates an instance of FileUpload.
  *
  * @param {HTMLElement} el - HTML input type="file"
  * @param {HTMLElement} el - Label element
  *
  * @example
  * <input class="js-file-input" type="file" name="name" id="id" accept="format">
  */
	function FileUpload(inputElement, labelElement) {
		_classCallCheck(this, FileUpload);

		this._input = inputElement;
		this._label = labelElement;
		this._labelValue = labelElement.innerHTML;

		this._input.addEventListener('change', this._onChange.bind(this));
	}

	// When a file gets uploaded change the button name to the filename


	_createClass(FileUpload, [{
		key: '_onChange',
		value: function _onChange(event) {
			var fileName = event.target.value.split('\\').pop();
			var newLabelValue = fileName.length > 0 ? fileName : this._labelValue;
			this._label.innerHTML = newLabelValue;
		}
	}]);

	return FileUpload;
}();

exports.default = FileUpload;

},{}],40:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/fn/array/index-of');

var _createId = require('../Partials/_create-id.js');

var _createId2 = _interopRequireDefault(_createId);

var _removeNode = require('../Partials/_remove-node.js');

var _removeNode2 = _interopRequireDefault(_removeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FileFieldGroup = function () {
	function FileFieldGroup() {
		var groupArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

		_classCallCheck(this, FileFieldGroup);

		if (groupArray.length <= 1) return;
		this._groups = groupArray;
		this._container = this._groups[0];
		this._filefields = [];
		this._selectedFields = [];
		this._unselectedFields = [];
		this._init();
	}

	_createClass(FileFieldGroup, [{
		key: '_init',
		value: function _init() {
			var _this = this;

			this._container.classList.add('file-fields');

			// Set some ARIA attributes on the main group
			var labelId = (0, _createId2.default)();
			this._container.setAttribute('role', 'group');
			this._container.setAttribute('aria-labelledby', labelId);
			var label = this._container.querySelector('label');
			label.setAttribute('id', labelId);
			label.removeAttribute('for');

			// Put all filefields in a new array, remove all but the first group
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = this._groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var group = _step.value;

					var field = group.querySelector('.file-field');
					this._filefields.push(field);
					this._unselectedFields.push(field);
					if (group !== this._container) (0, _removeNode2.default)(group);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this._renderFields();

			// Event listeners
			var handleEvent = function handleEvent(event) {
				var field = event.target.parentNode;
				if (field.classList.contains('file-field')) {
					_this._updateField(field);
				}
			};

			this._container.addEventListener('change', handleEvent);
			this._container.addEventListener('click', function (event) {
				if (event.target.classList.contains('file-field__reset')) handleEvent(event);
			});
		}
	}, {
		key: '_updateField',
		value: function _updateField(field) {
			// Take a field out of their respective array and move it over to the other
			if (field.classList.contains('file-field--selected')) {
				if (this._unselectedFields.indexOf(field) > -1) {
					this._unselectedFields.splice(this._unselectedFields.indexOf(field), 1);
				}

				// A field can be already in selected state, change value and should then not be added a second time to _selectedFields
				if (this._selectedFields.indexOf(field) === -1) {
					this._selectedFields.push(field);
				}
			} else {
				if (this._selectedFields.indexOf(field) > -1) {
					this._selectedFields.splice(this._selectedFields.indexOf(field), 1);
				}

				this._unselectedFields.push(field);
			}

			this._renderFields();
		}
	}, {
		key: '_removeAllFields',
		value: function _removeAllFields() {
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = this._filefields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var field = _step2.value;

					(0, _removeNode2.default)(field);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
	}, {
		key: '_renderFields',
		value: function _renderFields() {
			this._removeAllFields();

			// Render all selected + the first unselected field
			var insertBeforeNode = this._container.querySelector('.help-block');
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = this._selectedFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var field = _step3.value;

					this._container.insertBefore(field, insertBeforeNode);
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			if (this._unselectedFields[0]) {
				this._container.insertBefore(this._unselectedFields[0], insertBeforeNode);
			}
		}
	}]);

	return FileFieldGroup;
}();

exports.default = FileFieldGroup;

},{"../Partials/_create-id.js":38,"../Partials/_remove-node.js":50,"core-js/fn/array/index-of":65}],41:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FileField = function () {
	function FileField(field) {
		_classCallCheck(this, FileField);

		this._field = field;
		this._input = this._field.querySelector('input[type=file]');
		this._fileSize = 0;

		this._init();
	}

	_createClass(FileField, [{
		key: '_init',
		value: function _init() {
			var _this = this;

			this._field.classList.add('file-field--custom');

			// Display block
			this._display = document.createElement('span');
			this._display.classList.add('file-field__display');
			this._field.appendChild(this._display);

			// Reset button
			var _resetButtonText = this._field.getAttribute('data-resettext') || 'Reset selection';
			this._resetButton = document.createElement('button');
			this._resetButton.classList.add('file-field__reset');
			this._resetButton.setAttribute('title', _resetButtonText);
			this._resetButton.innerHTML = _resetButtonText;
			this._field.appendChild(this._resetButton);

			this._resetButton.addEventListener('click', function (event) {
				event.preventDefault();
				_this._reset();
			});

			// Selection button
			var _selectButtonText = this._field.getAttribute('data-buttontext') || 'Select file';
			this._selectButton = document.createElement('span');
			this._selectButton.classList.add('btn', 'btn--tertiary');
			this._selectButton.innerHTML = _selectButtonText;
			this._field.appendChild(this._selectButton);

			// File info
			this._fileInfo = document.createElement('span');
			this._fileInfo.classList.add('file-field__info');
			this._field.appendChild(this._fileInfo);

			// Event handlers
			this._input.addEventListener('focus', function () {
				return _this._focus();
			});
			this._input.addEventListener('blur', function () {
				return _this._blur();
			});
			this._field.addEventListener('mouseenter', function () {
				return _this._mouseenter();
			});
			this._field.addEventListener('mouseleave', function () {
				return _this._mouseleave();
			});
			this._input.addEventListener('change', function () {
				return _this._update();
			});
		}
	}, {
		key: '_focus',
		value: function _focus() {
			this._field.classList.add('file-field--has-focus');
		}
	}, {
		key: '_blur',
		value: function _blur() {
			this._field.classList.remove('file-field--has-focus');
		}
	}, {
		key: '_mouseenter',
		value: function _mouseenter() {
			this._field.classList.add('file-field--has-mouseover');
		}
	}, {
		key: '_mouseleave',
		value: function _mouseleave() {
			this._field.classList.remove('file-field--has-mouseover');
		}
	}, {
		key: '_update',
		value: function _update() {
			var path = this._input.value;
			if (path === '') {
				this._reset();
			} else {
				this._setSelected(this._unpath(path));
			}
			this._showFileInfo();
		}
	}, {
		key: '_unpath',
		value: function _unpath(path) {
			var arr = path.split('\\');
			return arr[arr.length - 1];
		}
	}, {
		key: '_setDisplay',
		value: function _setDisplay(string) {
			this._display.innerHTML = string;
		}
	}, {
		key: '_setSelected',
		value: function _setSelected(path) {
			this._field.classList.add('file-field--selected');
			this._setDisplay(path);
		}
	}, {
		key: '_showFileInfo',
		value: function _showFileInfo() {
			var val = '';
			var size = 0;
			var files = this._input.files;
			if (files && files.length > 0) {
				size = files[0].size;
				val = Math.round(size / 1000000 * 100) / 100 + 'MB';
			}
			this._fileInfo.innerHTML = val;
			this._fileSize = size;
		}
	}, {
		key: '_reset',
		value: function _reset() {
			this._input.value = '';
			this._field.classList.remove('file-field--selected');
			this._field.classList.remove('file-field--has-mouseover');
			this._setDisplay(''); // IE11+
		}
	}, {
		key: 'getFileSize',
		value: function getFileSize() {
			return this._fileSize;
		}
	}]);

	return FileField;
}();

exports.default = FileField;

},{}],42:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Focus = function () {
	function Focus() {
		_classCallCheck(this, Focus);

		this.timer = 0;

		this.events();
		this.matchMedia();
	}

	_createClass(Focus, [{
		key: 'events',
		value: function events() {
			window.addEventListener('resize', this.matchMedia.bind(this));
		}
	}, {
		key: 'matchMedia',
		value: function matchMedia() {
			var _this = this;

			clearTimeout(this.timer);

			this.timer = setTimeout(function () {
				var query = window.matchMedia('(max-width: 940px)');
				if (query.matches) {
					_this.init();
				} else {
					_this.destroy();
				}
			}, 100);
		}
	}, {
		key: 'keepInFocus',
		value: function keepInFocus(e) {
			e.target.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'nearest' });
		}
	}, {
		key: 'init',
		value: function init() {
			document.addEventListener('focusin', this.keepInFocus);
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			window.removeEventListener('focusin', this.keepInFocus);
		}
	}]);

	return Focus;
}();

new Focus();

},{}],43:[function(require,module,exports){
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

require('core-js/fn/object/entries');

require('core-js/fn/symbol/index');

require('core-js/fn/symbol/iterator');

var _filefield = require('../Partials/_filefield.js');

var _filefield2 = _interopRequireDefault(_filefield);

var _filefieldGroup = require('../Partials/_filefield-group.js');

var _filefieldGroup2 = _interopRequireDefault(_filefieldGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
	var forms = Array.from(document.querySelectorAll('.form'));
	var isIE10 = window.navigator.appVersion.indexOf('MSIE 10.') > -1;

	// Can't feature check on certain file input features (like nulling its value, a feat IE10 doesn't allow)
	forms.forEach(function (form) {
		if (!isIE10) {
			// Transform individual form fields to a custom UI

			// do we have a multi section form?
			var sections = form.querySelectorAll('form > div[data-sc-field-key]');

			// if so, check within the sections
			if (sections.length > 0) {
				sections.forEach(function (section) {
					var filefields = Array.from(section.querySelectorAll('.file-field:not([data-initialized="true"])'));
					createGroups(filefields);
				});
			}

			// business as usual on the remaining fields
			var filefields = Array.from(form.querySelectorAll('.file-field:not([data-initialized="true"])'));
			createGroups(filefields);
		}

		// Add an accessible "input required"" icon in all groups that need one
		var markText = form.getAttribute('data-requiredtext') || '(required)';
		var groups = Array.from(form.querySelectorAll('.form-group.required-field:not([data-initialized="true"])'));

		groups.forEach(function (group) {
			var labels = group.querySelectorAll('label:not(.option), .label:not(.option)');
			labels.forEach(function (label) {
				var mark = document.createElement('em');
				mark.classList.add('required-mark');
				mark.innerHTML = ' ' + markText;

				label.appendChild(mark);
			});
			// set an attribute so it won't render twice on ajax load
			group.setAttribute('data-initialized', 'true');
		});

		licencePlate(form);
	});

	if (window.jQuery) {
		$('.form .datepicker').datepicker({
			dateFormat: 'yy-mm-dd'
		});
	}
};

var licencePlate = function licencePlate(form) {
	// filter out non Word characters and make uppercase
	var filter = function filter(event) {
		var plate = event.target;
		plate.value = plate.value.replace(/[\W_]/g, '').toUpperCase();
	};

	form.querySelectorAll('.license-plate').forEach(function (elm) {
		// first try to remove an existing event, can happen with forms with multiple pages
		elm.removeEventListener('input', filter);
		elm.addEventListener('input', filter);
	});
};

var createGroups = function createGroups(filefields) {
	filefields.forEach(function (field) {
		return new _filefield2.default(field);
	});

	// Bundle multiple form field with the same label into one UI
	var bundles = {};
	filefields.forEach(function (field) {
		var group = field.parentNode;
		var label = group.querySelector('label').textContent;
		if (!bundles[label]) {
			bundles[label] = [];
		}
		bundles[label].push(group);

		// set an attribute so it won't render twice on ajax load
		field.setAttribute('data-initialized', 'true');
	});

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = Object.entries(bundles)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _step$value = _slicedToArray(_step.value, 1),
			    key = _step$value[0];

			new _filefieldGroup2.default(bundles[key]);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
};

document.addEventListener('DOMContentLoaded', init, { once: true });

if (window.jQuery) {
	$(document).ajaxComplete(function () {
		init();
	});
}

},{"../Partials/_filefield-group.js":40,"../Partials/_filefield.js":41,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64,"core-js/fn/object/entries":66,"core-js/fn/symbol/index":68,"core-js/fn/symbol/iterator":69}],44:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMaps = exports.GoogleMaps = function () {
	function GoogleMaps(element) {
		_classCallCheck(this, GoogleMaps);

		this.element = element;
		this.wrapper = this.element.querySelector('.google-maps__wrapper');
		if (this.wrapper) {
			this.id = this.wrapper.getAttribute('data-app-data-id');
		}

		this.map = null;
		this.data = [];

		if (!this.id) {
			return;
		}

		var el = document.getElementById(this.id);
		if (!el) {
			return;
		}

		if (el.textContent) {
			this.data = JSON.parse(el.textContent);
			this.init();
		}
	}

	_createClass(GoogleMaps, [{
		key: 'initMap',
		value: async function initMap() {
			if (this.wrapper) {
				var _ref = await google.maps.importLibrary('maps'),
				    _Map = _ref.Map;

				this.map = new _Map(this.wrapper, {
					zoom: 11,
					center: { lat: 30, lng: -110 },
					mapId: 'map-' + this.id,
					streetViewControl: false,
					fullscreenControl: false,
					mapTypeControl: false,
					zoomControlOptions: {
						position: google.maps.ControlPosition.TOP_LEFT
					}
				});

				google.maps.event.addListenerOnce(this.map, 'idle', function () {
					var map = document.querySelector('.google-maps [role="region"][tabindex="0"]');
					if (map) {
						map.removeAttribute('tabindex');
					}
				});
			}
		}
	}, {
		key: 'initMarkers',
		value: async function initMarkers() {
			var _this = this;

			var _ref2 = await google.maps.importLibrary('marker'),
			    AdvancedMarkerElement = _ref2.AdvancedMarkerElement;

			var _ref3 = await google.maps.importLibrary('maps'),
			    InfoWindow = _ref3.InfoWindow;

			var bounds = new window.google.maps.LatLngBounds();
			var infoWindow = new InfoWindow();
			this.data.forEach(function (location) {
				bounds.extend(location);
				var marker = new AdvancedMarkerElement({
					map: _this.map,
					position: location,
					title: location.place
				});

				var html = '<b>' + location.location + '</b><br><br>\n\t\t\t\t\t\t\t\t<span>' + location.address + '</span><br>\n\t\t\t\t\t\t\t\t<span>' + location.postalCode + '</span> <span>' + location.place + '</span>\n\t\t\t\t\t\t\t\t' + (location.phone ? '<br><span>' + location.phone + '</span>' : '');

				marker.addListener('click', function () {
					infoWindow.close();
					infoWindow.setContent(html);
					infoWindow.open(marker.map, marker);
				});
			});
			if (this.map && bounds) {
				this.map.fitBounds(bounds);
			}
		}
	}, {
		key: 'init',
		value: function init() {
			var _this2 = this;

			this.initMap().then(function () {
				_this2.initMarkers().then();
			});
		}
	}]);

	return GoogleMaps;
}();

document.querySelectorAll('.google-maps').forEach(function (element) {
	new GoogleMaps(element);
});

},{}],45:[function(require,module,exports){
"use strict";

// matches polyfill
// Source: https://plainjs.com/javascript/traversing/get-closest-element-by-selector-39/
window.Element && function (ElementPrototype) {
	ElementPrototype.matches = ElementPrototype.matches || ElementPrototype.matchesSelector || ElementPrototype.webkitMatchesSelector || ElementPrototype.msMatchesSelector || function (selector) {
		var node = this,
		    nodes = (node.parentNode || node.document).querySelectorAll(selector),
		    i = -1;
		while (nodes[++i] && nodes[i] != node) {}
		return !!nodes[i];
	};
}(window.Element.prototype);

},{}],46:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A simple class of which the on() method can be used to attach a 'swiping' touch gesture event listener to an element.
 *
 * @class OnSwipe
 */
var OnSwipe = function () {
	function OnSwipe() {
		_classCallCheck(this, OnSwipe);

		this._threshold = 150;
		this._restraint = 100;
		this._allowedTime = 300;
	}

	/**
  * The on() method of an OnSwipe instance attaches a 'swiping' gesture eventlistener
  *
  * @param {string="left","right","up","down"} dir - The desired direction
  * @param {HTMLElement} el - The DOM element to attach this eventlistener to
  * @param {function} [fn=function(){}] - Optional callback function
  *
  * @memberOf OnSwipe
  */


	_createClass(OnSwipe, [{
		key: 'on',
		value: function on(dir, el) {
			var _this = this;

			var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

			if (el === null) return;
			this._dir = dir;
			this._callbackFn = fn;
			el.addEventListener('touchstart', function (event) {
				return _this._startSwipe(event);
			}, {
				passive: true
			});
			el.addEventListener('touchend', function (event) {
				return _this._endSwipe(event);
			}, {
				passive: true
			});
		}
	}, {
		key: '_startSwipe',
		value: function _startSwipe(event) {
			var touchobj = event.changedTouches[0];
			this._dist = 0;
			this._startX = touchobj.pageX;
			this._startY = touchobj.pageY;
			this._startTime = new Date().getTime();
		}
	}, {
		key: '_endSwipe',
		value: function _endSwipe(event) {
			var swipeDir = void 0;
			var touchobj = event.changedTouches[0];
			var distX = touchobj.pageX - this._startX;
			var distY = touchobj.pageY - this._startY;
			var elapsedTime = new Date().getTime() - this._startTime;

			if (elapsedTime <= this._allowedTime) {
				if (Math.abs(distX) >= this._threshold && Math.abs(distY) <= this._restraint) {
					swipeDir = distX < 0 ? 'left' : 'right';
				} else if (Math.abs(distY) >= this._threshold && Math.abs(distX) <= this._restraint) {
					swipeDir = distY < 0 ? 'up' : 'down';
				}
			}

			if (swipeDir === this._dir) {
				// If the determined swiping direction matches the desired direction, run the callback function
				this._callbackFn();
			}
		}
	}]);

	return OnSwipe;
}();

exports.default = OnSwipe;

},{}],47:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

var patchListCounters = function patchListCounters(els) {
	if (els.constructor !== Array) {
		els = [els];
	}

	els.forEach(function (el) {
		var n = parseInt(el.getAttribute('start'), 10);
		if (!isNaN(n)) {
			el.style['counter-reset'] = 'list ' + n;
		}
	});
};

var init = function init() {
	var lists = Array.from(document.querySelectorAll('ol'));
	patchListCounters(lists);
};

document.addEventListener('DOMContentLoaded', init, { once: true });

exports.default = patchListCounters;

},{"core-js/fn/array/for-each":63,"core-js/fn/array/from":64}],48:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/fn/array/for-each');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var printButton = function () {
	function printButton(el) {
		var contextElements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

		_classCallCheck(this, printButton);

		this._root = el;
		this._contextElements = contextElements;
		this._init();
	}

	_createClass(printButton, [{
		key: '_init',
		value: function _init() {
			var _this = this;

			var fn = function fn(event) {
				event.preventDefault();
				if (_this._contextElements.length) {
					_this._printContext();
				} else {
					_this._print();
				}
			};

			this._root.addEventListener('click', fn);
		}
	}, {
		key: '_print',
		value: function _print() {
			window.print();
		}
	}, {
		key: '_printContext',
		value: function _printContext() {
			var _this2 = this;

			this._contextElements.forEach(function (context) {
				context.classList.add('print-only-me');
				var container = context.parentElement;
				if (container) container.classList.add('print-only-one');
			});

			var fn = function fn() {
				_this2._contextElements.forEach(function (context) {
					context.classList.remove('print-only-me');
					var container = context.parentElement;
					if (container) container.classList.remove('print-only-one');
				});
			};

			this._print();
			setTimeout(fn, 200);
		}
	}]);

	return printButton;
}();

exports.default = printButton;

},{"core-js/fn/array/for-each":63}],49:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

require('core-js/fn/array/for-each');

var events = {
	events: {},
	on: function on(eventName, fn) {
		this.events[eventName] = this.events[eventName] || [];
		this.events[eventName].push(fn);
	},
	off: function off(eventName, fn) {
		if (this.events[eventName]) {
			for (var i = 0; i < this.events[eventName].length; i++) {
				if (this.events[eventName][i] === fn) {
					this.events[eventName].splice(i, 1);
					break;
				}
			}
		}
	},
	emit: function emit(eventName, data) {
		if (this.events[eventName]) {
			this.events[eventName].forEach(function (fn) {
				fn(data);
			});
		}
	}
}; // Source: https://gist.github.com/learncodeacademy/777349747d8382bfb722
// Youtube explanation: https://www.youtube.com/watch?v=nQRXi1SVOow

exports.default = events;

},{"core-js/fn/array/for-each":63}],50:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var removeNode = function removeNode(domNode) {
	if (typeof domNode.remove === 'function') {
		domNode.remove();
	} else {
		domNode.removeNode(true);
	}
	return domNode;
};

exports.default = removeNode;

},{}],51:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchResultCategorySwitch = function () {
	function SearchResultCategorySwitch(element) {
		_classCallCheck(this, SearchResultCategorySwitch);

		this._element = element;
		this._select = element.querySelector('select');
		if (this._select) {
			this.init();
		}
	}

	_createClass(SearchResultCategorySwitch, [{
		key: 'init',
		value: function init() {
			var _this = this;

			this._select.addEventListener('change', function (e) {
				return _this._handleSelectChange();
			});
		}
	}, {
		key: '_handleSelectChange',
		value: function _handleSelectChange() {
			this._element.submit();
		}
	}]);

	return SearchResultCategorySwitch;
}();

var init = function init() {
	document.querySelectorAll('.search-results .site-search__form').forEach(function (element) {
		var searchResultCategorySwitch = new SearchResultCategorySwitch(element);
	});
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{}],52:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/fn/array/from');

require('core-js/fn/array/for-each');

require('core-js/fn/array/find-index');

require('url-search-params-polyfill');

var _createId = require('../Partials/_create-id.js');

var _createId2 = _interopRequireDefault(_createId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
    TODO:
    - meer ARIA? https://haltersweb.github.io/Accessibility/autocomplete.html
        - aria-live with info on what happened to screenreaders,
        - aria-describedby with how to use
    - APK categorien beperken op dit moment NIET de suggest scope, maar zouden dat misschien wel moeten:
        - value van dropdown uitlezen en meesturen in suggest AJAX query
        - opnieuw een query doen nadat select is gewijzigd en focus op _field staat
*/

var SearchSuggest = function () {
	function SearchSuggest(form, field) {
		_classCallCheck(this, SearchSuggest);

		this._form = form;
		this._suggestContainer = this._form.querySelector('.site-search__suggest-container');
		this._field = field;

		this._serviceURI = this._form.getAttribute('data-suggest-service-uri');
		this._label = this._form.getAttribute('data-suggest-label') || 'Suggestions';
		this._AllLink = this._form.getAttribute('data-suggest-all') || 'All results';
		this._id = (0, _createId2.default)();
		this._button = document.getElementById('page-header__search__toggle');

		this._minNumberOfChars = 3;
		this._maxSuggestionsRequested = 10;
		this._finalRequestDelay = 500;

		this._initialRequest = new XMLHttpRequest();
		this._finalRequest = new XMLHttpRequest();
		this._finalQuery = null;
		this._queryValue = '';
		this._queryValueBeforeSelection = '';
		this._initialRequestQueryValue = '';
		this._selectedMenuItemIndex = -1;
		this._requestResults = [];
		this._filteredResults = [];

		this._urlParams = new URLSearchParams(window.location.search);
		this._searchParam = this._urlParams.get('q');

		this._init();
	}

	_createClass(SearchSuggest, [{
		key: '_init',
		value: function _init() {
			var _this = this;

			// DOM additions
			this._menu = document.createElement('div');
			this._allButtonContainer = document.createElement('div');
			this._allButton = document.createElement('button');
			this._allButton.innerText = this._AllLink;
			this._allButton.setAttribute('type', 'submit');
			this._allButton.setAttribute('value', this._AllLink);
			this._allButtonContainer.appendChild(this._allButton);
			this._allButtonContainer.classList.add('search-suggest-buttons');

			this._menuList = document.createElement('ul');
			this._menu.appendChild(this._menuList);

			var id = 'suggest_' + this._id;
			this._menu.setAttribute('class', 'search-suggest');
			this._menu.setAttribute('id', id);
			this._menu.setAttribute('role', 'listbox');
			this._menu.setAttribute('aria-label', this._label);
			this._menu.setAttribute('aria-live', 'polite');

			this._field.setAttribute('aria-owns', id);
			this._suggestContainer.appendChild(this._menu);
			this._menu.appendChild(this._allButtonContainer);
			this._hideMenu();

			this._field.addEventListener('focus', function (e) {
				return _this._handleFocus(e);
			});
			this._field.addEventListener('keyup', function (e) {
				return _this._handleKeyUp(e);
			});
			this._field.addEventListener('focusout', function (e) {
				return _this._handleFocusOut(e);
			});

			// dit was weg in develop?
			this._field.addEventListener('focusout', function (e) {
				return _this._handleFocusOut(e);
			});

			this._allButton.addEventListener('keyup', function (e) {
				_this._allResultsButtonLosesFocus(e);
			});

			this._suggestContainer.addEventListener('blur', function (e) {
				return _this._handleFocusOut(e);
			});

			this._button.addEventListener('click', function (e) {
				return _this._handleFocusOut(e);
			});

			document.addEventListener('click', function (e) {
				var withinBoundaries = e.composedPath().includes(_this._suggestContainer);

				if (!withinBoundaries) {
					_this._handleFocusOut(e);
				}
			});

			document.addEventListener('keyup', function (e) {
				if (e.code === 'Tab') {
					_this._handleFocusOut(e);
				}
				if (e.code === 'Escape') {
					if (_this._field.parentNode.querySelector('.search-suggest.is-active')) {
						e.stopPropagation();
						_this._hideMenu();
					}
				}
			});
		}
	}, {
		key: '_allResultsButtonLosesFocus',
		value: function _allResultsButtonLosesFocus(e) {
			if (e.key === 'ArrowDown' || e.key === 'Down') {
				this._focusMenuItem(0);
			} else if (e.key === 'ArrowUp' || e.key === 'Up') {
				this._focusMenuItem(this._filteredResults.length);
			}
			this._field.focus();

			this._field.value = this._initialRequestQueryValue;
			this._queryValueBeforeSelection = this._initialRequestQueryValue;
		}
	}, {
		key: '_handleFocus',
		value: function _handleFocus() {
			this._queryValueBeforeSelection = this._field.value;

			// only suggest if they are matching, otherwise it does an unwanted search
			if (this._queryValueBeforeSelection === this._initialRequestQueryValue) {
				this._suggest();
			}
		}
	}, {
		key: '_handleFocusOut',
		value: function _handleFocusOut(e) {
			var withinBoundaries = e.composedPath().includes(this._suggestContainer);
			if (!withinBoundaries || e.relatedTarget && e.relatedTarget.classList.contains('site-search__button')) {
				this._queryValueBeforeSelection = this._field.value;
				this._hideMenu();
			}
		}
	}, {
		key: '_handleKeyUp',
		value: function _handleKeyUp(e) {
			if (e.key === 'ArrowDown' || e.key === 'Down') {
				this._focusMenuItem(1);
			} else if (e.key === 'ArrowUp' || e.key === 'Up') {
				this._focusMenuItem(-1);
			} else if (e.key === 'Escape' || e.key === 'Esc') {
				this._hideMenu();
			} else {
				this._suggest();
			}
		}
	}, {
		key: '_handleClick',
		value: function _handleClick(e) {
			e.preventDefault();
			e.stopPropagation();
			var t = e.target;
			if (t.tagName.toLowerCase() === 'button' || t.tagName.toLowerCase() === 'em') {
				if (t.tagName.toLowerCase() === 'em') {
					t = t.parentElement;
				}
				this._field.value = t.textContent;
				this._queryValue = this._field.value;
				this._hideMenu();
				this._form.submit();
			}
		}

		// Return whether the input field's string value is of minimal required length

	}, {
		key: '_isFieldValueOfMinimalLength',
		value: function _isFieldValueOfMinimalLength() {
			return this._field.value.length >= this._minNumberOfChars;
		}

		// Populate the suggestions dropdown menu

	}, {
		key: '_populateMenu',
		value: function _populateMenu(array) {
			var _this2 = this;

			this._clearMenu();
			var status = document.createElement('div');
			status.classList.add('search-suggest__status');
			status.textContent = array.length;
			this._menuList.appendChild(status);

			array.forEach(function (value) {
				var item = document.createElement('li');
				var button = document.createElement('button');
				item.setAttribute('role', 'option');
				item.setAttribute('tabindex', -1);
				button.innerHTML = value.replace(_this2._queryValue, '<em>' + _this2._queryValue + '</em>');
				button.addEventListener('click', function (e) {
					return _this2._handleClick(e);
				});
				item.appendChild(button);
				_this2._menuList.appendChild(item);
			});
		}

		// Clear the suggestions dropdown of entries

	}, {
		key: '_clearMenu',
		value: function _clearMenu() {
			this._menuList.innerHTML = '';
		}

		// Descent or ascent the dropdown menu

	}, {
		key: '_focusMenuItem',
		value: function _focusMenuItem() {
			var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

			if (!this._menu.classList.contains('is-active')) return;

			this._selectedMenuItemIndex += dir;
			this._resetMenuItemSelection();

			var items = Array.from(this._menu.querySelectorAll('li'));

			if (this._selectedMenuItemIndex < 0 || this._selectedMenuItemIndex > items.length - 1) {
				this._selectedMenuItemIndex = -1;
				this._field.value = this._queryValueBeforeSelection;
				this._allButton.focus();
				return;
			}

			this._abortQuery(this._initialRequest);
			this._abortQuery(this._finalRequest);

			this._setMenuItemSelection(this._selectedMenuItemIndex);
			this._field.value = items[this._selectedMenuItemIndex].textContent;
			this._queryValue = this._field.value;
		}

		// Reset dropdown menu selection

	}, {
		key: '_resetMenuItemSelection',
		value: function _resetMenuItemSelection() {
			var curSelectedItem = this._menu.querySelector('.is-selected');
			if (curSelectedItem) {
				curSelectedItem.classList.remove('is-selected');
				curSelectedItem.removeAttribute('id');
				curSelectedItem.removeAttribute('aria-selected');
			}
			this._field.setAttribute('aria-activedescendant', '');
		}

		// Set dropdown menu selection

	}, {
		key: '_setMenuItemSelection',
		value: function _setMenuItemSelection(index) {
			if (index > -1) {
				var menuItems = Array.from(this._menu.querySelectorAll('li'));
				var selectedItem = menuItems[index];
				var id = 'suggest_' + this._id + '_selected';
				selectedItem.classList.add('is-selected');
				selectedItem.setAttribute('id', id);
				selectedItem.setAttribute('aria-selected', 'true');
				this._field.setAttribute('aria-activedescendant', id);
			}
		}

		// Set the height of the dropdown menu

	}, {
		key: '_setMenuHeight',
		value: function _setMenuHeight(h) {
			var menuList = this._menu.querySelector('ul');
			if (menuList) menuList.style.height = h + 'px';
		}

		// Get the height of the dropdown menu

	}, {
		key: '_getMenuHeight',
		value: function _getMenuHeight() {
			var items = Array.from(this._menu.querySelectorAll('li'));
			var h = items.length * (items[0] ? items[0].offsetHeight : 0);
			return h;
		}

		// Show dropdown menu

	}, {
		key: '_showMenu',
		value: function _showMenu() {
			document.body.classList.add('search-suggest-is-active');
			this._menu.classList.add('is-active');
			this._menu.setAttribute('aria-hidden', false);
			this._setMenuHeight(this._getMenuHeight());
		}

		// Hide dropdown menu

	}, {
		key: '_hideMenu',
		value: function _hideMenu() {
			var _this3 = this;

			this._field.setAttribute('aria-activedescendant', '');
			document.body.classList.remove('search-suggest-is-active');
			this._menu.setAttribute('aria-hidden', true);
			this._selectedMenuItemIndex = -1;
			this._resetMenuItemSelection();
			this._setMenuHeight(0);

			setTimeout(function () {
				_this3._menu.classList.remove('is-active');
			}, 100);
		}

		// Suggest search queries

	}, {
		key: '_suggest',
		value: function _suggest() {
			var _this4 = this;

			if (this._serviceURI === null) {
				return;
			}

			var value = this._field.value;
			this._queryValueBeforeSelection = value;

			var processResults = function processResults(array) {
				_this4._requestResults = array;
				_this4._filteredResults = array;

				if (_this4._filteredResults.length > 0) {
					_this4._populateMenu(_this4._filteredResults);
					_this4._showMenu();

					// set the search query item active
					var suggestItems = Array.from(document.querySelectorAll('.search-suggest.is-active li'));
					var suggestResults = [];

					suggestItems.forEach(function (item) {
						suggestResults.push(item.textContent);
					});

					var searchQuery = function searchQuery(ar) {
						return ar === _this4._searchParam;
					};

					var i = suggestResults.findIndex(searchQuery);
					if (i >= 0) suggestItems[i].classList.add('is-active');
				} else {
					_this4._clearMenu();
					_this4._hideMenu();
				}
			};

			if (this._isFieldValueOfMinimalLength()) {
				if (value !== this._queryValue) {
					// Input value has changed since last keystroke
					clearTimeout(this._finalQuery);

					// If no request is running, make initial request
					if (!this._isQueryActive(this._initialRequest)) {
						this._query(this._initialRequest, value, processResults);
						this._initialRequestQueryValue = value;
					}

					// Launch a final request - timed out. Then cancel the initial request if it is still running
					this._finalQuery = setTimeout(function () {
						if (value !== _this4._initialRequestQueryValue) {
							// Input value has changed between initial and final request
							_this4._query(_this4._finalRequest, value, function (array) {
								_this4._abortQuery(_this4._initialRequest);
								processResults(array);
							});
						}
					}, this._finalRequestDelay);
				}

				// Continue filtering any existing results
				if (this._requestResults.length > 0) {
					processResults(this._requestResults);
				}
			} else {
				this._abortQuery(this._initialRequest);
				this._abortQuery(this._finalRequest);
				this._hideMenu();
			}

			this._queryValue = value;
		}

		// Make an XMLHTTPRequest

	}, {
		key: '_query',
		value: function _query(req, value, successFn) {
			this._abortQuery(req);
			var queryOp = this._serviceURI.includes('?') ? '&' : '?';
			var uri = '' + this._serviceURI + queryOp + 'q=' + encodeURIComponent(value) + '&count=' + this._maxSuggestionsRequested;
			req.onreadystatechange = function (e) {
				if (req.readyState === XMLHttpRequest.DONE && req.status === 200) {
					var result = JSON.parse(req.responseText);
					successFn(result);
				}
			};
			req.open('GET', uri, true);
			req.send();
		}

		// Return whether XMLHTTPRequest object is active

	}, {
		key: '_isQueryActive',
		value: function _isQueryActive(req) {
			var active = req.readyState && req.readyState !== 0 && req.readyState !== 4;
			return active;
		}

		// Abort an active XMLHTTPRequest

	}, {
		key: '_abortQuery',
		value: function _abortQuery(req) {
			if (this._isQueryActive(req)) {
				req.abort();
			}
		}
	}]);

	return SearchSuggest;
}();

exports.default = SearchSuggest;

},{"../Partials/_create-id.js":38,"core-js/fn/array/find-index":62,"core-js/fn/array/for-each":63,"core-js/fn/array/from":64,"url-search-params-polyfill":155}],53:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _viewportstateWatcher = require('../Partials/_viewportstate-watcher.js');

var _viewportstateWatcher2 = _interopRequireDefault(_viewportstateWatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Creates an instance of the Table class.
 *
 * @class Table
 */
var Table = function () {
	/**
  * Creates an instance of Table.
  * This class will resize the Table to be fullbleed on the right side.
  * It will take two elements into consideration the #main and .main__article__content
  *
  * This javascript solution is necessary because it needs to calculate
  * if the width of the table is larger than the width of the RTE
  * when this is the case it needs to calc the new width of the table that is
  * the original width plus the width of the space right of the RTE.
  * (Safari also doesn't support calc percentages with px's)
  *
  * @param {HTMLElement} el - HTML table element
  * @param {HTMLElement} el - HTML container element
  * @param {string, array} [viewportStates='all'] - An optional string or array that makes the Table functionality active for given viewport states (see Partials/_viewportstate-watcher.js)
  *
  * @example
  * <div class="table__wrapper js-table">
  *     <table class="table__simple">
  * </div>
  */
	function Table(tableWrapper, rte) {
		var _this = this;

		var viewportStates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['small', 'medium'];

		_classCallCheck(this, Table);

		this._tableWrapper = tableWrapper;
		this._rte = rte;
		this._table = tableWrapper.querySelector('table');

		// Get elements to calculate the extra padding
		// Prefer to use getBoundingClientRect but the right value is wrong and bugged
		this._mainArticleContent = document.querySelector('.main__article__content');
		this._main = document.querySelector('#main');

		// Get handler fn reference so it can be removed with this binding
		var timer = void 0;
		this._resizeHandler = function () {
			clearTimeout(timer);
			timer = setTimeout(function () {
				return _this._resize();
			}, 50);
		};

		_viewportstateWatcher2.default.watch(viewportStates, function () {
			return _this._init();
		}, function () {
			return _this._uninit();
		});
	}

	_createClass(Table, [{
		key: '_init',
		value: function _init() {
			this._calcWidth();
			window.addEventListener('resize', this._resizeHandler);
			window.addEventListener('orientationchange', this._resizeHandler);
		}
	}, {
		key: '_uninit',
		value: function _uninit() {
			this._tableWrapper.removeAttribute('style');
			window.removeEventListener('resize', this._resizeHandler);
			window.removeEventListener('orientationchange', this._resizeHandler);
		}
	}, {
		key: '_resize',
		value: function _resize() {
			this._calcWidth();
		}
	}, {
		key: '_calcWidth',
		value: function _calcWidth() {
			this._tableWrapper.removeAttribute('style');

			this._offsetWidth = parseFloat(window.getComputedStyle(this._mainArticleContent).marginRight) + parseFloat(window.getComputedStyle(this._mainArticleContent).paddingRight) + parseFloat(window.getComputedStyle(this._main).paddingRight);

			// Check if table is larger than rte width
			if (this._rte.offsetWidth < this._table.offsetWidth) {
				this._tableWrapper.style.marginRight = -this._offsetWidth + 'px';
			}
		}
	}]);

	return Table;
}();

exports.default = Table;

},{"../Partials/_viewportstate-watcher.js":58}],54:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * Test a CSS feature
 */
var testFeature = {
	test: function test(property, value, noPrefixes) {
		var prop = property + ':';
		var el = document.createElement('test');
		var mStyle = el.style;

		if (!noPrefixes) {
			mStyle.cssText = prop + ['-webkit-', '-moz-', '-ms-', '-o-', ''].join(value + ';' + prop) + value + ';';
		} else {
			mStyle.cssText = prop + value;
		}
		return !!mStyle[property];
	},
	setClass: function setClass() {
		var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
		var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

		var c = bool === true ? name : 'no-' + name;
		document.documentElement.classList.add(c);
	}
};

exports.default = testFeature;

},{}],55:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = detectIE;
function detectIE() {
	var ua = window.navigator.userAgent;

	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}
	// Edge support not needed
	// var edge = ua.indexOf('Edge/');
	// if (edge > 0) {
	//    // Edge (IE 12+) => return version number
	//    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	// }

	// other browser
	return false;
}

},{}],56:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * Test for touch event support
 */
var testTouchevents = {
	test: function test() {
		var bool = 'ontouchstart' in window;
		return bool;
	},
	setClass: function setClass() {
		var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
		var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

		var c = bool === true ? name : 'no-' + name;
		document.documentElement.classList.add(c);
	}
};

exports.default = testTouchevents;

},{}],57:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('core-js/fn/array/for-each');

var _createId = require('../Partials/_create-id.js');

var _createId2 = _interopRequireDefault(_createId);

var _trapFocus = require('../Helpers/trap-focus');

var _trapFocus2 = _interopRequireDefault(_trapFocus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Tooltips
 *
 * @class ToolTip
 */
var ToolTip = function () {
	function ToolTip(el) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, ToolTip);

		this._root = el;
		this._options = {
			triggers: options.triggers || ['click'],
			globalUntriggers: options.globalUntriggers || ['focusin', 'click'],
			keyboardControl: options.keyboardControl || true,
			additionalClassNames: options.additionalClassNames || [],
			allowFocusInside: options.allowFocusInside === false ? false : true,
			offsetTop: options.offsetTop || 0,
			offsetBottom: options.offsetBottom || 40
		};

		this._active = false;
		this._cooldown = false;

		this._init();
	}

	_createClass(ToolTip, [{
		key: '_init',
		value: function _init() {
			var _this = this;

			var tooltipId = 'tooltip-' + (0, _createId2.default)();
			var rootId = this._root.id || 'tooltipsrc-' + (0, _createId2.default)();
			var tooltipText = this._root.getAttribute('data-tooltip-html') || this._root.getAttribute('title') || '';

			// Create and configure hidden tooltip
			this._tooltip = document.createElement('div');
			document.body.appendChild(this._tooltip);

			this._tooltipContent = document.createElement('div');
			this._tooltipContent.classList.add('tooltip--content');
			this._tooltip.appendChild(this._tooltipContent);

			this._tooltipArrow = document.createElement('div');
			this._tooltipArrow.classList.add('tooltip--arrow');
			this._tooltip.appendChild(this._tooltipArrow);

			this._tooltip.setAttribute('role', 'tooltip');
			this._tooltip.setAttribute('id', tooltipId);
			this._tooltip.setAttribute('aria-labelledby', rootId);
			this._tooltip.classList.add('tooltip--hidden');
			this._tooltip.classList.add('tooltip');
			this._options.additionalClassNames.forEach(function (c) {
				return _this._tooltip.classList.add(c);
			});
			this._tooltipContent.innerHTML = tooltipText;

			// Attributes on root element
			this._root.setAttribute('aria-describedby', tooltipId);
			this._root.setAttribute('id', rootId);
			this._root.setAttribute('tabindex', this._root.getAttribute('tabindex') || 0);
			this._root.removeAttribute('title');

			// Keyboard focusable elements inside tooltip to handle closing during tabbing
			var hideWhenTabbedOut = function hideWhenTabbedOut() {
				_this._hide();
				_this._root.focus();
			};

			var focusBefore = document.createElement('span');
			focusBefore.setAttribute('tabindex', 0);
			this._tooltip.insertBefore(focusBefore, this._tooltipContent);
			focusBefore.addEventListener('focus', hideWhenTabbedOut);

			var focusAfter = document.createElement('span');
			focusAfter.setAttribute('tabindex', 0);
			this._tooltip.insertBefore(focusAfter, this._tooltipContent.nextSibling);
			focusAfter.addEventListener('focus', hideWhenTabbedOut);

			// Event listeners on root element

			var rootKeydown = function rootKeydown(e) {
				if (_this._options.keyboardControl && e.keyCode === 32) e.preventDefault();else if (e.key === 'Tab' && !e.shiftKey && _this._active && _this._options.allowFocusInside) {
					// If tooltip is open and user tabs forward, focus on first A inside, if any
					var a = _this._tooltip.querySelector('a');
					if (a) {
						e.preventDefault();
						a.focus();
					}
				}
			};
			this._root.addEventListener('keydown', rootKeydown);

			var rootKeyup = function rootKeyup(e) {
				if (e.key === 'Enter' || e.keyCode === 32) _this._toggle();else if (e.key === 'Escape' || e.key === 'Esc') _this._hide();
			};

			if (this._options.keyboardControl) {
				this._root.addEventListener('keyup', rootKeyup);
			}

			this._options.triggers.forEach(function (t) {
				_this._root.addEventListener(t, function (e) {
					return _this._toggle(e);
				}, {
					passive: true
				});
			});

			// Event listeners on tooltip

			var tooltipKeyUp = function tooltipKeyUp(e) {
				if (e.key === 'Escape' || e.key === 'Esc') {
					_this._hide();
					_this._root.focus();
				}
				if (e.key === 'Tab') {
					if (document.activeElement === _trapFocus2.default.lastFocusableEl) {
						_trapFocus2.default.endTrapFocus();
					}
				}
			};

			this._tooltip.addEventListener('keyup', tooltipKeyUp);

			this._options.globalUntriggers.forEach(function (t) {
				_this._tooltip.addEventListener(t, function (e) {
					return e.stopPropagation();
				});
			});

			// Global event listeners to close the tooltip
			this.globalFocusout = function (e) {
				var t = e.target;
				if (t !== _this._root) {
					_this._hide();
				}
			};

			this.scrolled = function () {
				_this._updateTooltipPosition();
			};

			var timer = void 0;
			var handleResize = function handleResize() {
				clearTimeout(timer);
				timer = setTimeout(function () {
					return _this._hide();
				}, 50);
			};

			window.addEventListener('orientationchange', handleResize);
			window.addEventListener('resize', handleResize);
		}
	}, {
		key: '_toggle',
		value: function _toggle(e) {
			var _this2 = this;

			// Cooldown stops consecutive events from conflicting (i.e. focus + mouseenter on touch devices)
			if (this._cooldown) return;
			this._cooldown = true;
			setTimeout(function () {
				_this2._cooldown = false;
			}, 500);

			if (this._active) {
				this._hide();
			} else {
				this._show();
			}
		}
	}, {
		key: '_show',
		value: function _show() {
			var _this3 = this;

			_trapFocus2.default.startTrapFocus(this._tooltipContent);

			this._active = true;
			this._tooltip.classList.add('tooltip--is-active');

			document.addEventListener('scroll', this.scrolled);

			this._updateTooltipPosition();
			this._options.globalUntriggers.forEach(function (t) {
				return document.body.addEventListener(t, _this3.globalFocusout);
			});
		}
	}, {
		key: '_hide',
		value: function _hide() {
			var _this4 = this;

			_trapFocus2.default.endTrapFocus();

			this._active = false;
			this._tooltip.classList.remove('tooltip--is-active');

			document.removeEventListener('scroll', this.scrolled);
			this._options.globalUntriggers.forEach(function (t) {
				return document.body.removeEventListener(t, _this4.globalFocusout);
			});
		}
	}, {
		key: '_updateTooltipPosition',
		value: function _updateTooltipPosition() {
			var bodyRect = document.body.getBoundingClientRect();
			var rootRect = this._root.getBoundingClientRect();
			var rootWidth = this._root.offsetWidth;

			var left = rootRect.left - bodyRect.left + rootWidth / 2;
			var top = rootRect.top - bodyRect.top;
			var w = this._tooltip.offsetWidth;

			this._tooltip.style.width = w + 'px';

			// Counter overflowing the canvas on left and right
			var offRight = left + w / 2 - document.body.offsetWidth;
			if (offRight > 0) {
				this._tooltip.style.marginLeft = -offRight + 'px';
				this._tooltipArrow.style.marginLeft = offRight + 'px';
			}

			var offLeft = left - w / 2;
			if (offLeft < 0) {
				this._tooltip.style.marginLeft = -offLeft + 'px';
				this._tooltipArrow.style.marginLeft = offLeft + 'px';
			}

			// Set x and y, if the tooltip will overlap the top of the window, position it under the text instead
			if (this._tooltip.getBoundingClientRect().height > this._root.getBoundingClientRect().top) {
				this._tooltip.style.top = top + this._tooltip.getBoundingClientRect().height + this._options.offsetBottom + 'px';
			} else {
				this._tooltip.style.top = top + this._options.offsetTop + 'px';
			}
			this._tooltip.style.left = left + 'px';
		}
	}]);

	return ToolTip;
}();

exports.default = ToolTip;

},{"../Helpers/trap-focus":2,"../Partials/_create-id.js":38,"core-js/fn/array/for-each":63}],58:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('custom-event-polyfill');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// More states can be added here.
// - The height property should match the height set to the #viewport-state element in SCSS/Partials/_viewport-state.scss
// - The label should be a discriptive name, like a CSS media query range
var presetStates = [{ height: 1, label: 'small' }, { height: 2, label: 'medium' }, { height: 3, label: 'mediumPlus' }, { height: 4, label: 'large' }, { height: 5, label: 'xlarge' }];

// Potential TODO: read CSS property based on property name ('height'), and set an array of current states or something, in order to allow
// for multiple active states that can overlap in requirements.

/**
 * A singleton that determines the state of the viewport (in most cases, the current CSS media query range)
 * and fires off a custom event when this state changes. It also offers run() and watch() methods to kick off
 * callback functions when given states match or fail to match the current state.
 *
 * @param {array} - An array with objects that define the preset states
 *
 * @class ViewPortStateWatcher
 */

var ViewPortStateWatcher = function () {
	function ViewPortStateWatcher() {
		var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

		_classCallCheck(this, ViewPortStateWatcher);

		this._states = arr;
		this._currentStateIndex = -1;

		this._sample = document.createElement('div');
		this._sample.setAttribute('id', 'viewport-state');
		this._sample.setAttribute('role', 'presentation');
	}

	_createClass(ViewPortStateWatcher, [{
		key: '_init',
		value: function _init() {
			var _this = this;

			// Append sample element to BODY
			document.body.appendChild(this._sample);

			// Viewport resizing event listeners
			var timer = void 0;
			var handleResize = function handleResize() {
				clearTimeout(timer);
				timer = setTimeout(function () {
					return _this._trigger();
				}, 100);
			};
			window.addEventListener('resize', handleResize);
			window.addEventListener('orientationchange', handleResize);
		}

		/**
   * Matches sample element's current height with index in states array.
   * _currentStateIndex is updated in case array index differs from _currentStateIndex's value
   *
   * @returns {boolean} - True of false depending on whether the current state changed
   *
   * @memberOf ViewPortStateWatcher
   */

	}, {
		key: '_update',
		value: function _update() {
			var samplestyle = window.getComputedStyle(this._sample);
			var h = parseInt(samplestyle.height.substr(0, 1));
			var i = -1;
			this._states.map(function (obj, index) {
				if (obj.height === h) {
					i = index;
				}
			});

			if (i > -1 && i !== this._currentStateIndex) {
				// State changed
				this._currentStateIndex = i;
				return true;
			} else {
				// State didn't change
				return false;
			}
		}

		/**
   * Called when viewport is resized, fires off a custom event in case viewport state was changed by calling _update
   *
   * @memberOf ViewPortStateWatcher
   */

	}, {
		key: '_trigger',
		value: function _trigger() {
			var stateChanged = this._update();
			if (stateChanged) {
				var event = new CustomEvent('viewportstatechange', {
					detail: {
						current: this._states[this._currentStateIndex].label
					}
				});
				window.dispatchEvent(event);
			}
		}

		/**
   * Based on _currentStateIndex, this returns the label of the current viewport state.
   *
   * @returns {string} - The label of the current viewport state
   *
   * @memberOf ViewPortStateWatcher
   */

	}, {
		key: 'getState',
		value: function getState() {
			this._update();
			var result = this._states[this._currentStateIndex] ? this._states[this._currentStateIndex].label : false;
			return result;
		}

		/**
   * This method will try to match the current viewport state with the given states and runs a callback function if a match.
   *
   * @param {string, array} states - Either a string with a single state label, or an array containing states as strings. The string "all" will match with all viewport states.
   * @param {function} yesFn - Callback function that is executed when current viewport state matches any of the given states.
   * @param {any} [noFn=function(){}] - Optional callback function executed when current viewport state does not match any of the given states.
   *
   * @memberOf ViewPortStateWatcher
   *
   * @example
   * viewPortStateWatcher.run(
   *      ['small'],
   *      () => match,
   *      () => noMatch
   * );
   */

	}, {
		key: 'run',
		value: function run(states, yesFn) {
			var _this2 = this;

			var noFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

			var stateArr = typeof states === 'string' ? [states] : states;

			var check = function check() {
				if (stateArr.indexOf(_this2.getState()) > -1 || stateArr[0] === 'all') {
					yesFn();
				} else {
					noFn();
				}
			};

			if (this.getState() === false) {
				// CSS has not loaded yet to set the height of the sample element
				var link = document.querySelector('link[href$="/styles.css"]');
				link.addEventListener('load', check, { once: true });
			} else {
				check();
			}
		}

		/**
   * This method will execute run() once and sets an event listener to kick off run() again when a viewport state change occurs. See run() for parameters.
   * Do note that the success callback function will be run every time a viewportstatechange event takes place that matches with the given states.
   *
   * @memberOf ViewPortStateWatcher
   */

	}, {
		key: 'watch',
		value: function watch(states, yesFn) {
			var _this3 = this;

			var noFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

			this.run(states, yesFn, noFn);
			window.addEventListener('viewportstatechange', function () {
				return _this3.run(states, yesFn, noFn);
			});
		}
	}]);

	return ViewPortStateWatcher;
}();

var viewPortStateWatcher = new ViewPortStateWatcher(presetStates);

var init = function init() {
	viewPortStateWatcher._init();
};

document.addEventListener('DOMContentLoaded', init, { once: true });

exports.default = viewPortStateWatcher;

},{"custom-event-polyfill":150}],59:[function(require,module,exports){
/*!
 * Stickyfill � `position: sticky` polyfill
 * v. 2.1.0 | https://github.com/wilddeer/stickyfill
 * MIT License
 */

'use strict';

/*
 * 1. Check if the browser supports `position: sticky` natively or is too old to run the polyfill.
 *    If either of these is the case set `seppuku` flag. It will be checked later to disable key features
 *    of the polyfill, but the API will remain functional to avoid breaking things.
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var seppuku = false;

var isWindowDefined = typeof window !== 'undefined';

// The polyfill can�t function properly without `window` or `window.getComputedStyle`.
if (!isWindowDefined || !window.getComputedStyle) seppuku = true;
// Dont�t get in a way if the browser supports `position: sticky` natively.
else {
		var testNode = document.createElement('div');

		if (['', '-webkit-', '-moz-', '-ms-'].some(function (prefix) {
			try {
				testNode.style.position = prefix + 'sticky';
			} catch (e) {}

			return testNode.style.position != '';
		})) seppuku = true;
	}

/*
 * 2. �Global� vars used across the polyfill
 */
var isInitialized = false;

// Check if Shadow Root constructor exists to make further checks simpler
var shadowRootExists = typeof ShadowRoot !== 'undefined';

// Last saved scroll position
var scroll = {
	top: null,
	left: null
};

// Array of created Sticky instances
var stickies = [];

/*
 * 3. Utility functions
 */
function extend(targetObj, sourceObject) {
	for (var key in sourceObject) {
		if (sourceObject.hasOwnProperty(key)) {
			targetObj[key] = sourceObject[key];
		}
	}
}

function parseNumeric(val) {
	return parseFloat(val) || 0;
}

function getDocOffsetTop(node) {
	var docOffsetTop = 0;

	while (node) {
		docOffsetTop += node.offsetTop;
		node = node.offsetParent;
	}

	return docOffsetTop;
}

/*
 * 4. Sticky class
 */

var Sticky = function () {
	function Sticky(node) {
		_classCallCheck(this, Sticky);

		if (!(node instanceof HTMLElement)) throw new Error('First argument must be HTMLElement');
		if (stickies.some(function (sticky) {
			return sticky._node === node;
		})) throw new Error('Stickyfill is already applied to this node');

		this._node = node;
		this._stickyMode = null;
		this._active = false;

		stickies.push(this);

		this.refresh();
	}

	_createClass(Sticky, [{
		key: 'refresh',
		value: function refresh() {
			if (seppuku || this._removed) return;
			if (this._active) this._deactivate();

			var node = this._node;

			/*
    * 1. Save node computed props
    */
			var nodeComputedStyle = getComputedStyle(node);
			var nodeComputedProps = {
				position: nodeComputedStyle.position,
				top: nodeComputedStyle.top,
				display: nodeComputedStyle.display,
				marginTop: nodeComputedStyle.marginTop,
				marginBottom: nodeComputedStyle.marginBottom,
				marginLeft: nodeComputedStyle.marginLeft,
				marginRight: nodeComputedStyle.marginRight,
				cssFloat: nodeComputedStyle.cssFloat
			};

			/*
    * 2. Check if the node can be activated
    */
			if (isNaN(parseFloat(nodeComputedProps.top)) || nodeComputedProps.display == 'table-cell' || nodeComputedProps.display == 'none') return;

			this._active = true;

			/*
    * 3. Check if the current node position is `sticky`. If it is, it means that the browser supports sticky positioning,
    *    but the polyfill was force-enabled. We set the node�s position to `static` before continuing, so that the node
    *    is in it�s initial position when we gather its params.
    */
			var originalPosition = node.style.position;
			if (nodeComputedStyle.position == 'sticky' || nodeComputedStyle.position == '-webkit-sticky') node.style.position = 'static';

			/*
    * 4. Get necessary node parameters
    */
			var referenceNode = node.parentNode;
			var parentNode = shadowRootExists && referenceNode instanceof ShadowRoot ? referenceNode.host : referenceNode;
			var nodeWinOffset = node.getBoundingClientRect();
			var parentWinOffset = parentNode.getBoundingClientRect();
			var parentComputedStyle = getComputedStyle(parentNode);

			this._parent = {
				node: parentNode,
				styles: {
					position: parentNode.style.position
				},
				offsetHeight: parentNode.offsetHeight
			};
			this._offsetToWindow = {
				left: nodeWinOffset.left,
				right: document.documentElement.clientWidth - nodeWinOffset.right
			};
			this._offsetToParent = {
				top: nodeWinOffset.top - parentWinOffset.top - parseNumeric(parentComputedStyle.borderTopWidth),
				left: nodeWinOffset.left - parentWinOffset.left - parseNumeric(parentComputedStyle.borderLeftWidth),
				right: -nodeWinOffset.right + parentWinOffset.right - parseNumeric(parentComputedStyle.borderRightWidth)
			};
			this._styles = {
				position: originalPosition,
				top: node.style.top,
				bottom: node.style.bottom,
				left: node.style.left,
				right: node.style.right,
				width: node.style.width,
				marginTop: node.style.marginTop,
				marginLeft: node.style.marginLeft,
				marginRight: node.style.marginRight
			};

			var nodeTopValue = parseNumeric(nodeComputedProps.top);
			this._limits = {
				start: nodeWinOffset.top + window.pageYOffset - nodeTopValue,
				end: parentWinOffset.top + window.pageYOffset + parentNode.offsetHeight - parseNumeric(parentComputedStyle.borderBottomWidth) - node.offsetHeight - nodeTopValue - parseNumeric(nodeComputedProps.marginBottom)
			};

			/*
    * 5. Ensure that the node will be positioned relatively to the parent node
    */
			var parentPosition = parentComputedStyle.position;

			if (parentPosition != 'absolute' && parentPosition != 'relative') {
				parentNode.style.position = 'relative';
			}

			/*
    * 6. Recalc node position.
    *    It�s important to do this before clone injection to avoid scrolling bug in Chrome.
    */
			this._recalcPosition();

			/*
    * 7. Create a clone
    */
			var clone = this._clone = {};
			clone.node = document.createElement('div');

			// Apply styles to the clone
			extend(clone.node.style, {
				width: nodeWinOffset.right - nodeWinOffset.left + 'px',
				height: nodeWinOffset.bottom - nodeWinOffset.top + 'px',
				marginTop: nodeComputedProps.marginTop,
				marginBottom: nodeComputedProps.marginBottom,
				marginLeft: nodeComputedProps.marginLeft,
				marginRight: nodeComputedProps.marginRight,
				cssFloat: nodeComputedProps.cssFloat,
				padding: 0,
				border: 0,
				borderSpacing: 0,
				fontSize: '1em',
				position: 'static'
			});

			referenceNode.insertBefore(clone.node, node);
			clone.docOffsetTop = getDocOffsetTop(clone.node);
		}
	}, {
		key: '_recalcPosition',
		value: function _recalcPosition() {
			if (!this._active || this._removed) return;

			var stickyMode = scroll.top <= this._limits.start ? 'start' : scroll.top >= this._limits.end ? 'end' : 'middle';

			if (this._stickyMode == stickyMode) return;

			switch (stickyMode) {
				case 'start':
					extend(this._node.style, {
						position: 'absolute',
						left: this._offsetToParent.left + 'px',
						right: this._offsetToParent.right + 'px',
						top: this._offsetToParent.top + 'px',
						bottom: 'auto',
						width: 'auto',
						marginLeft: 0,
						marginRight: 0,
						marginTop: 0
					});
					break;

				case 'middle':
					extend(this._node.style, {
						position: 'fixed',
						left: this._offsetToWindow.left + 'px',
						right: this._offsetToWindow.right + 'px',
						top: this._styles.top,
						bottom: 'auto',
						width: 'auto',
						marginLeft: 0,
						marginRight: 0,
						marginTop: 0
					});
					break;

				case 'end':
					extend(this._node.style, {
						position: 'absolute',
						left: this._offsetToParent.left + 'px',
						right: this._offsetToParent.right + 'px',
						top: 'auto',
						bottom: 0,
						width: 'auto',
						marginLeft: 0,
						marginRight: 0
					});
					break;
			}

			this._stickyMode = stickyMode;
		}
	}, {
		key: '_fastCheck',
		value: function _fastCheck() {
			if (!this._active || this._removed) return;

			if (Math.abs(getDocOffsetTop(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) this.refresh();
		}
	}, {
		key: '_deactivate',
		value: function _deactivate() {
			var _this = this;

			if (!this._active || this._removed) return;

			this._clone.node.parentNode.removeChild(this._clone.node);
			delete this._clone;

			extend(this._node.style, this._styles);
			delete this._styles;

			// Check whether element�s parent node is used by other stickies.
			// If not, restore parent node�s styles.
			if (!stickies.some(function (sticky) {
				return sticky !== _this && sticky._parent && sticky._parent.node === _this._parent.node;
			})) {
				extend(this._parent.node.style, this._parent.styles);
			}
			delete this._parent;

			this._stickyMode = null;
			this._active = false;

			delete this._offsetToWindow;
			delete this._offsetToParent;
			delete this._limits;
		}
	}, {
		key: 'remove',
		value: function remove() {
			var _this2 = this;

			this._deactivate();

			stickies.some(function (sticky, index) {
				if (sticky._node === _this2._node) {
					stickies.splice(index, 1);
					return true;
				}
			});

			this._removed = true;
		}
	}]);

	return Sticky;
}();

/*
 * 5. Stickyfill API
 */


var Stickyfill = {
	stickies: stickies,
	Sticky: Sticky,

	forceSticky: function forceSticky() {
		seppuku = false;
		init();

		this.refreshAll();
	},
	addOne: function addOne(node) {
		// Check whether it�s a node
		if (!(node instanceof HTMLElement)) {
			// Maybe it�s a node list of some sort?
			// Take first node from the list then
			if (node.length && node[0]) node = node[0];else return;
		}

		// Check if Stickyfill is already applied to the node
		// and return existing sticky
		for (var i = 0; i < stickies.length; i++) {
			if (stickies[i]._node === node) return stickies[i];
		}

		// Create and return new sticky
		return new Sticky(node);
	},
	add: function add(nodeList) {
		// If it�s a node make an array of one node
		if (nodeList instanceof HTMLElement) nodeList = [nodeList];
		// Check if the argument is an iterable of some sort
		if (!nodeList.length) return;

		// Add every element as a sticky and return an array of created Sticky instances
		var addedStickies = [];

		var _loop = function _loop(i) {
			var node = nodeList[i];

			// If it�s not an HTMLElement � create an empty element to preserve 1-to-1
			// correlation with input list
			if (!(node instanceof HTMLElement)) {
				addedStickies.push(void 0);
				return 'continue';
			}

			// If Stickyfill is already applied to the node
			// add existing sticky
			if (stickies.some(function (sticky) {
				if (sticky._node === node) {
					addedStickies.push(sticky);
					return true;
				}
			})) return 'continue';

			// Create and add new sticky
			addedStickies.push(new Sticky(node));
		};

		for (var i = 0; i < nodeList.length; i++) {
			var _ret = _loop(i);

			if (_ret === 'continue') continue;
		}

		return addedStickies;
	},
	refreshAll: function refreshAll() {
		stickies.forEach(function (sticky) {
			return sticky.refresh();
		});
	},
	removeOne: function removeOne(node) {
		// Check whether it�s a node
		if (!(node instanceof HTMLElement)) {
			// Maybe it�s a node list of some sort?
			// Take first node from the list then
			if (node.length && node[0]) node = node[0];else return;
		}

		// Remove the stickies bound to the nodes in the list
		stickies.some(function (sticky) {
			if (sticky._node === node) {
				sticky.remove();
				return true;
			}
		});
	},
	remove: function remove(nodeList) {
		// If it�s a node make an array of one node
		if (nodeList instanceof HTMLElement) nodeList = [nodeList];
		// Check if the argument is an iterable of some sort
		if (!nodeList.length) return;

		// Remove the stickies bound to the nodes in the list

		var _loop2 = function _loop2(i) {
			var node = nodeList[i];

			stickies.some(function (sticky) {
				if (sticky._node === node) {
					sticky.remove();
					return true;
				}
			});
		};

		for (var i = 0; i < nodeList.length; i++) {
			_loop2(i);
		}
	},
	removeAll: function removeAll() {
		while (stickies.length) {
			stickies[0].remove();
		}
	}
};

/*
 * 6. Setup events (unless the polyfill was disabled)
 */
function init() {
	if (isInitialized) {
		return;
	}

	isInitialized = true;

	// Watch for scroll position changes and trigger recalc/refresh if needed
	function checkScroll() {
		if (window.pageXOffset != scroll.left) {
			scroll.top = window.pageYOffset;
			scroll.left = window.pageXOffset;

			Stickyfill.refreshAll();
		} else if (window.pageYOffset != scroll.top) {
			scroll.top = window.pageYOffset;
			scroll.left = window.pageXOffset;

			// recalc position for all stickies
			stickies.forEach(function (sticky) {
				return sticky._recalcPosition();
			});
		}
	}

	checkScroll();
	window.addEventListener('scroll', checkScroll);

	// Watch for window resizes and device orientation changes and trigger refresh
	window.addEventListener('resize', Stickyfill.refreshAll);
	window.addEventListener('orientationchange', Stickyfill.refreshAll);

	//Fast dirty check for layout changes every 500ms
	var fastCheckTimer = void 0;

	function startFastCheckTimer() {
		fastCheckTimer = setInterval(function () {
			stickies.forEach(function (sticky) {
				return sticky._fastCheck();
			});
		}, 500);
	}

	function stopFastCheckTimer() {
		clearInterval(fastCheckTimer);
	}

	var docHiddenKey = void 0;
	var visibilityChangeEventName = void 0;

	if ('hidden' in document) {
		docHiddenKey = 'hidden';
		visibilityChangeEventName = 'visibilitychange';
	} else if ('webkitHidden' in document) {
		docHiddenKey = 'webkitHidden';
		visibilityChangeEventName = 'webkitvisibilitychange';
	}

	if (visibilityChangeEventName) {
		if (!document[docHiddenKey]) startFastCheckTimer();

		document.addEventListener(visibilityChangeEventName, function () {
			if (document[docHiddenKey]) {
				stopFastCheckTimer();
			} else {
				startFastCheckTimer();
			}
		});
	} else startFastCheckTimer();
}

if (!seppuku) init();

/*
 * 7. Expose Stickyfill
 */
if (typeof module != 'undefined' && module.exports) {
	module.exports = Stickyfill;
} else if (isWindowDefined) {
	window.Stickyfill = Stickyfill;
}

},{}],60:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module))) module.exports = t();else if ("function" == typeof define && define.amd) define([], t);else {
    var n = t();for (var o in n) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[o] = n[o];
    }
  }
}(window, function () {
  return function (e) {
    var t = {};function n(o) {
      if (t[o]) return t[o].exports;var r = t[o] = { i: o, l: !1, exports: {} };return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: o });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var o = Object.create(null);if (n.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";
    n.r(t);var o,
        r = "fslightbox-",
        i = "".concat(r, "styles"),
        s = "".concat(r, "cursor-grabbing"),
        c = "".concat(r, "full-dimension"),
        a = "".concat(r, "flex-centered"),
        l = "".concat(r, "open"),
        u = "".concat(r, "transform-transition"),
        d = "".concat(r, "absoluted"),
        p = "".concat(r, "slide-btn"),
        f = "".concat(p, "-container"),
        h = "".concat(r, "fade-in"),
        m = "".concat(r, "fade-out"),
        g = h + "-strong",
        v = m + "-strong",
        b = "".concat(r, "opacity-"),
        x = "".concat(b, "1"),
        y = "".concat(r, "source");function S(e) {
      return (S = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return typeof e === "undefined" ? "undefined" : _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
      })(e);
    }"object" === ("undefined" == typeof document ? "undefined" : S(document)) && ((o = document.createElement("style")).className = i, o.appendChild(document.createTextNode(".fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-fade-in{animation:fslightbox-fade-in .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .3s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .3s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);touch-action:pinch-zoom;z-index:1000000000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg-path{transition:fill .15s ease;fill:#ddd}.fslightbox-nav{height:45px;width:100%;position:absolute;top:0;left:0}.fslightbox-slide-number-container{display:flex;justify-content:center;align-items:center;position:relative;height:100%;font-size:15px;color:#d7d7d7;z-index:0;max-width:55px;text-align:left}.fslightbox-slide-number-container .fslightbox-flex-centered{height:100%}.fslightbox-slash{display:block;margin:0 5px;width:1px;height:12px;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex;background:rgba(35,35,35,.65)}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightbox-toolbar-button:hover .fslightbox-svg-path{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%)}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}}.fslightbox-slide-btn-container:hover .fslightbox-svg-path{fill:#f1f1f1}.fslightbox-slide-btn{padding:9px;font-size:26px;background:rgba(35,35,35,.65)}@media (min-width:768px){.fslightbox-slide-btn{padding:10px}}@media (min-width:1600px){.fslightbox-slide-btn{padding:11px}}.fslightbox-slide-btn-container-previous{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-container-previous{padding-left:3px}}.fslightbox-slide-btn-container-next{right:0;padding-left:12px;padding-right:3px}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-left:22px}}@media (min-width:768px){.fslightbox-slide-btn-container-next{padding-left:30px}}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-right:6px}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightbox-invalid-file-wrapper{font-size:22px;color:#eaebeb;margin:auto}.fslightbox-video{object-fit:cover}.fslightbox-youtube-iframe{border:0}.fslightbox-loader{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightbox-loader div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightbox-loader 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightbox-loader div:nth-child(1){animation-delay:-.45s}.fslightbox-loader div:nth-child(2){animation-delay:-.3s}.fslightbox-loader div:nth-child(3){animation-delay:-.15s}@keyframes fslightbox-loader{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-source{position:relative;z-index:2;opacity:0}")), document.head.appendChild(o));function w(e) {
      var t,
          n = e.props,
          o = 0,
          r = {};this.getSourceTypeFromLocalStorageByUrl = function (e) {
        return t[e] ? t[e] : i(e);
      }, this.handleReceivedSourceTypeForUrl = function (e, n) {
        !1 === r[n] && (o--, "invalid" !== e ? r[n] = e : delete r[n], 0 === o && (!function (e, t) {
          for (var n in t) {
            e[n] = t[n];
          }
        }(t, r), localStorage.setItem("fslightbox-types", JSON.stringify(t))));
      };var i = function i(e) {
        o++, r[e] = !1;
      };n.disableLocalStorage ? (this.getSourceTypeFromLocalStorageByUrl = function () {}, this.handleReceivedSourceTypeForUrl = function () {}) : (t = JSON.parse(localStorage.getItem("fslightbox-types"))) || (t = {}, this.getSourceTypeFromLocalStorageByUrl = i);
    }function L(e, t, n, o) {
      var r = e.data,
          i = e.elements.sources,
          s = n / o,
          c = 0;this.adjustSize = function () {
        if ((c = r.maxSourceWidth / s) < r.maxSourceHeight) return n < r.maxSourceWidth && (c = o), a();c = o > r.maxSourceHeight ? r.maxSourceHeight : o, a();
      };var a = function a() {
        i[t].style.width = c * s + "px", i[t].style.height = c + "px";
      };
    }function C(e, t) {
      var n = this,
          o = e.collections.sourceSizers,
          r = e.elements,
          i = r.sourceAnimationWrappers,
          s = r.sourceMainWrappers,
          c = r.sources,
          a = e.resolve;function l(e, n) {
        o[t] = a(L, [t, e, n]), o[t].adjustSize();
      }this.runActions = function (e, o) {
        c[t].classList.add(x), i[t].classList.add(g), s[t].removeChild(s[t].firstChild), l(e, o), n.runActions = l;
      };
    }function F(e, t) {
      var n,
          o = this,
          r = e.elements.sources,
          i = e.props,
          s = (0, e.resolve)(C, [t]);this.handleImageLoad = function (e) {
        var t = e.target,
            n = t.naturalWidth,
            o = t.naturalHeight;s.runActions(n, o);
      }, this.handleVideoLoad = function (e) {
        var t = e.target,
            o = t.videoWidth,
            r = t.videoHeight;n = !0, s.runActions(o, r);
      }, this.handleNotMetaDatedVideoLoad = function () {
        n || o.handleYoutubeLoad();
      }, this.handleYoutubeLoad = function () {
        var e = 1920,
            t = 1080;i.maxYoutubeDimensions && (e = i.maxYoutubeDimensions.width, t = i.maxYoutubeDimensions.height), s.runActions(e, t);
      }, this.handleCustomLoad = function () {
        setTimeout(function () {
          var e = r[t];s.runActions(e.offsetWidth, e.offsetHeight);
        });
      };
    }function A(e, t, n) {
      var o = e.elements.sources,
          r = e.props.customClasses,
          i = r[t] ? r[t] : "";o[t].className = n + " " + i;
    }function I(e, t) {
      var n = e.elements.sources,
          o = e.props.customAttributes;for (var r in o[t]) {
        n[t].setAttribute(r, o[t][r]);
      }
    }function T(e, t) {
      var n = e.collections.sourceLoadHandlers,
          o = e.elements,
          r = o.sources,
          i = o.sourceAnimationWrappers,
          s = e.props.sources;r[t] = document.createElement("img"), A(e, t, y), r[t].src = s[t], r[t].onload = n[t].handleImageLoad, I(e, t), i[t].appendChild(r[t]);
    }function E(e, t) {
      var n = e.collections.sourceLoadHandlers,
          o = e.elements,
          r = o.sources,
          i = o.sourceAnimationWrappers,
          s = e.props,
          c = s.sources,
          a = s.videosPosters;r[t] = document.createElement("video"), A(e, t, y), r[t].src = c[t], r[t].onloadedmetadata = function (e) {
        n[t].handleVideoLoad(e);
      }, r[t].controls = !0, I(e, t), a[t] && (r[t].poster = a[t]);var l = document.createElement("source");l.src = c[t], r[t].appendChild(l), setTimeout(n[t].handleNotMetaDatedVideoLoad, 3e3), i[t].appendChild(r[t]);
    }function N(e, t) {
      var n = e.collections.sourceLoadHandlers,
          o = e.elements,
          i = o.sources,
          s = o.sourceAnimationWrappers,
          c = e.props.sources;i[t] = document.createElement("iframe"), A(e, t, "".concat(y, " ").concat(r, "youtube-iframe")), i[t].src = "https://www.youtube.com/embed/".concat(c[t].match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2], "?enablejsapi=1"), i[t].allowFullscreen = !0, I(e, t), s[t].appendChild(i[t]), n[t].handleYoutubeLoad();
    }function W(e, t) {
      var n = e.collections.sourceLoadHandlers,
          o = e.elements,
          r = o.sources,
          i = o.sourceAnimationWrappers,
          s = e.props.sources;r[t] = s[t], A(e, t, "".concat(r[t].className, " ").concat(y)), i[t].appendChild(r[t]), n[t].handleCustomLoad();
    }function z(e, t) {
      var n = e.elements,
          o = n.sources,
          i = n.sourceAnimationWrappers,
          s = n.sourceMainWrappers;e.props.sources;o[t] = document.createElement("div"), o[t].className = "".concat(r, "invalid-file-wrapper ").concat(a), o[t].innerHTML = "Invalid source", i[t].classList.add(g), i[t].appendChild(o[t]), s[t].removeChild(s[t].firstChild);
    }function M(e) {
      var t = e.collections,
          n = t.sourceLoadHandlers,
          o = t.sourcesRenderFunctions,
          r = e.core.sourceDisplayFacade,
          i = e.resolve;this.runActionsForSourceTypeAndIndex = function (t, s) {
        var c;switch ("invalid" !== t && (n[s] = i(F, [s])), t) {case "image":
            c = T;break;case "video":
            c = E;break;case "youtube":
            c = N;break;case "custom":
            c = W;break;default:
            c = z;}o[s] = function () {
          return c(e, s);
        }, r.displaySourcesWhichShouldBeDisplayed();
      };
    }function P() {
      var e,
          t,
          n,
          o = { isUrlYoutubeOne: function isUrlYoutubeOne(e) {
          var t = document.createElement("a");return t.href = e, "www.youtube.com" === t.hostname;
        }, getTypeFromResponseContentType: function getTypeFromResponseContentType(e) {
          return e.slice(0, e.indexOf("/"));
        } };function r() {
        if (4 !== n.readyState) {
          if (2 === n.readyState) {
            var e;switch (o.getTypeFromResponseContentType(n.getResponseHeader("content-type"))) {case "image":
                e = "image";break;case "video":
                e = "video";break;default:
                e = "invalid";}n.onreadystatechange = null, n.abort(), t(e);
          }
        } else t("invalid");
      }this.setUrlToCheck = function (t) {
        e = t;
      }, this.getSourceType = function (i) {
        if (o.isUrlYoutubeOne(e)) return i("youtube");t = i, (n = new XMLHttpRequest()).onreadystatechange = r, n.open("GET", e, !0), n.send();
      };
    }function H(e, t, n) {
      var o = e.props,
          r = o.types,
          i = o.type,
          s = o.sources,
          c = e.resolve;this.getTypeSetByClientForIndex = function (e) {
        var t;return r && r[e] ? t = r[e] : i && (t = i), t;
      }, this.retrieveTypeWithXhrForIndex = function (e) {
        var o = c(P);o.setUrlToCheck(s[e]), o.getSourceType(function (o) {
          t.handleReceivedSourceTypeForUrl(o, s[e]), n.runActionsForSourceTypeAndIndex(o, e);
        });
      };
    }function k(e, t) {
      var n = e.componentsServices.hideSourceLoaderIfNotYetCollection,
          o = e.elements,
          r = o.sourceWrappersContainer,
          i = o.sourceMainWrappers;i[t] = document.createElement("div"), i[t].className = "".concat(d, " ").concat(c, " ").concat(a), i[t].innerHTML = '<div class="fslightbox-loader"><div></div><div></div><div></div><div></div></div>';var s = i[t].firstChild;n[t] = function () {
        i[t].contains(s) && i[t].removeChild(s);
      }, r.appendChild(i[t]), function (e, t) {
        var n = e.elements,
            o = n.sourceMainWrappers,
            r = n.sourceAnimationWrappers;r[t] = document.createElement("div"), o[t].appendChild(r[t]);
      }(e, t);
    }function O(e, t, n, o) {
      var i = document.createElementNS("http://www.w3.org/2000/svg", "svg");i.setAttributeNS(null, "width", t), i.setAttributeNS(null, "height", t), i.setAttributeNS(null, "viewBox", n);var s = document.createElementNS("http://www.w3.org/2000/svg", "path");return s.setAttributeNS(null, "class", "".concat(r, "svg-path")), s.setAttributeNS(null, "d", o), i.appendChild(s), e.appendChild(i), i;
    }function R(e, t) {
      var n = document.createElement("div");return n.className = "".concat(r, "toolbar-button ").concat(a), n.title = t, e.appendChild(n), n;
    }function D(e, t) {
      var n = document.createElement("div");n.className = "".concat(r, "toolbar"), t.appendChild(n), function (e, t) {
        var n = e.componentsServices,
            o = e.core.fullscreenToggler,
            r = e.data,
            i = "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z",
            s = R(t);s.title = "Enter fullscreen";var c = O(s, "20px", "0 0 18 18", i);n.enterFullscreen = function () {
          r.isFullscreenOpen = !0, s.title = "Exit fullscreen", c.setAttributeNS(null, "width", "24px"), c.setAttributeNS(null, "height", "24px"), c.setAttributeNS(null, "viewBox", "0 0 950 1024"), c.firstChild.setAttributeNS(null, "d", "M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z");
        }, n.exitFullscreen = function () {
          r.isFullscreenOpen = !1, s.title = "Enter fullscreen", c.setAttributeNS(null, "width", "20px"), c.setAttributeNS(null, "height", "20px"), c.setAttributeNS(null, "viewBox", "0 0 18 18"), c.firstChild.setAttributeNS(null, "d", i);
        }, s.onclick = function () {
          r.isFullscreenOpen ? o.exitFullscreen() : o.enterFullscreen();
        };
      }(e, n), function (e, t) {
        var n = R(t, "Close");n.onclick = e.core.lightboxCloser.closeLightbox, O(n, "20px", "0 0 24 24", "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z");
      }(e, n);
    }function j(e) {
      var t = e.props.sources,
          n = e.elements.container,
          o = document.createElement("div");o.className = "".concat(r, "nav"), n.appendChild(o), D(e, o), t.length > 1 && function (e, t) {
        var n = e.componentsServices,
            o = e.props.sources,
            i = (e.stageIndexes, document.createElement("div"));i.className = "".concat(r, "slide-number-container");var s = document.createElement("div");s.className = a;var c = document.createElement("span");n.setSlideNumber = function (e) {
          return c.innerHTML = e;
        };var l = document.createElement("span");l.className = "".concat(r, "slash");var u = document.createElement("div");u.innerHTML = o.length, i.appendChild(s), s.appendChild(c), s.appendChild(l), s.appendChild(u), t.appendChild(i), setTimeout(function () {
          s.offsetWidth > 55 && (i.style.justifyContent = "flex-start");
        });
      }(e, o);
    }function X(e, t) {
      var n = this,
          o = e.elements.sourceMainWrappers,
          r = e.props,
          i = 0;this.byValue = function (e) {
        return i = e, n;
      }, this.negative = function () {
        s(-c());
      }, this.zero = function () {
        s(0);
      }, this.positive = function () {
        s(c());
      };var s = function s(e) {
        o[t].style.transform = "translateX(".concat(e + i, "px)"), i = 0;
      },
          c = function c() {
        return (1 + r.slideDistance) * innerWidth;
      };
    }function B(e, t, n, o) {
      var r = e.elements.container,
          i = n.charAt(0).toUpperCase() + n.slice(1),
          s = document.createElement("div");s.className = "".concat(f, " ").concat(f, "-").concat(n), s.title = "".concat(i, " slide"), s.onclick = t, function (e, t) {
        var n = document.createElement("div");n.className = "".concat(p, " ").concat(a), O(n, "20px", "0 0 20 20", t), e.appendChild(n);
      }(s, o), r.appendChild(s);
    }function U(e, t) {
      var n = e.classList;n.contains(t) && n.remove(t);
    }function V(e) {
      var t = this,
          n = e.core,
          o = n.eventsDispatcher,
          r = n.fullscreenToggler,
          i = n.globalEventsController,
          s = n.scrollbarRecompensor,
          c = e.data,
          a = e.elements,
          u = e.props,
          d = e.sourcePointerProps;this.isLightboxFadingOut = !1, this.runActions = function () {
        t.isLightboxFadingOut = !0, a.container.classList.add(v), i.removeListeners(), u.exitFullscreenOnClose && c.isFullscreenOpen && r.exitFullscreen(), setTimeout(function () {
          t.isLightboxFadingOut = !1, d.isPointering = !1, a.container.classList.remove(v), document.documentElement.classList.remove(l), s.removeRecompense(), document.body.removeChild(a.container), o.dispatch("onClose");
        }, 270);
      };
    }function Y(e) {
      var t,
          n,
          o,
          r = e.collections.sourceMainWrappersTransformers,
          i = e.componentsServices,
          s = e.core,
          c = s.classFacade,
          a = s.slideIndexChanger,
          l = s.sourceDisplayFacade,
          d = s.stageManager,
          p = e.elements.sourceAnimationWrappers,
          f = e.stageIndexes,
          v = (t = function t() {
        c.removeFromEachElementClassIfContains("sourceAnimationWrappers", m);
      }, n = 300, o = [], function () {
        o.push(!0), setTimeout(function () {
          o.pop(), o.length || t();
        }, n);
      });a.changeTo = function (e) {
        f.current = e, d.updateStageIndexes(), i.setSlideNumber(e + 1), l.displaySourcesWhichShouldBeDisplayed();
      }, a.jumpTo = function (e) {
        var t = f.current;a.changeTo(e), c.removeFromEachElementClassIfContains("sourceMainWrappers", u), U(p[t], g), U(p[t], h), p[t].classList.add(m), U(p[e], g), U(p[e], m), p[e].classList.add(h), v(), r[e].zero(), setTimeout(function () {
          t !== f.current && r[t].negative();
        }, 270);
      };
    }function _(e) {
      var t = e.core,
          n = t.lightboxCloser,
          o = t.fullscreenToggler,
          r = t.slideChangeFacade;this.listener = function (e) {
        switch (e.key) {case "Escape":
            n.closeLightbox();break;case "ArrowLeft":
            r.changeToPrevious();break;case "ArrowRight":
            r.changeToNext();break;case "F11":
            e.preventDefault(), o.enterFullscreen();}
      };
    }function q(e) {
      var t = e.collections.sourceMainWrappersTransformers,
          n = e.elements,
          o = e.sourcePointerProps,
          r = e.stageIndexes;function i(e, n) {
        t[e].byValue(o.swipedX)[n]();
      }this.runActionsForEvent = function (e) {
        var t, c, a;n.container.contains(n.slideSwipingHoverer) || n.container.appendChild(n.slideSwipingHoverer), t = n.container, c = s, (a = t.classList).contains(c) || a.add(c), o.swipedX = e.screenX - o.downScreenX, i(r.current, "zero"), void 0 !== r.previous && o.swipedX > 0 ? i(r.previous, "negative") : void 0 !== r.next && o.swipedX < 0 && i(r.next, "positive");
      };
    }function J(e) {
      var t = e.props.sources,
          n = e.resolve,
          o = e.sourcePointerProps,
          r = n(q);1 === t.length ? this.listener = function () {
        o.swipedX = 1;
      } : this.listener = function (e) {
        o.isPointering && r.runActionsForEvent(e);
      };
    }function G(e) {
      var t = e.collections.sourceMainWrappersTransformers,
          n = e.core.slideIndexChanger,
          o = e.elements.sourceMainWrappers,
          r = e.stageIndexes;this.runPositiveSwipedXActions = function () {
        void 0 === r.previous || (i("positive"), n.changeTo(r.previous)), i("zero");
      }, this.runNegativeSwipedXActions = function () {
        void 0 === r.next || (i("negative"), n.changeTo(r.next)), i("zero");
      };var i = function i(e) {
        o[r.current].classList.add(u), t[r.current][e]();
      };
    }function $(e, t) {
      e.contains(t) && e.removeChild(t);
    }function K(e) {
      var t = e.core.lightboxCloser,
          n = e.elements,
          o = e.resolve,
          r = e.sourcePointerProps,
          i = o(G);this.runNoSwipeActions = function () {
        $(n.container, n.slideSwipingHoverer), r.isSourceDownEventTarget || t.closeLightbox(), r.isPointering = !1;
      }, this.runActions = function () {
        r.swipedX > 0 ? i.runPositiveSwipedXActions() : i.runNegativeSwipedXActions(), $(n.container, n.slideSwipingHoverer), n.container.classList.remove(s), r.isPointering = !1;
      };
    }function Q(e) {
      var t = e.resolve,
          n = e.sourcePointerProps,
          o = t(K);this.listener = function () {
        n.isPointering && (n.swipedX ? o.runActions() : o.runNoSwipeActions());
      };
    }function Z(e) {
      var t, n, o;n = (t = e).core.classFacade, o = t.elements, n.removeFromEachElementClassIfContains = function (e, t) {
        for (var n = 0; n < o[e].length; n++) {
          U(o[e][n], t);
        }
      }, function (e) {
        var t = e.core.eventsDispatcher,
            n = e.props;t.dispatch = function (e) {
          n[e] && n[e]();
        };
      }(e), function (e) {
        var t = e.componentsServices,
            n = e.core.fullscreenToggler;n.enterFullscreen = function () {
          t.enterFullscreen();var e = document.documentElement;e.requestFullscreen ? e.requestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.msRequestFullscreen && e.msRequestFullscreen();
        }, n.exitFullscreen = function () {
          t.exitFullscreen(), document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
        };
      }(e), function (e) {
        var t = e.core,
            n = t.globalEventsController,
            o = t.windowResizeActioner,
            r = e.resolve,
            i = r(_),
            s = r(J),
            c = r(Q);n.attachListeners = function () {
          document.addEventListener("pointermove", s.listener), document.addEventListener("pointerup", c.listener), addEventListener("resize", o.runActions), document.addEventListener("keydown", i.listener);
        }, n.removeListeners = function () {
          document.removeEventListener("pointermove", s.listener), document.removeEventListener("pointerup", c.listener), removeEventListener("resize", o.runActions), document.removeEventListener("keydown", i.listener);
        };
      }(e), function (e) {
        var t = e.core.lightboxCloser,
            n = (0, e.resolve)(V);t.closeLightbox = function () {
          n.isLightboxFadingOut || n.runActions();
        };
      }(e), ne(e), function (e) {
        var t = e.data,
            n = e.core.scrollbarRecompensor;function o() {
          document.body.offsetHeight > innerHeight && (document.body.style.marginRight = t.scrollbarWidth + "px");
        }n.addRecompense = function () {
          "complete" === document.readyState ? o() : addEventListener("load", function () {
            o(), n.addRecompense = o;
          });
        }, n.removeRecompense = function () {
          document.body.style.removeProperty("margin-right");
        };
      }(e), function (e) {
        var t = e.core,
            n = t.slideChangeFacade,
            o = t.slideIndexChanger,
            r = t.stageManager;e.props.sources.length > 1 ? (n.changeToPrevious = function () {
          o.jumpTo(r.getPreviousSlideIndex());
        }, n.changeToNext = function () {
          o.jumpTo(r.getNextSlideIndex());
        }) : (n.changeToPrevious = function () {}, n.changeToNext = function () {});
      }(e), Y(e), function (e) {
        var t = e.core,
            n = t.classFacade,
            o = t.sourcesPointerDown,
            r = e.elements.sources,
            i = e.sourcePointerProps,
            s = e.stageIndexes;o.listener = function (e) {
          "VIDEO" !== e.target.tagName && e.preventDefault(), i.isPointering = !0, i.downScreenX = e.screenX, i.swipedX = 0;var t = r[s.current];t && t.contains(e.target) ? i.isSourceDownEventTarget = !0 : i.isSourceDownEventTarget = !1, n.removeFromEachElementClassIfContains("sourceMainWrappers", u);
        };
      }(e), function (e) {
        var t = e.collections.sourcesRenderFunctions,
            n = e.core.sourceDisplayFacade,
            o = e.props,
            r = e.stageIndexes;function i(e) {
          t[e] && (t[e](), delete t[e]);
        }n.displaySourcesWhichShouldBeDisplayed = function () {
          if (o.loadOnlyCurrentSource) i(r.current);else for (var e in r) {
            i(r[e]);
          }
        };
      }(e), function (e) {
        var t = e.stageIndexes,
            n = e.core.stageManager,
            o = e.props.sources.length - 1;n.getPreviousSlideIndex = function () {
          return 0 === t.current ? o : t.current - 1;
        }, n.getNextSlideIndex = function () {
          return t.current === o ? 0 : t.current + 1;
        }, n.updateStageIndexes = 0 === o ? function () {} : 1 === o ? function () {
          0 === t.current ? (t.next = 1, delete t.previous) : (t.previous = 0, delete t.next);
        } : function () {
          t.previous = n.getPreviousSlideIndex(), t.next = n.getNextSlideIndex();
        }, n.isSourceInStage = o <= 2 ? function () {
          return !0;
        } : function (e) {
          var n = t.current;if (0 === n && e === o || n === o && 0 === e) return !0;var r = n - e;return -1 === r || 0 === r || 1 === r;
        };
      }(e), function (e) {
        var t = e.collections,
            n = t.sourceMainWrappersTransformers,
            o = t.sourceSizers,
            r = e.core.windowResizeActioner,
            i = e.data,
            s = e.elements.sourceMainWrappers,
            c = e.props,
            a = e.stageIndexes;r.runActions = function () {
          innerWidth < 992 ? i.maxSourceWidth = innerWidth : i.maxSourceWidth = .9 * innerWidth, i.maxSourceHeight = .9 * innerHeight;for (var e = 0; e < c.sources.length; e++) {
            U(s[e], u), e !== a.current && n[e].negative(), o[e] && o[e].adjustSize();
          }
        };
      }(e);
    }function ee(e) {
      var t = e.props.disableLocalStorage;if (!t) {
        var n = localStorage.getItem("fslightbox-scrollbar-width");if (n) return n;
      }var o = function () {
        var e = document.createElement("div"),
            t = e.style;return t.visibility = "hidden", t.width = "100px", t.msOverflowStyle = "scrollbar", t.overflow = "scroll", e;
      }(),
          r = function () {
        var e = document.createElement("div");return e.style.width = "100%", e;
      }();document.body.appendChild(o);var i = o.offsetWidth;o.appendChild(r);var s = r.offsetWidth;document.body.removeChild(o);var c = i - s;return t || localStorage.setItem("fslightbox-scrollbar-width", c.toString()), c;
    }function te(e) {
      var t = e.core.eventsDispatcher,
          n = e.data,
          o = e.elements,
          i = e.props.sources;n.isInitialized = !0, n.scrollbarWidth = ee(e), function (e) {
        for (var t = e.collections.sourceMainWrappersTransformers, n = e.props.sources, o = e.resolve, r = 0; r < n.length; r++) {
          t[r] = o(X, [r]);
        }
      }(e), Z(e), o.container = document.createElement("div"), o.container.className = "".concat(r, "container ").concat(c, " ").concat(g), function (e) {
        var t = e.elements;t.slideSwipingHoverer = document.createElement("div"), t.slideSwipingHoverer.className = "".concat(r, "slide-swiping-hoverer ").concat(c, " ").concat(d);
      }(e), j(e), function (e) {
        var t = e.core.sourcesPointerDown,
            n = e.elements,
            o = e.props.sources,
            r = document.createElement("div");r.className = "".concat(d, " ").concat(c), n.container.appendChild(r), r.addEventListener("pointerdown", t.listener), n.sourceWrappersContainer = r;for (var i = 0; i < o.length; i++) {
          k(e, i);
        }
      }(e), i.length > 1 && function (e) {
        var t = e.core.slideChangeFacade;B(e, t.changeToPrevious, "previous", "M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z"), B(e, t.changeToNext, "next", "M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z");
      }(e), function (e) {
        for (var t = e.props.sources, n = e.resolve, o = n(w), r = n(M), i = n(H, [o, r]), s = 0; s < t.length; s++) {
          if ("string" == typeof t[s]) {
            var c = i.getTypeSetByClientForIndex(s);if (c) r.runActionsForSourceTypeAndIndex(c, s);else {
              var a = o.getSourceTypeFromLocalStorageByUrl(t[s]);a ? r.runActionsForSourceTypeAndIndex(a, s) : i.retrieveTypeWithXhrForIndex(s);
            }
          } else r.runActionsForSourceTypeAndIndex("custom", s);
        }
      }(e), t.dispatch("onInit");
    }function ne(e) {
      var t = e.collections.sourceMainWrappersTransformers,
          n = e.componentsServices,
          o = e.core,
          r = o.eventsDispatcher,
          i = o.lightboxOpener,
          s = o.globalEventsController,
          c = o.scrollbarRecompensor,
          a = o.sourceDisplayFacade,
          u = o.stageManager,
          d = o.windowResizeActioner,
          p = e.data,
          f = e.elements,
          h = e.stageIndexes;i.open = function () {
        var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;h.current = o, p.isInitialized ? r.dispatch("onShow") : te(e), u.updateStageIndexes(), a.displaySourcesWhichShouldBeDisplayed(), n.setSlideNumber(o + 1), document.body.appendChild(f.container), document.documentElement.classList.add(l), c.addRecompense(), s.attachListeners(), d.runActions(), t[h.current].zero(), r.dispatch("onOpen");
      };
    }function oe(e, t, n) {
      return (oe = re() ? Reflect.construct : function (e, t, n) {
        var o = [null];o.push.apply(o, t);var r = new (Function.bind.apply(e, o))();return n && ie(r, n.prototype), r;
      }).apply(null, arguments);
    }function re() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;if (Reflect.construct.sham) return !1;if ("function" == typeof Proxy) return !0;try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }function ie(e, t) {
      return (ie = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }function se(e) {
      return function (e) {
        if (Array.isArray(e)) return ce(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;if ("string" == typeof e) return ce(e, t);var n = Object.prototype.toString.call(e).slice(8, -1);"Object" === n && e.constructor && (n = e.constructor.name);if ("Map" === n || "Set" === n) return Array.from(e);if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ce(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }function ce(e, t) {
      (null == t || t > e.length) && (t = e.length);for (var n = 0, o = new Array(t); n < t; n++) {
        o[n] = e[n];
      }return o;
    }function ae() {
      for (var e = document.getElementsByTagName("a"), t = function t(_t) {
        if (!e[_t].hasAttribute("data-fslightbox")) return "continue";var n = e[_t].getAttribute("data-fslightbox"),
            o = e[_t].getAttribute("href");fsLightboxInstances[n] || (fsLightboxInstances[n] = new FsLightbox());var r = null;"#" === o.charAt(0) ? (r = document.getElementById(o.substring(1)).cloneNode(!0)).removeAttribute("id") : r = o, fsLightboxInstances[n].props.sources.push(r), fsLightboxInstances[n].elements.a.push(e[_t]);var i = fsLightboxInstances[n].props.sources.length - 1;e[_t].onclick = function (e) {
          e.preventDefault(), fsLightboxInstances[n].open(i);
        }, d("types", "data-type"), d("videosPosters", "data-video-poster"), d("customClasses", "data-class"), d("customClasses", "data-custom-class");for (var s = ["href", "data-fslightbox", "data-type", "data-video-poster", "data-class", "data-custom-class"], c = e[_t].attributes, a = fsLightboxInstances[n].props.customAttributes, l = 0; l < c.length; l++) {
          if (-1 === s.indexOf(c[l].name) && "data-" === c[l].name.substr(0, 5)) {
            a[i] || (a[i] = {});var u = c[l].name.substr(5);a[i][u] = c[l].value;
          }
        }function d(o, r) {
          e[_t].hasAttribute(r) && (fsLightboxInstances[n].props[o][i] = e[_t].getAttribute(r));
        }
      }, n = 0; n < e.length; n++) {
        t(n);
      }var o = Object.keys(fsLightboxInstances);window.fsLightbox = fsLightboxInstances[o[o.length - 1]];
    }window.FsLightbox = function () {
      var e = this;this.props = { sources: [], customAttributes: [], customClasses: [], types: [], videosPosters: [], slideDistance: .3 }, this.data = { isInitialized: !1, isFullscreenOpen: !1, maxSourceWidth: 0, maxSourceHeight: 0, scrollbarWidth: 0 }, this.sourcePointerProps = { downScreenX: null, isPointering: !1, isSourceDownEventTarget: !1, swipedX: 0 }, this.stageIndexes = {}, this.elements = { a: [], container: null, slideSwipingHoverer: null, sourceWrappersContainer: null, sources: [], sourceMainWrappers: [], sourceAnimationWrappers: [] }, this.componentsServices = { enterFullscreen: null, exitFullscreen: null, hideSourceLoaderIfNotYetCollection: [], setSlideNumber: function setSlideNumber() {} }, this.resolve = function (t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];return n.unshift(e), oe(t, se(n));
      }, this.collections = { sourceMainWrappersTransformers: [], sourceLoadHandlers: [], sourcesRenderFunctions: [], sourceSizers: [] }, this.core = { classFacade: {}, eventsDispatcher: {}, fullscreenToggler: {}, globalEventsController: {}, lightboxCloser: {}, lightboxOpener: {}, lightboxUpdater: {}, scrollbarRecompensor: {}, slideChangeFacade: {}, slideIndexChanger: {}, sourcesPointerDown: {}, sourceDisplayFacade: {}, stageManager: {}, windowResizeActioner: {} }, ne(this), this.open = function (t) {
        return e.core.lightboxOpener.open(t);
      }, this.close = function () {
        return e.core.lightboxCloser.closeLightbox();
      };
    }, window.fsLightboxInstances = {}, ae(), window.refreshFsLightbox = function () {
      for (var e in fsLightboxInstances) {
        var t = fsLightboxInstances[e].props;fsLightboxInstances[e] = new FsLightbox(), fsLightboxInstances[e].props = t, fsLightboxInstances[e].props.sources = [], fsLightboxInstances[e].elements.a = [];
      }ae();
    };
  }]);
});

},{}],61:[function(require,module,exports){
'use strict';

require('picturefill');

require('svgxuse');

require('dom4');

require('./Partials/_ordered-lists.js');

require('./Partials/_browser-detect.js');

require('./Partials/_file-upload.js');

require('./Partials/_forms.js');

require('./Partials/_search-result-category-switch.js');

require('./Partials/_google-maps.js');

require('./Partials/_focus.js');

require('./Modules/_site-navigation.js');

require('./Modules/_search.js');

require('./Modules/_page-footer.js');

require('./Modules/_masthead.js');

require('./Modules/_service-listing.js');

require('./Modules/_expand-listing.js');

require('./Modules/_article-law-section.js');

require('./Modules/_definitions.js');

require('./Modules/_listings.js');

require('./Modules/_page-utils.js');

require('./Modules/_rte.js');

require('./Modules/_hotspot-navigation.js');

require('./Modules/_clustered-blocks');

require('./Modules/_chat-header.js');

require('./Modules/_dealer-locator.js');

require('./Modules/_faq.js');

require('./Modules/_luk.js');

require('./Modules/_chat.js');

require('./Modules/_login.js');

require('./Modules/_gtm-csat-ces.js');

require('./Modules/_messages');

require('./Modules/_genesys-live-chat.js');

require('./Modules/slideshow.js');

require('./Modules/lightbox.js');

require('./Modules/_lightboxRDW.js');

var _init = require('./LRV/_init.js');

var _init2 = _interopRequireDefault(_init);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
	var html = document.documentElement;
	html.classList.remove('no-js');
	html.classList.add('js');
	document.body.classList.remove('js-stop-transitions');
	(0, _init2.default)();
};

document.addEventListener('DOMContentLoaded', init, { once: true });

},{"./LRV/_init.js":5,"./Modules/_article-law-section.js":6,"./Modules/_chat-header.js":7,"./Modules/_chat.js":8,"./Modules/_clustered-blocks":9,"./Modules/_dealer-locator.js":10,"./Modules/_definitions.js":11,"./Modules/_expand-listing.js":12,"./Modules/_faq.js":13,"./Modules/_genesys-live-chat.js":14,"./Modules/_gtm-csat-ces.js":15,"./Modules/_hotspot-navigation.js":16,"./Modules/_lightboxRDW.js":17,"./Modules/_listings.js":18,"./Modules/_login.js":19,"./Modules/_luk.js":20,"./Modules/_masthead.js":22,"./Modules/_messages":23,"./Modules/_page-footer.js":24,"./Modules/_page-utils.js":25,"./Modules/_rte.js":27,"./Modules/_search.js":28,"./Modules/_service-listing.js":29,"./Modules/_site-navigation.js":31,"./Modules/lightbox.js":33,"./Modules/slideshow.js":34,"./Partials/_browser-detect.js":35,"./Partials/_file-upload.js":39,"./Partials/_focus.js":42,"./Partials/_forms.js":43,"./Partials/_google-maps.js":44,"./Partials/_ordered-lists.js":47,"./Partials/_search-result-category-switch.js":51,"dom4":151,"picturefill":152,"svgxuse":154}],62:[function(require,module,exports){
require('../../modules/es6.array.find-index');
module.exports = require('../../modules/_core').Array.findIndex;

},{"../../modules/_core":79,"../../modules/es6.array.find-index":137}],63:[function(require,module,exports){
require('../../modules/es6.array.for-each');
module.exports = require('../../modules/_core').Array.forEach;

},{"../../modules/_core":79,"../../modules/es6.array.for-each":138}],64:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":79,"../../modules/es6.array.from":139,"../../modules/es6.string.iterator":144}],65:[function(require,module,exports){
require('../../modules/es6.array.index-of');
module.exports = require('../../modules/_core').Array.indexOf;

},{"../../modules/_core":79,"../../modules/es6.array.index-of":140}],66:[function(require,module,exports){
require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;

},{"../../modules/_core":79,"../../modules/es7.object.entries":146}],67:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;

},{"../../modules/_core":79,"../../modules/es6.object.keys":142}],68:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":79,"../../modules/es6.object.to-string":143,"../../modules/es6.symbol":145,"../../modules/es7.symbol.async-iterator":147,"../../modules/es7.symbol.observable":148}],69:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":134,"../../modules/es6.string.iterator":144,"../../modules/web.dom.iterable":149}],70:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],71:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"./_hide":91,"./_wks":135}],72:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":97}],73:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":126,"./_to-iobject":128,"./_to-length":129}],74:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":76,"./_ctx":81,"./_iobject":94,"./_to-length":129,"./_to-object":130}],75:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":96,"./_is-object":97,"./_wks":135}],76:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":75}],77:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":78,"./_wks":135}],78:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],79:[function(require,module,exports){
var core = module.exports = { version: '2.6.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],80:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":107,"./_property-desc":119}],81:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":70}],82:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],83:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":88}],84:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":89,"./_is-object":97}],85:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],86:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":112,"./_object-keys":115,"./_object-pie":116}],87:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":79,"./_ctx":81,"./_global":89,"./_hide":91,"./_redefine":120}],88:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],89:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],90:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],91:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":83,"./_object-dp":107,"./_property-desc":119}],92:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":89}],93:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":83,"./_dom-create":84,"./_fails":88}],94:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":78}],95:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":103,"./_wks":135}],96:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":78}],97:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],98:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":72}],99:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":91,"./_object-create":106,"./_property-desc":119,"./_set-to-string-tag":121,"./_wks":135}],100:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":87,"./_hide":91,"./_iter-create":99,"./_iterators":103,"./_library":104,"./_object-gpo":113,"./_redefine":120,"./_set-to-string-tag":121,"./_wks":135}],101:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":135}],102:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],103:[function(require,module,exports){
module.exports = {};

},{}],104:[function(require,module,exports){
module.exports = false;

},{}],105:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":88,"./_has":90,"./_is-object":97,"./_object-dp":107,"./_uid":132}],106:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":72,"./_dom-create":84,"./_enum-bug-keys":85,"./_html":92,"./_object-dps":108,"./_shared-key":122}],107:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":72,"./_descriptors":83,"./_ie8-dom-define":93,"./_to-primitive":131}],108:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":72,"./_descriptors":83,"./_object-dp":107,"./_object-keys":115}],109:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":83,"./_has":90,"./_ie8-dom-define":93,"./_object-pie":116,"./_property-desc":119,"./_to-iobject":128,"./_to-primitive":131}],110:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":111,"./_to-iobject":128}],111:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":85,"./_object-keys-internal":114}],112:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],113:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":90,"./_shared-key":122,"./_to-object":130}],114:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":73,"./_has":90,"./_shared-key":122,"./_to-iobject":128}],115:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":85,"./_object-keys-internal":114}],116:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],117:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":79,"./_export":87,"./_fails":88}],118:[function(require,module,exports){
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

},{"./_object-keys":115,"./_object-pie":116,"./_to-iobject":128}],119:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],120:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":79,"./_global":89,"./_has":90,"./_hide":91,"./_uid":132}],121:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":90,"./_object-dp":107,"./_wks":135}],122:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":123,"./_uid":132}],123:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":79,"./_global":89,"./_library":104}],124:[function(require,module,exports){
'use strict';
var fails = require('./_fails');

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

},{"./_fails":88}],125:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":82,"./_to-integer":127}],126:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":127}],127:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],128:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":82,"./_iobject":94}],129:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":127}],130:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":82}],131:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":97}],132:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],133:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":79,"./_global":89,"./_library":104,"./_object-dp":107,"./_wks-ext":134}],134:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":135}],135:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":89,"./_shared":123,"./_uid":132}],136:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":77,"./_core":79,"./_iterators":103,"./_wks":135}],137:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":71,"./_array-methods":74,"./_export":87}],138:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $forEach = require('./_array-methods')(0);
var STRICT = require('./_strict-method')([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":74,"./_export":87,"./_strict-method":124}],139:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":80,"./_ctx":81,"./_export":87,"./_is-array-iter":95,"./_iter-call":98,"./_iter-detect":101,"./_to-length":129,"./_to-object":130,"./core.get-iterator-method":136}],140:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $indexOf = require('./_array-includes')(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

},{"./_array-includes":73,"./_export":87,"./_strict-method":124}],141:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":71,"./_iter-define":100,"./_iter-step":102,"./_iterators":103,"./_to-iobject":128}],142:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":115,"./_object-sap":117,"./_to-object":130}],143:[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof');
var test = {};
test[require('./_wks')('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  require('./_redefine')(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

},{"./_classof":77,"./_redefine":120,"./_wks":135}],144:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":100,"./_string-at":125}],145:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":72,"./_descriptors":83,"./_enum-keys":86,"./_export":87,"./_fails":88,"./_global":89,"./_has":90,"./_hide":91,"./_is-array":96,"./_is-object":97,"./_library":104,"./_meta":105,"./_object-create":106,"./_object-dp":107,"./_object-gopd":109,"./_object-gopn":111,"./_object-gopn-ext":110,"./_object-gops":112,"./_object-keys":115,"./_object-pie":116,"./_property-desc":119,"./_redefine":120,"./_set-to-string-tag":121,"./_shared":123,"./_to-iobject":128,"./_to-primitive":131,"./_uid":132,"./_wks":135,"./_wks-define":133,"./_wks-ext":134}],146:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

},{"./_export":87,"./_object-to-array":118}],147:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":133}],148:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":133}],149:[function(require,module,exports){
var $iterators = require('./es6.array.iterator');
var getKeys = require('./_object-keys');
var redefine = require('./_redefine');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var wks = require('./_wks');
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}

},{"./_global":89,"./_hide":91,"./_iterators":103,"./_object-keys":115,"./_redefine":120,"./_wks":135,"./es6.array.iterator":141}],150:[function(require,module,exports){
// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

(function() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    var ce = new window.CustomEvent('test', { cancelable: true });
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
      // IE has problems with .preventDefault() on custom events
      // http://stackoverflow.com/questions/23349191
      throw new Error('Could not prevent default');
    }
  } catch (e) {
    var CustomEvent = function(event, params) {
      var evt, origPrevent;
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined
      };

      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(
        event,
        params.bubbles,
        params.cancelable,
        params.detail
      );
      origPrevent = evt.preventDefault;
      evt.preventDefault = function() {
        origPrevent.call(this);
        try {
          Object.defineProperty(this, 'defaultPrevented', {
            get: function() {
              return true;
            }
          });
        } catch (e) {
          this.defaultPrevented = true;
        }
      };
      return evt;
    };

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent; // expose definition to window
  }
})();

},{}],151:[function(require,module,exports){
/*!
Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
(function(window){'use strict';
  /* jshint loopfunc: true, noempty: false*/
  // http://www.w3.org/TR/dom/#element

  function createDocumentFragment() {
    return document.createDocumentFragment();
  }

  function createElement(nodeName) {
    return document.createElement(nodeName);
  }

  function enoughArguments(length, name) {
    if (!length) throw new Error(
      'Failed to construct ' +
        name +
      ': 1 argument required, but only 0 present.'
    );
  }

  function mutationMacro(nodes) {
    if (nodes.length === 1) {
      return textNodeIfString(nodes[0]);
    }
    for (var
      fragment = createDocumentFragment(),
      list = slice.call(nodes),
      i = 0; i < nodes.length; i++
    ) {
      fragment.appendChild(textNodeIfString(list[i]));
    }
    return fragment;
  }

  function textNodeIfString(node) {
    return typeof node === 'string' ? document.createTextNode(node) : node;
  }

  for(var
    head,
    property,
    TemporaryPrototype,
    TemporaryTokenList,
    wrapVerifyToken,
    document = window.document,
    hOP = Object.prototype.hasOwnProperty,
    defineProperty = Object.defineProperty || function (object, property, descriptor) {
      if (hOP.call(descriptor, 'value')) {
        object[property] = descriptor.value;
      } else {
        if (hOP.call(descriptor, 'get'))
          object.__defineGetter__(property, descriptor.get);
        if (hOP.call(descriptor, 'set'))
          object.__defineSetter__(property, descriptor.set);
      }
      return object;
    },
    indexOf = [].indexOf || function indexOf(value){
      var length = this.length;
      while(length--) {
        if (this[length] === value) {
          break;
        }
      }
      return length;
    },
    // http://www.w3.org/TR/domcore/#domtokenlist
    verifyToken = function (token) {
      if (!token) {
        throw 'SyntaxError';
      } else if (spaces.test(token)) {
        throw 'InvalidCharacterError';
      }
      return token;
    },
    DOMTokenList = function (node) {
      var
        noClassName = typeof node.className === 'undefined',
        className = noClassName ?
          (node.getAttribute('class') || '') : node.className,
        isSVG = noClassName || typeof className === 'object',
        value = (isSVG ?
          (noClassName ? className : className.baseVal) :
          className
        ).replace(trim, '')
      ;
      if (value.length) {
        properties.push.apply(
          this,
          value.split(spaces)
        );
      }
      this._isSVG = isSVG;
      this._ = node;
    },
    classListDescriptor = {
      get: function get() {
        return new DOMTokenList(this);
      },
      set: function(){}
    },
    trim = /^\s+|\s+$/g,
    spaces = /\s+/,
    SPACE = '\x20',
    CLASS_LIST = 'classList',
    toggle = function toggle(token, force) {
      if (this.contains(token)) {
        if (!force) {
          // force is not true (either false or omitted)
          this.remove(token);
        }
      } else if(force === undefined || force) {
        force = true;
        this.add(token);
      }
      return !!force;
    },
    DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype,
    Node = window.Node,
    NodePrototype = (Node || Element).prototype,
    CharacterData = window.CharacterData || Node,
    CharacterDataPrototype = CharacterData && CharacterData.prototype,
    DocumentType = window.DocumentType,
    DocumentTypePrototype = DocumentType && DocumentType.prototype,
    ElementPrototype = (window.Element || Node || window.HTMLElement).prototype,
    HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor,
    selectRemove = HTMLSelectElement.prototype.remove,
    SVGElement = window.SVGElement,
    properties = [
      'matches', (
        ElementPrototype.matchesSelector ||
        ElementPrototype.webkitMatchesSelector ||
        ElementPrototype.khtmlMatchesSelector ||
        ElementPrototype.mozMatchesSelector ||
        ElementPrototype.msMatchesSelector ||
        ElementPrototype.oMatchesSelector ||
        function matches(selector) {
          var parentNode = this.parentNode;
          return !!parentNode && -1 < indexOf.call(
            parentNode.querySelectorAll(selector),
            this
          );
        }
      ),
      'closest', function closest(selector) {
        var parentNode = this, matches;
        while (
          // document has no .matches
          (matches = parentNode && parentNode.matches) &&
          !parentNode.matches(selector)
        ) {
          parentNode = parentNode.parentNode;
        }
        return matches ? parentNode : null;
      },
      'prepend', function prepend() {
        var firstChild = this.firstChild,
            node = mutationMacro(arguments);
        if (firstChild) {
          this.insertBefore(node, firstChild);
        } else {
          this.appendChild(node);
        }
      },
      'append', function append() {
        this.appendChild(mutationMacro(arguments));
      },
      'before', function before() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.insertBefore(
            mutationMacro(arguments), this
          );
        }
      },
      'after', function after() {
        var parentNode = this.parentNode,
            nextSibling = this.nextSibling,
            node = mutationMacro(arguments);
        if (parentNode) {
          if (nextSibling) {
            parentNode.insertBefore(node, nextSibling);
          } else {
            parentNode.appendChild(node);
          }
        }
      },
      // https://dom.spec.whatwg.org/#dom-element-toggleattribute
      'toggleAttribute', function toggleAttribute(name, force) {
        var had = this.hasAttribute(name);
        if (1 < arguments.length) {
          if (had && !force)
            this.removeAttribute(name);
          else if (force && !had)
            this.setAttribute(name, "");
        }
        else if (had)
          this.removeAttribute(name);
        else
          this.setAttribute(name, "");
        return this.hasAttribute(name);
      },
      // WARNING - DEPRECATED - use .replaceWith() instead
      'replace', function replace() {
        this.replaceWith.apply(this, arguments);
      },
      'replaceWith', function replaceWith() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.replaceChild(
            mutationMacro(arguments),
            this
          );
        }
      },
      'remove', function remove() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.removeChild(this);
        }
      }
    ],
    slice = properties.slice,
    i = properties.length; i; i -= 2
  ) {
    property = properties[i - 2];
    if (!(property in ElementPrototype)) {
      ElementPrototype[property] = properties[i - 1];
    }
    // avoid unnecessary re-patch when the script is included
    // gazillion times without any reason whatsoever
    // https://github.com/WebReflection/dom4/pull/48
    if (property === 'remove' && !selectRemove._dom4) {
      // see https://github.com/WebReflection/dom4/issues/19
      (HTMLSelectElement.prototype[property] = function () {
        return 0 < arguments.length ?
          selectRemove.apply(this, arguments) :
          ElementPrototype.remove.call(this);
      })._dom4 = true;
    }
    // see https://github.com/WebReflection/dom4/issues/18
    if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
      if (CharacterData && !(property in CharacterDataPrototype)) {
        CharacterDataPrototype[property] = properties[i - 1];
      }
      if (DocumentType && !(property in DocumentTypePrototype)) {
        DocumentTypePrototype[property] = properties[i - 1];
      }
    }
    // see https://github.com/WebReflection/dom4/pull/26
    if (/^(?:append|prepend)$/.test(property)) {
      if (DocumentFragmentPrototype) {
        if (!(property in DocumentFragmentPrototype)) {
          DocumentFragmentPrototype[property] = properties[i - 1];
        }
      } else {
        try {
          createDocumentFragment().constructor.prototype[property] = properties[i - 1];
        } catch(o_O) {}
      }
    }
  }

  // most likely an IE9 only issue
  // see https://github.com/WebReflection/dom4/issues/6
  if (!createElement('a').matches('a')) {
    ElementPrototype[property] = function(matches){
      return function (selector) {
        return matches.call(
          this.parentNode ?
            this :
            createDocumentFragment().appendChild(this),
          selector
        );
      };
    }(ElementPrototype[property]);
  }

  // used to fix both old webkit and SVG
  DOMTokenList.prototype = {
    length: 0,
    add: function add() {
      for(var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if(!this.contains(token)) {
          properties.push.call(this, property);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    contains: (function(indexOf){
      return function contains(token) {
        i = indexOf.call(this, property = verifyToken(token));
        return -1 < i;
      };
    }([].indexOf || function (token) {
      i = this.length;
      while(i-- && this[i] !== token){}
      return i;
    })),
    item: function item(i) {
      return this[i] || null;
    },
    remove: function remove() {
      for(var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if(this.contains(token)) {
          properties.splice.call(this, i, 1);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    toggle: toggle,
    toString: function toString() {
      return properties.join.call(this, SPACE);
    }
  };

  if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
    defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
  }

  // http://www.w3.org/TR/dom/#domtokenlist
  // iOS 5.1 has completely screwed this property
  // classList in ElementPrototype is false
  // but it's actually there as getter
  if (!(CLASS_LIST in document.documentElement)) {
    defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
  } else {
    // iOS 5.1 and Nokia ASHA do not support multiple add or remove
    // trying to detect and fix that in here
    TemporaryTokenList = createElement('div')[CLASS_LIST];
    TemporaryTokenList.add('a', 'b', 'a');
    if ('a\x20b' != TemporaryTokenList) {
      // no other way to reach original methods in iOS 5.1
      TemporaryPrototype = TemporaryTokenList.constructor.prototype;
      if (!('add' in TemporaryPrototype)) {
        // ASHA double fails in here
        TemporaryPrototype = window.TemporaryTokenList.prototype;
      }
      wrapVerifyToken = function (original) {
        return function () {
          var i = 0;
          while (i < arguments.length) {
            original.call(this, arguments[i++]);
          }
        };
      };
      TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
      TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
      // toggle is broken too ^_^ ... let's fix it
      TemporaryPrototype.toggle = toggle;
    }
  }

  if (!('contains' in NodePrototype)) {
    defineProperty(NodePrototype, 'contains', {
      value: function (el) {
        while (el && el !== this) el = el.parentNode;
        return this === el;
      }
    });
  }

  if (!('head' in document)) {
    defineProperty(document, 'head', {
      get: function () {
        return head || (
          head = document.getElementsByTagName('head')[0]
        );
      }
    });
  }

  // requestAnimationFrame partial polyfill
  (function () {
    for (var
      raf,
      rAF = window.requestAnimationFrame,
      cAF = window.cancelAnimationFrame,
      prefixes = ['o', 'ms', 'moz', 'webkit'],
      i = prefixes.length;
      !cAF && i--;
    ) {
      rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
      cAF = window[prefixes[i] + 'CancelAnimationFrame'] ||
            window[prefixes[i] + 'CancelRequestAnimationFrame'];
    }
    if (!cAF) {
      // some FF apparently implemented rAF but no cAF 
      if (rAF) {
        raf = rAF;
        rAF = function (callback) {
          var goOn = true;
          raf(function () {
            if (goOn) callback.apply(this, arguments);
          });
          return function () {
            goOn = false;
          };
        };
        cAF = function (id) {
          id();
        };
      } else {
        rAF = function (callback) {
          return setTimeout(callback, 15, 15);
        };
        cAF = function (id) {
          clearTimeout(id);
        };
      }
    }
    window.requestAnimationFrame = rAF;
    window.cancelAnimationFrame = cAF;
  }());

  // http://www.w3.org/TR/dom/#customevent
  try{new window.CustomEvent('?');}catch(o_O){
    window.CustomEvent = function(
      eventName,
      defaultInitDict
    ){

      // the infamous substitute
      function CustomEvent(type, eventInitDict) {
        /*jshint eqnull:true */
        var event = document.createEvent(eventName);
        if (typeof type != 'string') {
          throw new Error('An event name must be provided');
        }
        if (eventName == 'Event') {
          event.initCustomEvent = initCustomEvent;
        }
        if (eventInitDict == null) {
          eventInitDict = defaultInitDict;
        }
        event.initCustomEvent(
          type,
          eventInitDict.bubbles,
          eventInitDict.cancelable,
          eventInitDict.detail
        );
        return event;
      }

      // attached at runtime
      function initCustomEvent(
        type, bubbles, cancelable, detail
      ) {
        /*jshint validthis:true*/
        this.initEvent(type, bubbles, cancelable);
        this.detail = detail;
      }

      // that's it
      return CustomEvent;
    }(
      // is this IE9 or IE10 ?
      // where CustomEvent is there
      // but not usable as construtor ?
      window.CustomEvent ?
        // use the CustomEvent interface in such case
        'CustomEvent' : 'Event',
        // otherwise the common compatible one
      {
        bubbles: false,
        cancelable: false,
        detail: null
      }
    );
  }

  // window.Event as constructor
  try { new Event('_'); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($Event) {
      function Event(type, init) {
        enoughArguments(arguments.length, 'Event');
        var out = document.createEvent('Event');
        if (!init) init = {};
        out.initEvent(
          type,
          !!init.bubbles,
          !!init.cancelable
        );
        return out;
      }
      Event.prototype = $Event.prototype;
      return Event;
    }(window.Event || function Event() {}));
    defineProperty(window, 'Event', {value: o_O});
    // Android 4 gotcha
    if (Event !== o_O) Event = o_O;
  }

  // window.KeyboardEvent as constructor
  try { new KeyboardEvent('_', {}); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($KeyboardEvent) {
      // code inspired by https://gist.github.com/termi/4654819
      var
        initType = 0,
        defaults = {
          char: '',
          key: '',
          location: 0,
          ctrlKey: false,
          shiftKey: false,
          altKey: false,
          metaKey: false,
          altGraphKey: false,
          repeat: false,
          locale: navigator.language,
          detail: 0,
          bubbles: false,
          cancelable: false,
          keyCode: 0,
          charCode: 0,
          which: 0
        },
        eventType
      ;
      try {
        var e = document.createEvent('KeyboardEvent');
        e.initKeyboardEvent(
          'keyup', false, false, window, '+', 3,
          true, false, true, false, false
        );
        initType = (
          (e.keyIdentifier || e.key) == '+' &&
          (e.keyLocation || e.location) == 3
        ) && (
          e.ctrlKey ? e.altKey ? 1 : 3 : e.shiftKey ? 2 : 4
        ) || 9;
      } catch(o_O) {}
      eventType = 0 < initType ? 'KeyboardEvent' : 'Event';

      function getModifier(init) {
        for (var
          out = [],
          keys = [
            'ctrlKey',
            'Control',
            'shiftKey',
            'Shift',
            'altKey',
            'Alt',
            'metaKey',
            'Meta',
            'altGraphKey',
            'AltGraph'
          ],
          i = 0; i < keys.length; i += 2
        ) {
          if (init[keys[i]])
            out.push(keys[i + 1]);
        }
        return out.join(' ');
      }

      function withDefaults(target, source) {
        for (var key in source) {
          if (
            source.hasOwnProperty(key) &&
            !source.hasOwnProperty.call(target, key)
          ) target[key] = source[key];
        }
        return target;
      }

      function withInitValues(key, out, init) {
        try {
          out[key] = init[key];
        } catch(o_O) {}
      }

      function KeyboardEvent(type, init) {
        enoughArguments(arguments.length, 'KeyboardEvent');
        init = withDefaults(init || {}, defaults);
        var
          out = document.createEvent(eventType),
          ctrlKey = init.ctrlKey,
          shiftKey = init.shiftKey,
          altKey = init.altKey,
          metaKey = init.metaKey,
          altGraphKey = init.altGraphKey,
          modifiers = initType > 3 ? getModifier(init) : null,
          key = String(init.key),
          chr = String(init.char),
          location = init.location,
          keyCode = init.keyCode || (
            (init.keyCode = key) &&
            key.charCodeAt(0)
          ) || 0,
          charCode = init.charCode || (
            (init.charCode = chr) &&
            chr.charCodeAt(0)
          ) || 0,
          bubbles = init.bubbles,
          cancelable = init.cancelable,
          repeat = init.repeat,
          locale = init.locale,
          view = init.view || window,
          args
        ;
        if (!init.which) init.which = init.keyCode;
        if ('initKeyEvent' in out) {
          out.initKeyEvent(
            type, bubbles, cancelable, view,
            ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode
          );
        } else if (0 < initType && 'initKeyboardEvent' in out) {
          args = [type, bubbles, cancelable, view];
          switch (initType) {
            case 1:
              args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
              break;
            case 2:
              args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
              break;
            case 3:
              args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
              break;
            case 4:
              args.push(key, location, modifiers, repeat, locale);
              break;
            default:
              args.push(char, key, location, modifiers, repeat, locale);
          }
          out.initKeyboardEvent.apply(out, args);
        } else {
          out.initEvent(type, bubbles, cancelable);
        }
        for (key in out) {
          if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
            withInitValues(key, out, init);
          }
        }
        return out;
      }
      KeyboardEvent.prototype = $KeyboardEvent.prototype;
      return KeyboardEvent;
    }(window.KeyboardEvent || function KeyboardEvent() {}));
    defineProperty(window, 'KeyboardEvent', {value: o_O});
    // Android 4 gotcha
    if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
  }

  // window.MouseEvent as constructor
  try { new MouseEvent('_', {}); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($MouseEvent) {
      function MouseEvent(type, init) {
        enoughArguments(arguments.length, 'MouseEvent');
        var out = document.createEvent('MouseEvent');
        if (!init) init = {};
        out.initMouseEvent(
          type,
          !!init.bubbles,
          !!init.cancelable,
          init.view || window,
          init.detail || 1,
          init.screenX || 0,
          init.screenY || 0,
          init.clientX || 0,
          init.clientY || 0,
          !!init.ctrlKey,
          !!init.altKey,
          !!init.shiftKey,
          !!init.metaKey,
          init.button || 0,
          init.relatedTarget || null
        );
        return out;
      }
      MouseEvent.prototype = $MouseEvent.prototype;
      return MouseEvent;
    }(window.MouseEvent || function MouseEvent() {}));
    defineProperty(window, 'MouseEvent', {value: o_O});
    // Android 4 gotcha
    if (MouseEvent !== o_O) MouseEvent = o_O;
  }

  if (!document.querySelectorAll('*').forEach) {
    (function () {
      function patch(what) {
        var querySelectorAll = what.querySelectorAll;
        what.querySelectorAll = function qSA(css) {
          var result = querySelectorAll.call(this, css);
          result.forEach = Array.prototype.forEach;
          return result;
        };
      }
      patch(document);
      patch(Element.prototype);
    }());
  }

  try {
    // https://drafts.csswg.org/selectors-4/#the-scope-pseudo
    document.querySelector(':scope *');
  } catch(o_O) {
    (function () {
      var dataScope = 'data-scope-' + (Math.random() * 1e9 >>> 0);
      var proto = Element.prototype;
      var querySelector = proto.querySelector;
      var querySelectorAll = proto.querySelectorAll;
      proto.querySelector = function qS(css) {
        return find(this, querySelector, css);
      };
      proto.querySelectorAll = function qSA(css) {
        return find(this, querySelectorAll, css);
      };
      function find(node, method, css) {
        node.setAttribute(dataScope, null);
        var result = method.call(
          node,
          String(css).replace(
            /(^|,\s*)(:scope([ >]|$))/g,
            function ($0, $1, $2, $3) {
              return $1 + '[' + dataScope + ']' + ($3 || ' ');
            }
          )
        );
        node.removeAttribute(dataScope);
        return result;
      }
    }());
  }
}(window));
(function (global){'use strict';

  // a WeakMap fallback for DOM nodes only used as key
  var DOMMap = global.WeakMap || (function () {

    var
      counter = 0,
      dispatched = false,
      drop = false,
      value
    ;

    function dispatch(key, ce, shouldDrop) {
      drop = shouldDrop;
      dispatched = false;
      value = undefined;
      key.dispatchEvent(ce);
    }

    function Handler(value) {
      this.value = value;
    }

    Handler.prototype.handleEvent = function handleEvent(e) {
      dispatched = true;
      if (drop) {
        e.currentTarget.removeEventListener(e.type, this, false);
      } else {
        value = this.value;
      }
    };

    function DOMMap() {
      counter++;  // make id clashing highly improbable
      this.__ce__ = new Event(('@DOMMap:' + counter) + Math.random());
    }

    DOMMap.prototype = {
      'constructor': DOMMap,
      'delete': function del(key) {
        return dispatch(key, this.__ce__, true), dispatched;
      },
      'get': function get(key) {
        dispatch(key, this.__ce__, false);
        var v = value;
        value = undefined;
        return v;
      },
      'has': function has(key) {
        return dispatch(key, this.__ce__, false), dispatched;
      },
      'set': function set(key, value) {
        dispatch(key, this.__ce__, true);
        key.addEventListener(this.__ce__.type, new Handler(value), false);
        return this;
      },
    };

    return DOMMap;

  }());

  function Dict() {}
  Dict.prototype = (Object.create || Object)(null);

  // https://dom.spec.whatwg.org/#interface-eventtarget

  function createEventListener(type, callback, options) {
    function eventListener(e) {
      if (eventListener.once) {
        e.currentTarget.removeEventListener(
          e.type,
          callback,
          eventListener
        );
        eventListener.removed = true;
      }
      if (eventListener.passive) {
        e.preventDefault = createEventListener.preventDefault;
      }
      if (typeof eventListener.callback === 'function') {
        /* jshint validthis: true */
        eventListener.callback.call(this, e);
      } else if (eventListener.callback) {
        eventListener.callback.handleEvent(e);
      }
      if (eventListener.passive) {
        delete e.preventDefault;
      }
    }
    eventListener.type = type;
    eventListener.callback = callback;
    eventListener.capture = !!options.capture;
    eventListener.passive = !!options.passive;
    eventListener.once = !!options.once;
    // currently pointless but specs say to use it, so ...
    eventListener.removed = false;
    return eventListener;
  }

  createEventListener.preventDefault = function preventDefault() {};

  var
    Event = global.CustomEvent,
    dE = global.dispatchEvent,
    aEL = global.addEventListener,
    rEL = global.removeEventListener,
    counter = 0,
    increment = function () { counter++; },
    indexOf = [].indexOf || function indexOf(value){
      var length = this.length;
      while(length--) {
        if (this[length] === value) {
          break;
        }
      }
      return length;
    },
    getListenerKey = function (options) {
      return ''.concat(
        options.capture ? '1' : '0',
        options.passive ? '1' : '0',
        options.once ? '1' : '0'
      );
    },
    augment
  ;

  try {
    aEL('_', increment, {once: true});
    dE(new Event('_'));
    dE(new Event('_'));
    rEL('_', increment, {once: true});
  } catch(o_O) {}

  if (counter !== 1) {
    (function () {
      var dm = new DOMMap();
      function createAEL(aEL) {
        return function addEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var
              info = dm.get(this),
              key = getListenerKey(options),
              i, tmp, wrap
            ;
            if (!info) dm.set(this, (info = new Dict()));
            if (!(type in info)) info[type] = {
              handler: [],
              wrap: []
            };
            tmp = info[type];
            i = indexOf.call(tmp.handler, handler);
            if (i < 0) {
              i = tmp.handler.push(handler) - 1;
              tmp.wrap[i] = (wrap = new Dict());
            } else {
              wrap = tmp.wrap[i];
            }
            if (!(key in wrap)) {
              wrap[key] = createEventListener(type, handler, options);
              aEL.call(this, type, wrap[key], wrap[key].capture);
            }
          } else {
            aEL.call(this, type, handler, options);
          }
        };
      }
      function createREL(rEL) {
        return function removeEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var
              info = dm.get(this),
              key, i, tmp, wrap
            ;
            if (info && (type in info)) {
              tmp = info[type];
              i = indexOf.call(tmp.handler, handler);
              if (-1 < i) {
                key = getListenerKey(options);
                wrap = tmp.wrap[i];
                if (key in wrap) {
                  rEL.call(this, type, wrap[key], wrap[key].capture);
                  delete wrap[key];
                  // return if there are other wraps
                  for (key in wrap) return;
                  // otherwise remove all the things
                  tmp.handler.splice(i, 1);
                  tmp.wrap.splice(i, 1);
                  // if there are no other handlers
                  if (tmp.handler.length === 0)
                    // drop the info[type] entirely
                    delete info[type];
                }
              }
            }
          } else {
            rEL.call(this, type, handler, options);
          }
        };
      }

      augment = function (Constructor) {
        if (!Constructor) return;
        var proto = Constructor.prototype;
        proto.addEventListener = createAEL(proto.addEventListener);
        proto.removeEventListener = createREL(proto.removeEventListener);
      };

      if (global.EventTarget) {
        augment(EventTarget);
      } else {
        augment(global.Text);
        augment(global.Element || global.HTMLElement);
        augment(global.HTMLDocument);
        augment(global.Window || {prototype:global});
        augment(global.XMLHttpRequest);
      }

    }());
  }

}(self));

},{}],152:[function(require,module,exports){
/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
/*! Gecko-Picture - v1.0
 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
 * Firefox's early picture implementation (prior to FF41) is static and does
 * not react to viewport changes. This tiny module fixes this.
 */
(function(window) {
	/*jshint eqnull:true */
	var ua = navigator.userAgent;

	if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
		addEventListener("resize", (function() {
			var timer;

			var dummySrc = document.createElement("source");

			var fixRespimg = function(img) {
				var source, sizes;
				var picture = img.parentNode;

				if (picture.nodeName.toUpperCase() === "PICTURE") {
					source = dummySrc.cloneNode();

					picture.insertBefore(source, picture.firstElementChild);
					setTimeout(function() {
						picture.removeChild(source);
					});
				} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
					img._pfLastSize = img.offsetWidth;
					sizes = img.sizes;
					img.sizes += ",100vw";
					setTimeout(function() {
						img.sizes = sizes;
					});
				}
			};

			var findPictureImgs = function() {
				var i;
				var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
				for (i = 0; i < imgs.length; i++) {
					fixRespimg(imgs[i]);
				}
			};
			var onResize = function() {
				clearTimeout(timer);
				timer = setTimeout(findPictureImgs, 99);
			};
			var mq = window.matchMedia && matchMedia("(orientation: landscape)");
			var init = function() {
				onResize();

				if (mq && mq.addListener) {
					mq.addListener(onResize);
				}
			};

			dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

			if (/^[c|i]|d$/.test(document.readyState || "")) {
				init();
			} else {
				document.addEventListener("DOMContentLoaded", init);
			}

			return onResize;
		})());
	}
})(window);

/*! Picturefill - v3.0.2
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
 *  License: MIT
 */

(function( window, document, undefined ) {
	// Enable strict mode
	"use strict";

	// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
	document.createElement( "picture" );

	var warn, eminpx, alwaysCheckWDescriptor, evalId;
	// local object for method references and testing exposure
	var pf = {};
	var isSupportTestReady = false;
	var noop = function() {};
	var image = document.createElement( "img" );
	var getImgAttr = image.getAttribute;
	var setImgAttr = image.setAttribute;
	var removeImgAttr = image.removeAttribute;
	var docElem = document.documentElement;
	var types = {};
	var cfg = {
		//resource selection:
		algorithm: ""
	};
	var srcAttr = "data-pfsrc";
	var srcsetAttr = srcAttr + "set";
	// ua sniffing is done for undetectable img loading features,
	// to do some non crucial perf optimizations
	var ua = navigator.userAgent;
	var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
	var curSrcProp = "currentSrc";
	var regWDesc = /\s+\+?\d+(e\d+)?w/;
	var regSize = /(\([^)]+\))?\s*(.+)/;
	var setOptions = window.picturefillCFG;
	/**
	 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
	 */
	// baseStyle also used by getEmValue (i.e.: width: 1em is important)
	var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
	var fsCss = "font-size:100%!important;";
	var isVwDirty = true;

	var cssCache = {};
	var sizeLengthCache = {};
	var DPR = window.devicePixelRatio;
	var units = {
		px: 1,
		"in": 96
	};
	var anchor = document.createElement( "a" );
	/**
	 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
	 * @type {boolean}
	 */
	var alreadyRun = false;

	// Reusable, non-"g" Regexes

	// (Don't use \s, to avoid matching non-breaking space.)
	var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
	    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
	    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
	    regexTrailingCommas = /[,]+$/,
	    regexNonNegativeInteger = /^\d+$/,

	    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
	    // Must include at least one digit.
	    // According to spec tests any decimal point must be followed by a digit.
	    // No leading plus sign is allowed.)
	    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

	var on = function(obj, evt, fn, capture) {
		if ( obj.addEventListener ) {
			obj.addEventListener(evt, fn, capture || false);
		} else if ( obj.attachEvent ) {
			obj.attachEvent( "on" + evt, fn);
		}
	};

	/**
	 * simple memoize function:
	 */

	var memoize = function(fn) {
		var cache = {};
		return function(input) {
			if ( !(input in cache) ) {
				cache[ input ] = fn(input);
			}
			return cache[ input ];
		};
	};

	// UTILITY FUNCTIONS

	// Manual is faster than RegEx
	// http://jsperf.com/whitespace-character/5
	function isSpace(c) {
		return (c === "\u0020" || // space
		        c === "\u0009" || // horizontal tab
		        c === "\u000A" || // new line
		        c === "\u000C" || // form feed
		        c === "\u000D");  // carriage return
	}

	/**
	 * gets a mediaquery and returns a boolean or gets a css length and returns a number
	 * @param css mediaqueries or css length
	 * @returns {boolean|number}
	 *
	 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
	 */
	var evalCSS = (function() {

		var regLength = /^([\d\.]+)(em|vw|px)$/;
		var replace = function() {
			var args = arguments, index = 0, string = args[0];
			while (++index in args) {
				string = string.replace(args[index], args[++index]);
			}
			return string;
		};

		var buildStr = memoize(function(css) {

			return "return " + replace((css || "").toLowerCase(),
				// interpret `and`
				/\band\b/g, "&&",

				// interpret `,`
				/,/g, "||",

				// interpret `min-` as >=
				/min-([a-z-\s]+):/g, "e.$1>=",

				// interpret `max-` as <=
				/max-([a-z-\s]+):/g, "e.$1<=",

				//calc value
				/calc([^)]+)/g, "($1)",

				// interpret css values
				/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
				//make eval less evil
				/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
			) + ";";
		});

		return function(css, length) {
			var parsedLength;
			if (!(css in cssCache)) {
				cssCache[css] = false;
				if (length && (parsedLength = css.match( regLength ))) {
					cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
				} else {
					/*jshint evil:true */
					try{
						cssCache[css] = new Function("e", buildStr(css))(units);
					} catch(e) {}
					/*jshint evil:false */
				}
			}
			return cssCache[css];
		};
	})();

	var setResolution = function( candidate, sizesattr ) {
		if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
			candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
			candidate.res = candidate.w / candidate.cWidth ;
		} else {
			candidate.res = candidate.d;
		}
		return candidate;
	};

	/**
	 *
	 * @param opt
	 */
	var picturefill = function( opt ) {

		if (!isSupportTestReady) {return;}

		var elements, i, plen;

		var options = opt || {};

		if ( options.elements && options.elements.nodeType === 1 ) {
			if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
				options.elements =  [ options.elements ];
			} else {
				options.context = options.elements;
				options.elements =  null;
			}
		}

		elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );

		if ( (plen = elements.length) ) {

			pf.setupRun( options );
			alreadyRun = true;

			// Loop through all elements
			for ( i = 0; i < plen; i++ ) {
				pf.fillImg(elements[ i ], options);
			}

			pf.teardownRun( options );
		}
	};

	/**
	 * outputs a warning for the developer
	 * @param {message}
	 * @type {Function}
	 */
	warn = ( window.console && console.warn ) ?
		function( message ) {
			console.warn( message );
		} :
		noop
	;

	if ( !(curSrcProp in image) ) {
		curSrcProp = "src";
	}

	// Add support for standard mime types.
	types[ "image/jpeg" ] = true;
	types[ "image/gif" ] = true;
	types[ "image/png" ] = true;

	function detectTypeSupport( type, typeUri ) {
		// based on Modernizr's lossless img-webp test
		// note: asynchronous
		var image = new window.Image();
		image.onerror = function() {
			types[ type ] = false;
			picturefill();
		};
		image.onload = function() {
			types[ type ] = image.width === 1;
			picturefill();
		};
		image.src = typeUri;
		return "pending";
	}

	// test svg support
	types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );

	/**
	 * updates the internal vW property with the current viewport width in px
	 */
	function updateMetrics() {

		isVwDirty = false;
		DPR = window.devicePixelRatio;
		cssCache = {};
		sizeLengthCache = {};

		pf.DPR = DPR || 1;

		units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
		units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);

		units.vw = units.width / 100;
		units.vh = units.height / 100;

		evalId = [ units.height, units.width, DPR ].join("-");

		units.em = pf.getEmValue();
		units.rem = units.em;
	}

	function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
		var bonusFactor, tooMuch, bonus, meanDensity;

		//experimental
		if (cfg.algorithm === "saveData" ){
			if ( lowerValue > 2.7 ) {
				meanDensity = dprValue + 1;
			} else {
				tooMuch = higherValue - dprValue;
				bonusFactor = Math.pow(lowerValue - 0.6, 1.5);

				bonus = tooMuch * bonusFactor;

				if (isCached) {
					bonus += 0.1 * bonusFactor;
				}

				meanDensity = lowerValue + bonus;
			}
		} else {
			meanDensity = (dprValue > 1) ?
				Math.sqrt(lowerValue * higherValue) :
				lowerValue;
		}

		return meanDensity > dprValue;
	}

	function applyBestCandidate( img ) {
		var srcSetCandidates;
		var matchingSet = pf.getSet( img );
		var evaluated = false;
		if ( matchingSet !== "pending" ) {
			evaluated = evalId;
			if ( matchingSet ) {
				srcSetCandidates = pf.setRes( matchingSet );
				pf.applySetCandidate( srcSetCandidates, img );
			}
		}
		img[ pf.ns ].evaled = evaluated;
	}

	function ascendingSort( a, b ) {
		return a.res - b.res;
	}

	function setSrcToCur( img, src, set ) {
		var candidate;
		if ( !set && src ) {
			set = img[ pf.ns ].sets;
			set = set && set[set.length - 1];
		}

		candidate = getCandidateForSrc(src, set);

		if ( candidate ) {
			src = pf.makeUrl(src);
			img[ pf.ns ].curSrc = src;
			img[ pf.ns ].curCan = candidate;

			if ( !candidate.res ) {
				setResolution( candidate, candidate.set.sizes );
			}
		}
		return candidate;
	}

	function getCandidateForSrc( src, set ) {
		var i, candidate, candidates;
		if ( src && set ) {
			candidates = pf.parseSet( set );
			src = pf.makeUrl(src);
			for ( i = 0; i < candidates.length; i++ ) {
				if ( src === pf.makeUrl(candidates[ i ].url) ) {
					candidate = candidates[ i ];
					break;
				}
			}
		}
		return candidate;
	}

	function getAllSourceElements( picture, candidates ) {
		var i, len, source, srcset;

		// SPEC mismatch intended for size and perf:
		// actually only source elements preceding the img should be used
		// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
		var sources = picture.getElementsByTagName( "source" );

		for ( i = 0, len = sources.length; i < len; i++ ) {
			source = sources[ i ];
			source[ pf.ns ] = true;
			srcset = source.getAttribute( "srcset" );

			// if source does not have a srcset attribute, skip
			if ( srcset ) {
				candidates.push( {
					srcset: srcset,
					media: source.getAttribute( "media" ),
					type: source.getAttribute( "type" ),
					sizes: source.getAttribute( "sizes" )
				} );
			}
		}
	}

	/**
	 * Srcset Parser
	 * By Alex Bell |  MIT License
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 */

	// 1. Let input be the value passed to this algorithm.
	// (TO-DO : Explain what "set" argument is here. Maybe choose a more
	// descriptive & more searchable name.  Since passing the "set" in really has
	// nothing to do with parsing proper, I would prefer this assignment eventually
	// go in an external fn.)
	function parseSrcset(input, set) {

		function collectCharacters(regEx) {
			var chars,
			    match = regEx.exec(input.substring(pos));
			if (match) {
				chars = match[ 0 ];
				pos += chars.length;
				return chars;
			}
		}

		var inputLength = input.length,
		    url,
		    descriptors,
		    currentDescriptor,
		    state,
		    c,

		    // 2. Let position be a pointer into input, initially pointing at the start
		    //    of the string.
		    pos = 0,

		    // 3. Let candidates be an initially empty source set.
		    candidates = [];

		/**
		* Adds descriptor properties to a candidate, pushes to the candidates array
		* @return undefined
		*/
		// (Declared outside of the while loop so that it's only created once.
		// (This fn is defined before it is used, in order to pass JSHINT.
		// Unfortunately this breaks the sequencing of the spec comments. :/ )
		function parseDescriptors() {

			// 9. Descriptor parser: Let error be no.
			var pError = false,

			// 10. Let width be absent.
			// 11. Let density be absent.
			// 12. Let future-compat-h be absent. (We're implementing it now as h)
			    w, d, h, i,
			    candidate = {},
			    desc, lastChar, value, intVal, floatVal;

			// 13. For each descriptor in descriptors, run the appropriate set of steps
			// from the following list:
			for (i = 0 ; i < descriptors.length; i++) {
				desc = descriptors[ i ];

				lastChar = desc[ desc.length - 1 ];
				value = desc.substring(0, desc.length - 1);
				intVal = parseInt(value, 10);
				floatVal = parseFloat(value);

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0077 LATIN SMALL LETTER W character
				if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

					// If width and density are not both absent, then let error be yes.
					if (w || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes.
					// Otherwise, let width be the result.
					if (intVal === 0) {pError = true;} else {w = intVal;}

				// If the descriptor consists of a valid floating-point number followed by
				// a U+0078 LATIN SMALL LETTER X character
				} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

					// If width, density and future-compat-h are not all absent, then let error
					// be yes.
					if (w || d || h) {pError = true;}

					// Apply the rules for parsing floating-point number values to the descriptor.
					// If the result is less than zero, let error be yes. Otherwise, let density
					// be the result.
					if (floatVal < 0) {pError = true;} else {d = floatVal;}

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0068 LATIN SMALL LETTER H character
				} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

					// If height and density are not both absent, then let error be yes.
					if (h || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes. Otherwise, let future-compat-h
					// be the result.
					if (intVal === 0) {pError = true;} else {h = intVal;}

				// Anything else, Let error be yes.
				} else {pError = true;}
			} // (close step 13 for loop)

			// 15. If error is still no, then append a new image source to candidates whose
			// URL is url, associated with a width width if not absent and a pixel
			// density density if not absent. Otherwise, there is a parse error.
			if (!pError) {
				candidate.url = url;

				if (w) { candidate.w = w;}
				if (d) { candidate.d = d;}
				if (h) { candidate.h = h;}
				if (!h && !d && !w) {candidate.d = 1;}
				if (candidate.d === 1) {set.has1x = true;}
				candidate.set = set;

				candidates.push(candidate);
			}
		} // (close parseDescriptors fn)

		/**
		* Tokenizes descriptor properties prior to parsing
		* Returns undefined.
		* (Again, this fn is defined before it is used, in order to pass JSHINT.
		* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
		*/
		function tokenize() {

			// 8.1. Descriptor tokeniser: Skip whitespace
			collectCharacters(regexLeadingSpaces);

			// 8.2. Let current descriptor be the empty string.
			currentDescriptor = "";

			// 8.3. Let state be in descriptor.
			state = "in descriptor";

			while (true) {

				// 8.4. Let c be the character at position.
				c = input.charAt(pos);

				//  Do the following depending on the value of state.
				//  For the purpose of this step, "EOF" is a special character representing
				//  that position is past the end of input.

				// In descriptor
				if (state === "in descriptor") {
					// Do the following, depending on the value of c:

				  // Space character
				  // If current descriptor is not empty, append current descriptor to
				  // descriptors and let current descriptor be the empty string.
				  // Set state to after descriptor.
					if (isSpace(c)) {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
							currentDescriptor = "";
							state = "after descriptor";
						}

					// U+002C COMMA (,)
					// Advance position to the next character in input. If current descriptor
					// is not empty, append current descriptor to descriptors. Jump to the step
					// labeled descriptor parser.
					} else if (c === ",") {
						pos += 1;
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// U+0028 LEFT PARENTHESIS (()
					// Append c to current descriptor. Set state to in parens.
					} else if (c === "\u0028") {
						currentDescriptor = currentDescriptor + c;
						state = "in parens";

					// EOF
					// If current descriptor is not empty, append current descriptor to
					// descriptors. Jump to the step labeled descriptor parser.
					} else if (c === "") {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}
				// (end "in descriptor"

				// In parens
				} else if (state === "in parens") {

					// U+0029 RIGHT PARENTHESIS ())
					// Append c to current descriptor. Set state to in descriptor.
					if (c === ")") {
						currentDescriptor = currentDescriptor + c;
						state = "in descriptor";

					// EOF
					// Append current descriptor to descriptors. Jump to the step labeled
					// descriptor parser.
					} else if (c === "") {
						descriptors.push(currentDescriptor);
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}

				// After descriptor
				} else if (state === "after descriptor") {

					// Do the following, depending on the value of c:
					// Space character: Stay in this state.
					if (isSpace(c)) {

					// EOF: Jump to the step labeled descriptor parser.
					} else if (c === "") {
						parseDescriptors();
						return;

					// Anything else
					// Set state to in descriptor. Set position to the previous character in input.
					} else {
						state = "in descriptor";
						pos -= 1;

					}
				}

				// Advance position to the next character in input.
				pos += 1;

			// Repeat this step.
			} // (close while true loop)
		}

		// 4. Splitting loop: Collect a sequence of characters that are space
		//    characters or U+002C COMMA characters. If any U+002C COMMA characters
		//    were collected, that is a parse error.
		while (true) {
			collectCharacters(regexLeadingCommasOrSpaces);

			// 5. If position is past the end of input, return candidates and abort these steps.
			if (pos >= inputLength) {
				return candidates; // (we're done, this is the sole return path)
			}

			// 6. Collect a sequence of characters that are not space characters,
			//    and let that be url.
			url = collectCharacters(regexLeadingNotSpaces);

			// 7. Let descriptors be a new empty list.
			descriptors = [];

			// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
			//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
			//         more than one character, that is a parse error.
			if (url.slice(-1) === ",") {
				url = url.replace(regexTrailingCommas, "");
				// (Jump ahead to step 9 to skip tokenization and just push the candidate).
				parseDescriptors();

			//	Otherwise, follow these substeps:
			} else {
				tokenize();
			} // (close else of step 8)

		// 16. Return to the step labeled splitting loop.
		} // (Close of big while loop.)
	}

	/*
	 * Sizes Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
	 *
	 * Reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 *
	 * Grammar is:
	 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
	 * <source-size> = <media-condition> <source-size-value>
	 * <source-size-value> = <length>
	 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
	 *
	 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
	 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
	 *
	 * Returns the first valid <css-length> with a media condition that evaluates to true,
	 * or "100vw" if all valid media conditions evaluate to false.
	 *
	 */

	function parseSizes(strValue) {

		// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
		// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
		// CSS allows a single optional plus or minus sign:
		// http://www.w3.org/TR/CSS2/syndata.html#numbers
		// CSS is ASCII case-insensitive:
		// http://www.w3.org/TR/CSS2/syndata.html#characters )
		// Spec allows exponential notation for <number> type:
		// http://dev.w3.org/csswg/css-values/#numbers
		var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;

		// (This is a quick and lenient test. Because of optional unlimited-depth internal
		// grouping parens and strict spacing rules, this could get very complicated.)
		var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

		var i;
		var unparsedSizesList;
		var unparsedSizesListLength;
		var unparsedSize;
		var lastComponentValue;
		var size;

		// UTILITY FUNCTIONS

		//  (Toy CSS parser. The goals here are:
		//  1) expansive test coverage without the weight of a full CSS parser.
		//  2) Avoiding regex wherever convenient.
		//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
		//  Returns an array of arrays.)
		function parseComponentValues(str) {
			var chrctr;
			var component = "";
			var componentArray = [];
			var listArray = [];
			var parenDepth = 0;
			var pos = 0;
			var inComment = false;

			function pushComponent() {
				if (component) {
					componentArray.push(component);
					component = "";
				}
			}

			function pushComponentArray() {
				if (componentArray[0]) {
					listArray.push(componentArray);
					componentArray = [];
				}
			}

			// (Loop forwards from the beginning of the string.)
			while (true) {
				chrctr = str.charAt(pos);

				if (chrctr === "") { // ( End of string reached.)
					pushComponent();
					pushComponentArray();
					return listArray;
				} else if (inComment) {
					if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
						inComment = false;
						pos += 2;
						pushComponent();
						continue;
					} else {
						pos += 1; // (Skip all characters inside comments.)
						continue;
					}
				} else if (isSpace(chrctr)) {
					// (If previous character in loop was also a space, or if
					// at the beginning of the string, do not add space char to
					// component.)
					if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
						pos += 1;
						continue;
					} else if (parenDepth === 0) {
						pushComponent();
						pos +=1;
						continue;
					} else {
						// (Replace any space character with a plain space for legibility.)
						chrctr = " ";
					}
				} else if (chrctr === "(") {
					parenDepth += 1;
				} else if (chrctr === ")") {
					parenDepth -= 1;
				} else if (chrctr === ",") {
					pushComponent();
					pushComponentArray();
					pos += 1;
					continue;
				} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
					inComment = true;
					pos += 2;
					continue;
				}

				component = component + chrctr;
				pos += 1;
			}
		}

		function isValidNonNegativeSourceSizeValue(s) {
			if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
			if (regexCssCalc.test(s)) {return true;}
			// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
			// "-0 is equivalent to 0 and is not a negative number." which means that
			// unitless zero and unitless negative zero must be accepted as special cases.)
			if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
			return false;
		}

		// When asked to parse a sizes attribute from an element, parse a
		// comma-separated list of component values from the value of the element's
		// sizes attribute (or the empty string, if the attribute is absent), and let
		// unparsed sizes list be the result.
		// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values

		unparsedSizesList = parseComponentValues(strValue);
		unparsedSizesListLength = unparsedSizesList.length;

		// For each unparsed size in unparsed sizes list:
		for (i = 0; i < unparsedSizesListLength; i++) {
			unparsedSize = unparsedSizesList[i];

			// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
			// ( parseComponentValues() already omits spaces outside of parens. )

			// If unparsed size is now empty, that is a parse error; continue to the next
			// iteration of this algorithm.
			// ( parseComponentValues() won't push an empty array. )

			// 2. If the last component value in unparsed size is a valid non-negative
			// <source-size-value>, let size be its value and remove the component value
			// from unparsed size. Any CSS function other than the calc() function is
			// invalid. Otherwise, there is a parse error; continue to the next iteration
			// of this algorithm.
			// http://dev.w3.org/csswg/css-syntax/#parse-component-value
			lastComponentValue = unparsedSize[unparsedSize.length - 1];

			if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
				size = lastComponentValue;
				unparsedSize.pop();
			} else {
				continue;
			}

			// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
			// size. If unparsed size is now empty, return size and exit this algorithm.
			// If this was not the last item in unparsed sizes list, that is a parse error.
			if (unparsedSize.length === 0) {
				return size;
			}

			// 4. Parse the remaining component values in unparsed size as a
			// <media-condition>. If it does not parse correctly, or it does parse
			// correctly but the <media-condition> evaluates to false, continue to the
			// next iteration of this algorithm.
			// (Parsing all possible compound media conditions in JS is heavy, complicated,
			// and the payoff is unclear. Is there ever an situation where the
			// media condition parses incorrectly but still somehow evaluates to true?
			// Can we just rely on the browser/polyfill to do it?)
			unparsedSize = unparsedSize.join(" ");
			if (!(pf.matchesMedia( unparsedSize ) ) ) {
				continue;
			}

			// 5. Return size and exit this algorithm.
			return size;
		}

		// If the above algorithm exhausts unparsed sizes list without returning a
		// size value, return 100vw.
		return "100vw";
	}

	// namespace
	pf.ns = ("pf" + new Date().getTime()).substr(0, 9);

	// srcset support test
	pf.supSrcset = "srcset" in image;
	pf.supSizes = "sizes" in image;
	pf.supPicture = !!window.HTMLPictureElement;

	// UC browser does claim to support srcset and picture, but not sizes,
	// this extended test reveals the browser does support nothing
	if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
		(function(image2) {
			image.srcset = "data:,a";
			image2.src = "data:,a";
			pf.supSrcset = image.complete === image2.complete;
			pf.supPicture = pf.supSrcset && pf.supPicture;
		})(document.createElement("img"));
	}

	// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
	if (pf.supSrcset && !pf.supSizes) {

		(function() {
			var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
			var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
			var img = document.createElement("img");
			var test = function() {
				var width = img.width;

				if (width === 2) {
					pf.supSizes = true;
				}

				alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;

				isSupportTestReady = true;
				// force async
				setTimeout(picturefill);
			};

			img.onload = test;
			img.onerror = test;
			img.setAttribute("sizes", "9px");

			img.srcset = width1 + " 1w," + width2 + " 9w";
			img.src = width1;
		})();

	} else {
		isSupportTestReady = true;
	}

	// using pf.qsa instead of dom traversing does scale much better,
	// especially on sites mixing responsive and non-responsive images
	pf.selShort = "picture>img,img[srcset]";
	pf.sel = pf.selShort;
	pf.cfg = cfg;

	/**
	 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
	 */
	pf.DPR = (DPR  || 1 );
	pf.u = units;

	// container of supported mime types that one might need to qualify before using
	pf.types =  types;

	pf.setSize = noop;

	/**
	 * Gets a string and returns the absolute URL
	 * @param src
	 * @returns {String} absolute URL
	 */

	pf.makeUrl = memoize(function(src) {
		anchor.href = src;
		return anchor.href;
	});

	/**
	 * Gets a DOM element or document and a selctor and returns the found matches
	 * Can be extended with jQuery/Sizzle for IE7 support
	 * @param context
	 * @param sel
	 * @returns {NodeList|Array}
	 */
	pf.qsa = function(context, sel) {
		return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
	};

	/**
	 * Shortcut method for matchMedia ( for easy overriding in tests )
	 * wether native or pf.mMQ is used will be decided lazy on first call
	 * @returns {boolean}
	 */
	pf.matchesMedia = function() {
		if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
			pf.matchesMedia = function( media ) {
				return !media || ( matchMedia( media ).matches );
			};
		} else {
			pf.matchesMedia = pf.mMQ;
		}

		return pf.matchesMedia.apply( this, arguments );
	};

	/**
	 * A simplified matchMedia implementation for IE8 and IE9
	 * handles only min-width/max-width with px or em values
	 * @param media
	 * @returns {boolean}
	 */
	pf.mMQ = function( media ) {
		return media ? evalCSS(media) : true;
	};

	/**
	 * Returns the calculated length in css pixel from the given sourceSizeValue
	 * http://dev.w3.org/csswg/css-values-3/#length-value
	 * intended Spec mismatches:
	 * * Does not check for invalid use of CSS functions
	 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
	 * @param sourceSizeValue
	 * @returns {Number}
	 */
	pf.calcLength = function( sourceSizeValue ) {

		var value = evalCSS(sourceSizeValue, true) || false;
		if (value < 0) {
			value = false;
		}

		return value;
	};

	/**
	 * Takes a type string and checks if its supported
	 */

	pf.supportsType = function( type ) {
		return ( type ) ? types[ type ] : true;
	};

	/**
	 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
	 * @param sourceSizeStr
	 * @returns {*}
	 */
	pf.parseSize = memoize(function( sourceSizeStr ) {
		var match = ( sourceSizeStr || "" ).match(regSize);
		return {
			media: match && match[1],
			length: match && match[2]
		};
	});

	pf.parseSet = function( set ) {
		if ( !set.cands ) {
			set.cands = parseSrcset(set.srcset, set);
		}
		return set.cands;
	};

	/**
	 * returns 1em in css px for html/body default size
	 * function taken from respondjs
	 * @returns {*|number}
	 */
	pf.getEmValue = function() {
		var body;
		if ( !eminpx && (body = document.body) ) {
			var div = document.createElement( "div" ),
				originalHTMLCSS = docElem.style.cssText,
				originalBodyCSS = body.style.cssText;

			div.style.cssText = baseStyle;

			// 1em in a media query is the value of the default font size of the browser
			// reset docElem and body to ensure the correct value is returned
			docElem.style.cssText = fsCss;
			body.style.cssText = fsCss;

			body.appendChild( div );
			eminpx = div.offsetWidth;
			body.removeChild( div );

			//also update eminpx before returning
			eminpx = parseFloat( eminpx, 10 );

			// restore the original values
			docElem.style.cssText = originalHTMLCSS;
			body.style.cssText = originalBodyCSS;

		}
		return eminpx || 16;
	};

	/**
	 * Takes a string of sizes and returns the width in pixels as a number
	 */
	pf.calcListLength = function( sourceSizeListStr ) {
		// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
		//
		//                           or (min-width:30em) calc(30% - 15px)
		if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
			var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );

			sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
		}

		return sizeLengthCache[ sourceSizeListStr ];
	};

	/**
	 * Takes a candidate object with a srcset property in the form of url/
	 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
	 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
	 *     "images/pic-small.png"
	 * Get an array of image candidates in the form of
	 *      {url: "/foo/bar.png", resolution: 1}
	 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
	 * If sizes is specified, res is calculated
	 */
	pf.setRes = function( set ) {
		var candidates;
		if ( set ) {

			candidates = pf.parseSet( set );

			for ( var i = 0, len = candidates.length; i < len; i++ ) {
				setResolution( candidates[ i ], set.sizes );
			}
		}
		return candidates;
	};

	pf.setRes.res = setResolution;

	pf.applySetCandidate = function( candidates, img ) {
		if ( !candidates.length ) {return;}
		var candidate,
			i,
			j,
			length,
			bestCandidate,
			curSrc,
			curCan,
			candidateSrc,
			abortCurSrc;

		var imageData = img[ pf.ns ];
		var dpr = pf.DPR;

		curSrc = imageData.curSrc || img[curSrcProp];

		curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);

		// if we have a current source, we might either become lazy or give this source some advantage
		if ( curCan && curCan.set === candidates[ 0 ].set ) {

			// if browser can abort image request and the image has a higher pixel density than needed
			// and this image isn't downloaded yet, we skip next part and try to save bandwidth
			abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);

			if ( !abortCurSrc ) {
				curCan.cached = true;

				// if current candidate is "best", "better" or "okay",
				// set it to bestCandidate
				if ( curCan.res >= dpr ) {
					bestCandidate = curCan;
				}
			}
		}

		if ( !bestCandidate ) {

			candidates.sort( ascendingSort );

			length = candidates.length;
			bestCandidate = candidates[ length - 1 ];

			for ( i = 0; i < length; i++ ) {
				candidate = candidates[ i ];
				if ( candidate.res >= dpr ) {
					j = i - 1;

					// we have found the perfect candidate,
					// but let's improve this a little bit with some assumptions ;-)
					if (candidates[ j ] &&
						(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
						chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {

						bestCandidate = candidates[ j ];

					} else {
						bestCandidate = candidate;
					}
					break;
				}
			}
		}

		if ( bestCandidate ) {

			candidateSrc = pf.makeUrl( bestCandidate.url );

			imageData.curSrc = candidateSrc;
			imageData.curCan = bestCandidate;

			if ( candidateSrc !== curSrc ) {
				pf.setSrc( img, bestCandidate );
			}
			pf.setSize( img );
		}
	};

	pf.setSrc = function( img, bestCandidate ) {
		var origWidth;
		img.src = bestCandidate.url;

		// although this is a specific Safari issue, we don't want to take too much different code paths
		if ( bestCandidate.set.type === "image/svg+xml" ) {
			origWidth = img.style.width;
			img.style.width = (img.offsetWidth + 1) + "px";

			// next line only should trigger a repaint
			// if... is only done to trick dead code removal
			if ( img.offsetWidth + 1 ) {
				img.style.width = origWidth;
			}
		}
	};

	pf.getSet = function( img ) {
		var i, set, supportsType;
		var match = false;
		var sets = img [ pf.ns ].sets;

		for ( i = 0; i < sets.length && !match; i++ ) {
			set = sets[i];

			if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
				continue;
			}

			if ( supportsType === "pending" ) {
				set = supportsType;
			}

			match = set;
			break;
		}

		return match;
	};

	pf.parseSets = function( element, parent, options ) {
		var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;

		var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
		var imageData = element[ pf.ns ];

		if ( imageData.src === undefined || options.src ) {
			imageData.src = getImgAttr.call( element, "src" );
			if ( imageData.src ) {
				setImgAttr.call( element, srcAttr, imageData.src );
			} else {
				removeImgAttr.call( element, srcAttr );
			}
		}

		if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
			srcsetAttribute = getImgAttr.call( element, "srcset" );
			imageData.srcset = srcsetAttribute;
			srcsetParsed = true;
		}

		imageData.sets = [];

		if ( hasPicture ) {
			imageData.pic = true;
			getAllSourceElements( parent, imageData.sets );
		}

		if ( imageData.srcset ) {
			imageSet = {
				srcset: imageData.srcset,
				sizes: getImgAttr.call( element, "sizes" )
			};

			imageData.sets.push( imageSet );

			isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");

			// add normal src as candidate, if source has no w descriptor
			if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
				imageSet.srcset += ", " + imageData.src;
				imageSet.cands.push({
					url: imageData.src,
					d: 1,
					set: imageSet
				});
			}

		} else if ( imageData.src ) {
			imageData.sets.push( {
				srcset: imageData.src,
				sizes: null
			} );
		}

		imageData.curCan = null;
		imageData.curSrc = undefined;

		// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
		// or has a w descriptor (and does not support sizes) set support to false to evaluate
		imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );

		if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
			if ( srcsetAttribute ) {
				setImgAttr.call( element, srcsetAttr, srcsetAttribute );
				element.srcset = "";
			} else {
				removeImgAttr.call( element, srcsetAttr );
			}
		}

		if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
			if (imageData.src === null) {
				element.removeAttribute("src");
			} else {
				element.src = imageData.src;
			}
		}

		imageData.parsed = true;
	};

	pf.fillImg = function(element, options) {
		var imageData;
		var extreme = options.reselect || options.reevaluate;

		// expando for caching data on the img
		if ( !element[ pf.ns ] ) {
			element[ pf.ns ] = {};
		}

		imageData = element[ pf.ns ];

		// if the element has already been evaluated, skip it
		// unless `options.reevaluate` is set to true ( this, for example,
		// is set to true when running `picturefill` on `resize` ).
		if ( !extreme && imageData.evaled === evalId ) {
			return;
		}

		if ( !imageData.parsed || options.reevaluate ) {
			pf.parseSets( element, element.parentNode, options );
		}

		if ( !imageData.supported ) {
			applyBestCandidate( element );
		} else {
			imageData.evaled = evalId;
		}
	};

	pf.setupRun = function() {
		if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
			updateMetrics();
		}
	};

	// If picture is supported, well, that's awesome.
	if ( pf.supPicture ) {
		picturefill = noop;
		pf.fillImg = noop;
	} else {

		 // Set up picture polyfill by polling the document
		(function() {
			var isDomReady;
			var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;

			var run = function() {
				var readyState = document.readyState || "";

				timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
				if ( document.body ) {
					pf.fillImgs();
					isDomReady = isDomReady || regReady.test(readyState);
					if ( isDomReady ) {
						clearTimeout( timerId );
					}

				}
			};

			var timerId = setTimeout(run, document.body ? 9 : 99);

			// Also attach picturefill on resize and readystatechange
			// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
			var debounce = function(func, wait) {
				var timeout, timestamp;
				var later = function() {
					var last = (new Date()) - timestamp;

					if (last < wait) {
						timeout = setTimeout(later, wait - last);
					} else {
						timeout = null;
						func();
					}
				};

				return function() {
					timestamp = new Date();

					if (!timeout) {
						timeout = setTimeout(later, wait);
					}
				};
			};
			var lastClientWidth = docElem.clientHeight;
			var onResize = function() {
				isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
				lastClientWidth = docElem.clientHeight;
				if ( isVwDirty ) {
					pf.fillImgs();
				}
			};

			on( window, "resize", debounce(onResize, 99 ) );
			on( document, "readystatechange", run );
		})();
	}

	pf.picturefill = picturefill;
	//use this internally for easy monkey patching/performance testing
	pf.fillImgs = picturefill;
	pf.teardownRun = noop;

	/* expose methods for testing */
	picturefill._ = pf;

	window.picturefillCFG = {
		pf: pf,
		push: function(args) {
			var name = args.shift();
			if (typeof pf[name] === "function") {
				pf[name].apply(pf, args);
			} else {
				cfg[name] = args[0];
				if (alreadyRun) {
					pf.fillImgs( { reselect: true } );
				}
			}
		}
	};

	while (setOptions && setOptions.length) {
		window.picturefillCFG.push(setOptions.shift());
	}

	/* expose picturefill */
	window.picturefill = picturefill;

	/* expose picturefill */
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// CommonJS, just export
		module.exports = picturefill;
	} else if ( typeof define === "function" && define.amd ) {
		// AMD support
		define( "picturefill", function() { return picturefill; } );
	}

	// IE8 evals this sync, so it must be the last thing we do
	if ( !pf.supPicture ) {
		types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
	}

} )( window, document );

},{}],153:[function(require,module,exports){
/* smoothscroll v0.4.0 - 2018 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;

      do {
        el = el.parentNode;

        isBody = el === d.body;
      } while (isBody === false && isScrollable(el) === false);

      isBody = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (typeof exports === 'object' && typeof module !== 'undefined') {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());

},{}],154:[function(require,module,exports){
/*!
 * @copyright Copyright (c) 2017 IcoMoon.io
 * @license   Licensed under MIT license
 *            See https://github.com/Keyamoon/svgxuse
 * @version   1.2.6
 */
/*jslint browser: true */
/*global XDomainRequest, MutationObserver, window */
(function () {
    "use strict";
    if (typeof window !== "undefined" && window.addEventListener) {
        var cache = Object.create(null); // holds xhr objects to prevent multiple requests
        var checkUseElems;
        var tid; // timeout id
        var debouncedCheck = function () {
            clearTimeout(tid);
            tid = setTimeout(checkUseElems, 100);
        };
        var unobserveChanges = function () {
            return;
        };
        var observeChanges = function () {
            var observer;
            window.addEventListener("resize", debouncedCheck, false);
            window.addEventListener("orientationchange", debouncedCheck, false);
            if (window.MutationObserver) {
                observer = new MutationObserver(debouncedCheck);
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                unobserveChanges = function () {
                    try {
                        observer.disconnect();
                        window.removeEventListener("resize", debouncedCheck, false);
                        window.removeEventListener("orientationchange", debouncedCheck, false);
                    } catch (ignore) {}
                };
            } else {
                document.documentElement.addEventListener("DOMSubtreeModified", debouncedCheck, false);
                unobserveChanges = function () {
                    document.documentElement.removeEventListener("DOMSubtreeModified", debouncedCheck, false);
                    window.removeEventListener("resize", debouncedCheck, false);
                    window.removeEventListener("orientationchange", debouncedCheck, false);
                };
            }
        };
        var createRequest = function (url) {
            // In IE 9, cross origin requests can only be sent using XDomainRequest.
            // XDomainRequest would fail if CORS headers are not set.
            // Therefore, XDomainRequest should only be used with cross origin requests.
            function getOrigin(loc) {
                var a;
                if (loc.protocol !== undefined) {
                    a = loc;
                } else {
                    a = document.createElement("a");
                    a.href = loc;
                }
                return a.protocol.replace(/:/g, "") + a.host;
            }
            var Request;
            var origin;
            var origin2;
            if (window.XMLHttpRequest) {
                Request = new XMLHttpRequest();
                origin = getOrigin(location);
                origin2 = getOrigin(url);
                if (Request.withCredentials === undefined && origin2 !== "" && origin2 !== origin) {
                    Request = XDomainRequest || undefined;
                } else {
                    Request = XMLHttpRequest;
                }
            }
            return Request;
        };
        var xlinkNS = "http://www.w3.org/1999/xlink";
        checkUseElems = function () {
            var base;
            var bcr;
            var fallback = ""; // optional fallback URL in case no base path to SVG file was given and no symbol definition was found.
            var hash;
            var href;
            var i;
            var inProgressCount = 0;
            var isHidden;
            var Request;
            var url;
            var uses;
            var xhr;
            function observeIfDone() {
                // If done with making changes, start watching for chagnes in DOM again
                inProgressCount -= 1;
                if (inProgressCount === 0) { // if all xhrs were resolved
                    unobserveChanges(); // make sure to remove old handlers
                    observeChanges(); // watch for changes to DOM
                }
            }
            function attrUpdateFunc(spec) {
                return function () {
                    if (cache[spec.base] !== true) {
                        spec.useEl.setAttributeNS(xlinkNS, "xlink:href", "#" + spec.hash);
                        if (spec.useEl.hasAttribute("href")) {
                            spec.useEl.setAttribute("href", "#" + spec.hash);
                        }
                    }
                };
            }
            function onloadFunc(xhr) {
                return function () {
                    var body = document.body;
                    var x = document.createElement("x");
                    var svg;
                    xhr.onload = null;
                    x.innerHTML = xhr.responseText;
                    svg = x.getElementsByTagName("svg")[0];
                    if (svg) {
                        svg.setAttribute("aria-hidden", "true");
                        svg.style.position = "absolute";
                        svg.style.width = 0;
                        svg.style.height = 0;
                        svg.style.overflow = "hidden";
                        body.insertBefore(svg, body.firstChild);
                    }
                    observeIfDone();
                };
            }
            function onErrorTimeout(xhr) {
                return function () {
                    xhr.onerror = null;
                    xhr.ontimeout = null;
                    observeIfDone();
                };
            }
            unobserveChanges(); // stop watching for changes to DOM
            // find all use elements
            uses = document.getElementsByTagName("use");
            for (i = 0; i < uses.length; i += 1) {
                try {
                    bcr = uses[i].getBoundingClientRect();
                } catch (ignore) {
                    // failed to get bounding rectangle of the use element
                    bcr = false;
                }
                href = uses[i].getAttribute("href")
                        || uses[i].getAttributeNS(xlinkNS, "href")
                        || uses[i].getAttribute("xlink:href");
                if (href && href.split) {
                    url = href.split("#");
                } else {
                    url = ["", ""];
                }
                base = url[0];
                hash = url[1];
                isHidden = bcr && bcr.left === 0 && bcr.right === 0 && bcr.top === 0 && bcr.bottom === 0;
                if (bcr && bcr.width === 0 && bcr.height === 0 && !isHidden) {
                    // the use element is empty
                    // if there is a reference to an external SVG, try to fetch it
                    // use the optional fallback URL if there is no reference to an external SVG
                    if (fallback && !base.length && hash && !document.getElementById(hash)) {
                        base = fallback;
                    }
                    if (uses[i].hasAttribute("href")) {
                        uses[i].setAttributeNS(xlinkNS, "xlink:href", href);
                    }
                    if (base.length) {
                        // schedule updating xlink:href
                        xhr = cache[base];
                        if (xhr !== true) {
                            // true signifies that prepending the SVG was not required
                            setTimeout(attrUpdateFunc({
                                useEl: uses[i],
                                base: base,
                                hash: hash
                            }), 0);
                        }
                        if (xhr === undefined) {
                            Request = createRequest(base);
                            if (Request !== undefined) {
                                xhr = new Request();
                                cache[base] = xhr;
                                xhr.onload = onloadFunc(xhr);
                                xhr.onerror = onErrorTimeout(xhr);
                                xhr.ontimeout = onErrorTimeout(xhr);
                                xhr.open("GET", base);
                                xhr.send();
                                inProgressCount += 1;
                            }
                        }
                    }
                } else {
                    if (!isHidden) {
                        if (cache[base] === undefined) {
                            // remember this URL if the use element was not empty and no request was sent
                            cache[base] = true;
                        } else if (cache[base].onload) {
                            // if it turns out that prepending the SVG is not necessary,
                            // abort the in-progress xhr.
                            cache[base].abort();
                            delete cache[base].onload;
                            cache[base] = true;
                        }
                    } else if (base.length && cache[base]) {
                        setTimeout(attrUpdateFunc({
                            useEl: uses[i],
                            base: base,
                            hash: hash
                        }), 0);
                    }
                }
            }
            uses = "";
            inProgressCount += 1;
            observeIfDone();
        };
        var winLoad;
        winLoad = function () {
            window.removeEventListener("load", winLoad, false); // to prevent memory leaks
            tid = setTimeout(checkUseElems, 0);
        };
        if (document.readyState !== "complete") {
            // The load event fires when all resources have finished loading, which allows detecting whether SVG use elements are empty.
            window.addEventListener("load", winLoad, false);
        } else {
            // No need to add a listener if the document is already loaded, initialize immediately.
            winLoad();
        }
    }
}());

},{}],155:[function(require,module,exports){
(function (global){
/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

(function(self) {
    'use strict';

    var nativeURLSearchParams = self.URLSearchParams ? self.URLSearchParams : null,
        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
        __URLSearchParams__ = "__URLSearchParams__",
        // Fix bug in Edge which cannot encode ' &' correctly
        encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
            var ampersandTest = new nativeURLSearchParams();
            ampersandTest.append('s', ' &');
            return ampersandTest.toString() === 's=+%26';
        })() : true,
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
        return;
    }


    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }
        this [__URLSearchParams__] = parseToDict(search);
    }


    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function(name, value) {
        appendTo(this [__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype.delete = function(name) {
        delete this [__URLSearchParams__] [name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict [name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function(name) {
        return name in this [__URLSearchParams__];
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this [__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };

    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy)
    /*
     * Apply polifill to global object and append other prototype into it
     */
    self.URLSearchParams = useProxy ?
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        new Proxy(nativeURLSearchParams, {
            construct: function(target, args) {
                return new target((new URLSearchParamsPolyfill(args[0]).toString()));
            }
        }) :
        URLSearchParamsPolyfill;


    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this.delete(keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i], values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };


    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }


    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }

    function decode(str) {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    }

    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {done: value === undefined, value: value};
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function() {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            for (var key in search) {
                if (search.hasOwnProperty(key)) {
                    appendTo(dict, key, search[key])
                }
            }

        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs [j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        var val = typeof value === 'string' ? value : (
            value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
        )

        if (name in dict) {
            dict[name].push(val);
        } else {
            dict[name] = [val];
        }
    }

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[61]);
